// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/files/minecraftia-regular-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/files/minecraftia-regular-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/files/minecraftia-regular-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/files/minecraftia-regular-webfont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("fonts/files/minecraftia-regular-webfont.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("fonts/files/Nunito-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("fonts/files/PixelifySans-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("fonts/files/webfont-icons.eot?v=4.5.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("fonts/files/webfont-icons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("fonts/files/webfont-icons.woff?v=4.5.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("fonts/files/webfont-icons.ttf?v=4.5.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("fonts/files/webfont-icons.svg?v=4.5.0", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#minecraftiaregular" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___, { hash: "?#iefix&v=4.5.0" });
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___, { hash: "#webfonticons" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset 'UTF-8';

/* stylelint-disable */

/* prettier-ignore */

/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css */

/**
 * 1. Change the default font family in all browsers (opinionated).
 * 2. Prevent adjustments of font size after orientation changes in IE and iOS.
 */

html {
  font-family: sans-serif; /* 1 */
  -ms-text-size-adjust: 100%; /* 2 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

/**
 * Remove the margin in all browsers (opinionated).
 */

body {
  margin: 0;
}

/* HTML5 display definitions
   ========================================================================== */

/**
 * Add the correct display in IE 9-.
 * 1. Add the correct display in Edge, IE, and Firefox.
 * 2. Add the correct display in IE.
 */

article,
aside,
details, /* 1 */
figcaption,
figure,
footer,
header,
main, /* 2 */
menu,
nav,
section,
summary {
  /* 1 */
  display: block;
}

/**
 * Add the correct display in IE 9-.
 */

audio,
canvas,
progress,
video {
  display: inline-block;
}

/**
 * Add the correct display in iOS 4-7.
 */

audio:not([controls]) {
  display: none;
  height: 0;
}

/**
 * Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */

progress {
  vertical-align: baseline;
}

/**
 * Add the correct display in IE 10-.
 * 1. Add the correct display in IE.
 */

template, /* 1 */
[hidden] {
  display: none;
}

/* Links
   ========================================================================== */

/**
 * 1. Remove the gray background on active links in IE 10.
 * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.
 */

a {
  background-color: transparent; /* 1 */
  -webkit-text-decoration-skip: objects; /* 2 */
}

/**
 * Remove the outline on focused links when they are also active or hovered
 * in all browsers (opinionated).
 */

a:active,
a:hover {
  outline-width: 0;
}

/* Text-level semantics
   ========================================================================== */

/**
 * 1. Remove the bottom border in Firefox 39-.
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */

abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted; /* 2 */
}

/**
 * Prevent the duplicate application of \`bolder\` by the next rule in Safari 6.
 */

b,
strong {
  font-weight: inherit;
}

/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */

b,
strong {
  font-weight: bolder;
}

/**
 * Add the correct font style in Android 4.3-.
 */

dfn {
  font-style: italic;
}

/**
 * Correct the font size and margin on \`h1\` elements within \`section\` and
 * \`article\` contexts in Chrome, Firefox, and Safari.
 */

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/**
 * Add the correct background and color in IE 9-.
 */

mark {
  background-color: #ff0;
  color: #000;
}

/**
 * Add the correct font size in all browsers.
 */

small {
  font-size: 80%;
}

/**
 * Prevent \`sub\` and \`sup\` elements from affecting the line height in
 * all browsers.
 */

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
   ========================================================================== */

/**
 * Remove the border on images inside links in IE 10-.
 */

img {
  border-style: none;
}

/**
 * Hide the overflow in IE.
 */

svg:not(:root) {
  overflow: hidden;
}

/* Grouping content
   ========================================================================== */

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */

code,
kbd,
pre,
samp {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/**
 * Add the correct margin in IE 8.
 */

figure {
  margin: 1em 40px;
}

/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */

hr {
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}

/* Forms
   ========================================================================== */

/**
 * 1. Change font properties to \`inherit\` in all browsers (opinionated).
 * 2. Remove the margin in Firefox and Safari.
 */

button,
input,
optgroup,
select,
textarea {
  font: inherit; /* 1 */
  margin: 0; /* 2 */
}

/**
 * Restore the font weight unset by the previous rule.
 */

optgroup {
  font-weight: bold;
}

/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */

button,
input {
  /* 1 */
  overflow: visible;
}

/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */

button,
select {
  /* 1 */
  text-transform: none;
}

/**
 * 1. Prevent a WebKit bug where (2) destroys native \`audio\` and \`video\`
 *    controls in Android 4.
 * 2. Correct the inability to style clickable types in iOS and Safari.
 */

button,
html [type="button"], /* 1 */
[type="reset"],
[type="submit"] {
  -webkit-appearance: button; /* 2 */
}

/**
 * Remove the inner border and padding in Firefox.
 */

button::-moz-focus-inner,
[type='button']::-moz-focus-inner,
[type='reset']::-moz-focus-inner,
[type='submit']::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
 * Restore the focus styles unset by the previous rule.
 */

button:-moz-focusring,
[type='button']:-moz-focusring,
[type='reset']:-moz-focusring,
[type='submit']:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
 * Change the border, margin, and padding in all browsers (opinionated).
 */

fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}

/**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from \`fieldset\` elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    \`fieldset\` elements in all browsers.
 */

legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}

/**
 * Remove the default vertical scrollbar in IE.
 */

textarea {
  overflow: auto;
}

/**
 * 1. Add the correct box sizing in IE 10-.
 * 2. Remove the padding in IE 10-.
 */

[type='checkbox'],
[type='radio'] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */

[type='number']::-webkit-inner-spin-button,
[type='number']::-webkit-outer-spin-button {
  height: auto;
}

/**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/**
 * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.
 */

[type='search']::-webkit-search-cancel-button,
[type='search']::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * Correct the text style of placeholders in Chrome, Edge, and Safari.
 */

::-webkit-input-placeholder {
  color: inherit;
  opacity: 0.54;
}

/**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to \`inherit\` in Safari.
 */

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

@font-face {
  font-family: 'minecraftiaregular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
      format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___})
      format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face{
  font-family: 'Nunito';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
}

@font-face{
  font-family: 'pixelify';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
}

@font-face {
  font-family: 'WebFontIcons';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___})
      format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('svg');
  font-weight: normal;
  font-style: normal;
}

/* define a new type 'icon' */

.icon-help {
  display: inline-block;
  font: normal normal normal 14px/1 WebFontIcons;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-help::before {
      content: '\\73'
  }

/* Button colors */

/**
 * Tooltip
 */

[data-tooltip] {
  position: relative;
  cursor: pointer;
  text-align: center;
}

[data-tooltip]::before,
[data-tooltip]::after {
  position: absolute;
  opacity: 0;
  transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out,
    transform 0.2s cubic-bezier(0.71, 1.7, 0.77, 1.24);
  transform: translate3d(0, 0, 0);
  pointer-events: none;
  bottom: 100%;
  left: 50%;
}

[data-tooltip]::before {
  z-index: 1001;
  border: 6px solid transparent;
  background: transparent;
  content: '';
  margin-left: -6px;
  margin-bottom: -12px;
  border-top-color: black;
  border-top-color: #4caf50;
}

[data-tooltip]::after {
  z-index: 1000;
  padding: 8px;
  width: 160px;
  background-color: black;
  background-color: #4caf50;
  color: white;
  content: attr(data-tooltip);
  font-size: 14px;
  line-height: 1.2;
  font-weight: normal;
  margin-left: -80px;
}

[data-tooltip]:hover::before,
[data-tooltip]:hover::after,
[data-tooltip]:focus::before,
[data-tooltip]:focus::after {
  visibility: visible;
  opacity: 1;
  transform: translateY(-12px);
}

html {
  box-sizing: border-box;
  background-color: #515151;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

html,
body {
  position: relative;
  font-family: 'Nunito', 'Helvetica Neue Light', 'Helvetica Neue', 'Helvetica',
  'Arial', sans-serif;
  /* font-weight: 700; */
}

.main-header{
  font-family: 'pixelify', 'Helvetica Neue Light', 'Helvetica Neue',
  'Helvetica', 'Arial', sans-serif;
  font-size: 1.5em;
}

.main-title{
  font-family: 'pixelify', 'Helvetica Neue Light', 'Helvetica Neue',
  'Helvetica', 'Arial', sans-serif;
  font-size: 4em!important;
  font-weight: 400!important;
}

body {
  overflow: auto;
  /* no background color */
  background-color: transparent;
}

.app-container {
  height: 100%;
  width: 90%;
  margin: 0 auto;
  padding: 0;
}

p{
  font-size: 1.2em;
}

h1 {
  font-size: 2em;
}

/* h2 {
  font-size: 0.8em;
  padding-right: 1em;
  display: inline;
  position: relative;
  top: -0.9em;
} */

h3 {
  font-size: 1em;
}

.block {
  display: block;
}

.hidden {
  display: none;
}

.text-center {
  text-align: center;
}

.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.flex {
  display: flex;
}

.flex-wrap {
  flex-wrap: wrap;
}

.flex-col {
  flex-direction: column;
}

.flex-row {
  flex-direction: row;
}

.clearfix:before {
  content: '';
  display: table;
}

.clearfix:after {
  content: '';
  display: table;
  clear: both;
}

.col-1-3 {
  width: calc(99.9% * 1/3 - (30px - 30px * 1/3));
}

.col-1-3:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.col-1-3:last-child {
  margin-right: 0;
}

.col-1-3:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.col-1-3:nth-child(3n + 1) {
  clear: both;
}

.col-2-3 {
  width: calc(99.9% * 2/3 - (30px - 30px * 2/3));
}

.col-2-3:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.col-2-3:last-child {
  margin-right: 0;
}

.col-2-3:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.col-2-3:nth-child(3n + 1) {
  clear: both;
}

.col-1-2 {
  width: calc(99.9% * 1/2 - (30px - 30px * 1/2));
}

.col-1-2:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.col-1-2:last-child {
  margin-right: 0;
}

.col-1-2:nth-child(2n) {
  margin-right: 0;
  float: right;
}

.col-1-2:nth-child(2n + 1) {
  clear: both;
}

.col-1-4 {
  width: calc(99.9% * 1/4 - (30px - 30px * 1/4));
}

.col-1-4:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.col-1-4:last-child {
  margin-right: 0;
}

.col-1-4:nth-child(4n) {
  margin-right: 0;
  float: right;
}

.col-1-4:nth-child(4n + 1) {
  clear: both;
}

.col-2-4 {
  width: calc(99.9% * 2/4 - (30px - 30px * 2/4));
}

.col-2-4:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.col-2-4:last-child {
  margin-right: 0;
}

.col-2-4:nth-child(4n) {
  margin-right: 0;
  float: right;
}

.col-2-4:nth-child(4n + 1) {
  clear: both;
}

.col-3-4,
.col-6-8 {
  width: calc(99.9% * 3/4 - (30px - 30px * 3/4));
}

.col-3-4:nth-child(1n),
.col-6-8:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.col-3-4:last-child,
.col-6-8:last-child {
  margin-right: 0;
}

.col-3-4:nth-child(4n),
.col-6-8:nth-child(4n) {
  margin-right: 0;
  float: right;
}

.col-3-4:nth-child(4n + 1),
.col-6-8:nth-child(4n + 1) {
  clear: both;
}

.col-1-8 {
  width: calc(99.9% * 1/8 - (30px - 30px * 1/8));
}

.col-1-8:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.col-1-8:last-child {
  margin-right: 0;
}

.col-1-8:nth-child(8n) {
  margin-right: 0;
  float: right;
}

.col-1-8:nth-child(8n + 1) {
  clear: both;
}

.col-7-8 {
  width: calc(99.9% * 7/8 - (30px - 30px * 7/8));
}

.col-7-8:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.col-7-8:last-child {
  margin-right: 0;
}

.col-7-8:nth-child(8n) {
  margin-right: 0;
  float: right;
}

.col-7-8:nth-child(8n + 1) {
  clear: both;
}

.grid-3:before {
  content: '';
  display: table
}

.grid-3:after {
  content: '';
  display: table;
  clear: both
}

.grid-3 > div {
    width: calc(99.9% * 1/3);
  }

.grid-3 > div:nth-child(1n) {
    float: left;
    margin-right: 0;
    clear: none;
  }

.grid-3 > div:last-child {
    margin-right: 0;
  }

.grid-3 > div:nth-child(3n) {
    margin-right: 0;
    float: right;
  }

.grid-3 > div:nth-child(3n + 1) {
    clear: both;
  }

.grid-4:before {
  content: '';
  display: table
}

.grid-4:after {
  content: '';
  display: table;
  clear: both
}

.grid-4 > div {
    width: calc(99.9% * 1/4);
  }

.grid-4 > div:nth-child(1n) {
    float: left;
    margin-right: 0;
    clear: none;
  }

.grid-4 > div:last-child {
    margin-right: 0;
  }

.grid-4 > div:nth-child(4n) {
    margin-right: 0;
    float: right;
  }

.grid-4 > div:nth-child(4n + 1) {
    clear: both;
  }

.grid-2:before {
  content: '';
  display: table
}

.grid-2:after {
  content: '';
  display: table;
  clear: both
}

.grid-2 > div {
    width: calc(99.9% * 1/2);
  }

.grid-2 > div:nth-child(1n) {
    float: left;
    margin-right: 0;
    clear: none;
  }

.grid-2 > div:last-child {
    margin-right: 0;
  }

.grid-2 > div:nth-child(2n) {
    margin-right: 0;
    float: right;
  }

.grid-2 > div:nth-child(2n + 1) {
    clear: both;
  }

.max-width-container {
  max-width: 20em;
}

.max-width-container-centered {
  max-width: 20em;
  margin: 0 auto;
}

header {
  color: #bbb;
  margin: 1em 0;
}

header:before {
  content: '';
  display: table;
}

header:after {
  content: '';
  display: table;
  clear: both;
}

header a {
    text-decoration: none;
    color: inherit
  }

header a:visited,
    header a:hover,
    header a:active {
      color: inherit;
    }

header h1 {
    margin: 0;
  }

header .header__social {
    text-align: right;
  }

header .header__social .header__credits {
      font-size: 12px;
      margin-bottom: 0.2em;
    }

header .header__social .header__credits a {
        color: #bbb;
      }

header .header__social .header__credits span {
        color: #b17e7e;
      }

header .header__social .header__credits h2 {
        display: block;
        font-size: 0.8em;
        padding-right: 1.3em;
        position: relative;
        margin: 0;
        top: 0;
      }

header .header__social .header__credits:hover img {
          transform: scale(1.2);
        }

@media only screen and (max-width: 460px) {
    header .col-2-3,
    header .col-1-3 {
      width: calc(99.9% * 1/2 - (30px - 30px * 1/2));
    }
    header .col-2-3:nth-child(1n),
    header .col-1-3:nth-child(1n) {
      float: left;
      margin-right: 30px;
      clear: none;
    }
    header .col-2-3:last-child,
    header .col-1-3:last-child {
      margin-right: 0;
    }
    header .col-2-3:nth-child(2n),
    header .col-1-3:nth-child(2n) {
      margin-right: 0;
      float: right;
    }
    header .col-2-3:nth-child(2n + 1),
    header .col-1-3:nth-child(2n + 1) {
      clear: both;
    }
  h1 {
    font-size: 1.5em;
  }
}

@media only screen and (max-width: 1250px) {
  .app__left-side,
  .app__right-side {
    width: 100% !important;
  }

  .app__central-container{
    padding: 2em 1em !important;
  }
}

@media only screen and (max-width: 780px) {
    .dimensions label {
      font-size: 1.5em !important;
      top: -0.2em;
    }

  .app__central-container{
    padding: 2em 0em !important;
  }
}

@media only screen and (min-width: 730px) {
  /*
    Fix small vertical scrollbar glitch for some resolutions
    inside frames-handler
    Detected in Chrome
  */
  .app__frames-container::-webkit-scrollbar,
  .app__frames-container div::-webkit-scrollbar {
    width: 1em !important;
  }
}

@media only screen and (max-width: 730px) {
  .app__main, #app .app__central-container {
    padding: 1em 0.5em!important;
  }

  .app__copycss-button {
    margin-top: 1.4em !important;
  }

  .app__mobile--container .app__mobile--group {
    width: 100%!important;
  }

  .max-width-container-centered {
    max-width: 100% !important;
  }
      .app__central-container .col-1-4.left {
        width: auto;
      }
      .app__central-container .col-1-4.left:last-child {
        float: none;
        clear: none;
        margin-right: 0;
        width: auto;
      }
      .app__central-container .col-1-4.left:nth-child(1n) {
        float: none;
        clear: none;
        margin-right: 0;
        width: auto;
      }
      .app__central-container .col-1-4.left:nth-child(1n + 1) {
        float: none;
        clear: none;
        margin-right: 0;
        width: auto;
      }

        .app__central-container .col-1-4.left .app__copycss-button {
          padding: 4px !important;
        }

        .app__central-container .col-1-4.left .palette-grid {
          margin: 0;
        }

      .app__central-container .col-1-4.right {
        width: auto;
      }

      .app__central-container .col-1-4.right:last-child {
        float: none;
        clear: none;
        margin-right: 0;
        width: auto;
      }

      .app__central-container .col-1-4.right:nth-child(1n) {
        float: none;
        clear: none;
        margin-right: 0;
        width: auto;
      }

      .app__central-container .col-1-4.right:nth-child(1n + 1) {
        float: none;
        clear: none;
        margin-right: 0;
        width: auto;
      }

    .app__central-container .col-2-4 {
      margin-right: 2em!important;
      margin-left: 2em!important
    }
      .app__central-container .col-2-4.center {
        width: auto;
      }
      .app__central-container .col-2-4.center:last-child {
        float: none;
        clear: none;
        margin-right: 0;
        width: auto;
      }
      .app__central-container .col-2-4.center:nth-child(1n) {
        float: none;
        clear: none;
        margin-right: 0;
        width: auto;
      }
      .app__central-container .col-2-4.center:nth-child(1n + 1) {
        float: none;
        clear: none;
        margin-right: 0;
        width: auto;
      }

        .app__central-container .col-2-4.center .grid-container {
          margin: 1em auto !important;
          width: 100%;
        }

  .app__mobile--container:before {
    content: '';
    display: table;
  }

  .app__mobile--container:after {
    content: '';
    display: table;
    clear: both;
  }

    .app__mobile--container .app__mobile--group {
      width: calc(99.9% * 1/2 - (30px - 30px * 1/2));
    }

    .app__mobile--container .app__mobile--group:nth-child(1n) {
      float: left;
      margin-right: 30px;
      clear: none;
    }

    .app__mobile--container .app__mobile--group:last-child {
      margin-right: 0;
    }

    .app__mobile--container .app__mobile--group:nth-child(2n) {
      margin-right: 0;
      float: right;
    }

    .app__mobile--container .app__mobile--group:nth-child(2n + 1) {
      clear: both;
    }

    .app__mobile--container{

    max-width: none;
  }

  .app__preview-button {
    margin-top: 1em !important;
  }

  body {
    width: 100% !important;
  }

  /* Avoid button hover effect in mobile devices
  .undo-redo,
  .app__load-save-container,
  .new-project,
  .frames-handler,
  .app__right-side {
    button:hover,
    button.selected {
      background-color: \$color-mineShaft !important;
    }
  } */

  .app__load-save-container{
    margin-bottom: 5em !important;
  }

  .undo-redo {
    margin-top: 1em !important;
  }
    .undo-redo button {
      padding:20px !important;
    }

  .app__tools-wrapper {
    margin-top: 2em !important;
    margin-bottom: 2em !important;
  }

  .app__social-container {
    margin-bottom: 0.5em !important;
  }

  .dimensions{
    margin-top: 2em !important;
  }

  .color-cost-info{
    margin-top:1em !important;
  }

  .grid-3 > div {
    width: calc(94% * 1/3);
  }

  .color-picker{
    height: 5.8em !important;
  }
    button.app__copycss-button:hover,
    button.app__copycss-button.selected {
      background-color: #e0e0e0 !important;
    }
    .app__toggle-help-button:hover,
    .app__toggle-help-button.selected {
      background-color: #164075 !important;
    }

  .load-drawing__import {
    height: 10em !important;
  }

  .sidebar{
    width: 100% !important;
  }

  .sidebar__button{
    width: 100% !important;
  }

  .sidebar__button__palette{
    width: 100% !important;
  }
    .edit-this-design h2{
      margin:0 10px;
      font-size: 1.2rem;
    }

  .sizing-modal-layout{
    flex-direction: column !important;
    flex-direction: column-reverse !important;
  }

  .sizing-modal-sidebar{
    flex-direction: row !important;
    overflow-x: auto !important;
    padding-bottom: 0 !important;
    margin-right: 0 !important;
  }

  .sizing-modal-sidebar-img{
    margin-right: 10px !important;
  }

  .sizing-modal-desc{
    margin-bottom: 0 !important;
  }

  .sizing-modal-content{
    max-height: 75% !important;
  }

  .home-splash-padding{
    padding-top:120px!important;
  }

  .main-title{
    font-size: 3rem !important;
  }

  .main-paragraph{
    font-size: 1.2rem !important;
  }

  .footer-links{
    /* flex so that it is a row but can wrap */
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: wrap !important;
  }
    .footer-links a{
      font-size: 1rem !important;
    }
    .footer span{
      font-size: 0.8rem !important;
    }
}

/* 
@media only screen and (max-width: 360px) {
  button,
  .dimensions {
    font-size: 0.8em !important;
  }

  .app__central-container{
    margin: 2em 0em !important;
  }
} */

/* input[type='text'],
input[type='number'] {
  @mixin inputText;
} */

/* input[type='number'] {
  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
} */

.cookies-disclaimer {
  padding: 2em;
  text-align: left;
  color: #bbb;
  width: 50%;
  margin: 0 auto;
}

.cookies-disclaimer h2 {
    font-size: 2.5em;
    top: 0;
    margin: 1em 0 1.5em 0;
    display: block;
    text-align: center;
    padding: 0;
  }

.cookies-disclaimer h3 {
    font-size: 1.5em;
  }

.cookies-disclaimer a {
    text-decoration: none;
    color: #78b4ff;
  }

.cookies-disclaimer li {
    list-style-type: none;
  }

.cookies-disclaimer ul li:before {
    content: '•';
    font-size: 100%;
    padding-right: 10px;
  }

.cookies-disclaimer .art-wrapper {
    height: 100px;
    width: 100px;
    margin: 1em auto;
  }

.cookies-disclaimer .pixelart-cookie {
    box-shadow: 40px 10px 0 #ac7d40, 50px 10px 0 #ac7d40, 60px 10px 0 #332413,
      70px 10px 0 #eea64b, 30px 20px 0 #ac7d40, 40px 20px 0 #eea64b,
      50px 20px 0 #eea64b, 60px 20px 0 #eea64b, 70px 20px 0 #eea64b,
      80px 20px 0 #ac7d40, 20px 30px 0 #ac7d40, 30px 30px 0 #332413,
      40px 30px 0 #eea64b, 50px 30px 0 #eea64b, 60px 30px 0 #eea64b,
      70px 30px 0 #332413, 80px 30px 0 #332413, 90px 30px 0 #eea64b,
      20px 40px 0 #eea64b, 30px 40px 0 #eea64b, 40px 40px 0 #eea64b,
      50px 40px 0 #332413, 60px 40px 0 #eea64b, 70px 40px 0 #332413,
      80px 40px 0 #332413, 90px 40px 0 #eea64b, 10px 50px 0 #ac7d40,
      20px 50px 0 #332413, 30px 50px 0 #eea64b, 40px 50px 0 #eea64b,
      50px 50px 0 #eea64b, 60px 50px 0 #eea64b, 70px 50px 0 #eea64b,
      80px 50px 0 #eea64b, 90px 50px 0 #eea64b, 100px 50px 0 #ac7d40,
      10px 60px 0 #ac7d40, 20px 60px 0 #eea64b, 30px 60px 0 #eea64b,
      40px 60px 0 #332413, 50px 60px 0 #eea64b, 60px 60px 0 #eea64b,
      70px 60px 0 #eea64b, 80px 60px 0 #eea64b, 90px 60px 0 #332413,
      100px 60px 0 #ac7d40, 10px 70px 0 #9a4719, 20px 70px 0 #332413,
      30px 70px 0 #eea64b, 40px 70px 0 #eea64b, 50px 70px 0 #eea64b,
      60px 70px 0 #332413, 70px 70px 0 #eea64b, 80px 70px 0 #dc9736,
      90px 70px 0 #dc9736, 100px 70px 0 #9a4719, 20px 80px 0 #9a4719,
      30px 80px 0 #dc9736, 40px 80px 0 #dc9736, 50px 80px 0 #dc9736,
      60px 80px 0 #dc9736, 70px 80px 0 #dc9736, 80px 80px 0 #dc9736,
      90px 80px 0 #9a4719, 30px 90px 0 #9a4719, 40px 90px 0 #dc9736,
      50px 90px 0 #dc9736, 60px 90px 0 #dc9736, 70px 90px 0 #332413,
      80px 90px 0 #9a4719, 40px 100px 0 #9a4719, 50px 100px 0 #9a4719,
      60px 100px 0 #9a4719, 70px 100px 0 #9a4719;
    -webkit-box-shadow: 40px 10px 0 #ac7d40, 50px 10px 0 #ac7d40,
      60px 10px 0 #332413, 70px 10px 0 #eea64b, 30px 20px 0 #ac7d40,
      40px 20px 0 #eea64b, 50px 20px 0 #eea64b, 60px 20px 0 #eea64b,
      70px 20px 0 #eea64b, 80px 20px 0 #ac7d40, 20px 30px 0 #ac7d40,
      30px 30px 0 #332413, 40px 30px 0 #eea64b, 50px 30px 0 #eea64b,
      60px 30px 0 #eea64b, 70px 30px 0 #332413, 80px 30px 0 #332413,
      90px 30px 0 #eea64b, 20px 40px 0 #eea64b, 30px 40px 0 #eea64b,
      40px 40px 0 #eea64b, 50px 40px 0 #332413, 60px 40px 0 #eea64b,
      70px 40px 0 #332413, 80px 40px 0 #332413, 90px 40px 0 #eea64b,
      10px 50px 0 #ac7d40, 20px 50px 0 #332413, 30px 50px 0 #eea64b,
      40px 50px 0 #eea64b, 50px 50px 0 #eea64b, 60px 50px 0 #eea64b,
      70px 50px 0 #eea64b, 80px 50px 0 #eea64b, 90px 50px 0 #eea64b,
      100px 50px 0 #ac7d40, 10px 60px 0 #ac7d40, 20px 60px 0 #eea64b,
      30px 60px 0 #eea64b, 40px 60px 0 #332413, 50px 60px 0 #eea64b,
      60px 60px 0 #eea64b, 70px 60px 0 #eea64b, 80px 60px 0 #eea64b,
      90px 60px 0 #332413, 100px 60px 0 #ac7d40, 10px 70px 0 #9a4719,
      20px 70px 0 #332413, 30px 70px 0 #eea64b, 40px 70px 0 #eea64b,
      50px 70px 0 #eea64b, 60px 70px 0 #332413, 70px 70px 0 #eea64b,
      80px 70px 0 #dc9736, 90px 70px 0 #dc9736, 100px 70px 0 #9a4719,
      20px 80px 0 #9a4719, 30px 80px 0 #dc9736, 40px 80px 0 #dc9736,
      50px 80px 0 #dc9736, 60px 80px 0 #dc9736, 70px 80px 0 #dc9736,
      80px 80px 0 #dc9736, 90px 80px 0 #9a4719, 30px 90px 0 #9a4719,
      40px 90px 0 #dc9736, 50px 90px 0 #dc9736, 60px 90px 0 #dc9736,
      70px 90px 0 #332413, 80px 90px 0 #9a4719, 40px 100px 0 #9a4719,
      50px 100px 0 #9a4719, 60px 100px 0 #9a4719, 70px 100px 0 #9a4719;
    -moz-box-shadow: 40px 10px 0 #ac7d40, 50px 10px 0 #ac7d40,
      60px 10px 0 #332413, 70px 10px 0 #eea64b, 30px 20px 0 #ac7d40,
      40px 20px 0 #eea64b, 50px 20px 0 #eea64b, 60px 20px 0 #eea64b,
      70px 20px 0 #eea64b, 80px 20px 0 #ac7d40, 20px 30px 0 #ac7d40,
      30px 30px 0 #332413, 40px 30px 0 #eea64b, 50px 30px 0 #eea64b,
      60px 30px 0 #eea64b, 70px 30px 0 #332413, 80px 30px 0 #332413,
      90px 30px 0 #eea64b, 20px 40px 0 #eea64b, 30px 40px 0 #eea64b,
      40px 40px 0 #eea64b, 50px 40px 0 #332413, 60px 40px 0 #eea64b,
      70px 40px 0 #332413, 80px 40px 0 #332413, 90px 40px 0 #eea64b,
      10px 50px 0 #ac7d40, 20px 50px 0 #332413, 30px 50px 0 #eea64b,
      40px 50px 0 #eea64b, 50px 50px 0 #eea64b, 60px 50px 0 #eea64b,
      70px 50px 0 #eea64b, 80px 50px 0 #eea64b, 90px 50px 0 #eea64b,
      100px 50px 0 #ac7d40, 10px 60px 0 #ac7d40, 20px 60px 0 #eea64b,
      30px 60px 0 #eea64b, 40px 60px 0 #332413, 50px 60px 0 #eea64b,
      60px 60px 0 #eea64b, 70px 60px 0 #eea64b, 80px 60px 0 #eea64b,
      90px 60px 0 #332413, 100px 60px 0 #ac7d40, 10px 70px 0 #9a4719,
      20px 70px 0 #332413, 30px 70px 0 #eea64b, 40px 70px 0 #eea64b,
      50px 70px 0 #eea64b, 60px 70px 0 #332413, 70px 70px 0 #eea64b,
      80px 70px 0 #dc9736, 90px 70px 0 #dc9736, 100px 70px 0 #9a4719,
      20px 80px 0 #9a4719, 30px 80px 0 #dc9736, 40px 80px 0 #dc9736,
      50px 80px 0 #dc9736, 60px 80px 0 #dc9736, 70px 80px 0 #dc9736,
      80px 80px 0 #dc9736, 90px 80px 0 #9a4719, 30px 90px 0 #9a4719,
      40px 90px 0 #dc9736, 50px 90px 0 #dc9736, 60px 90px 0 #dc9736,
      70px 90px 0 #332413, 80px 90px 0 #9a4719, 40px 100px 0 #9a4719,
      50px 100px 0 #9a4719, 60px 100px 0 #9a4719, 70px 100px 0 #9a4719;
    height: 10px;
    width: 10px;
  }

.cookies-disclaimer span.highlight {
    color: #b17e7e;
  }

@media only screen and (max-width: 1200px) {
  .cookies-disclaimer {
    width: 80%;
  }
}

@media only screen and (max-width: 700px) {
  .cookies-disclaimer {
    width: 90%;
  }
}

.not-found {
  text-align: center;
}

.not-found h2 {
    font-size: 2.5em;
    top: 0;
    margin: 1em 0 1em 0;
    display: block;
    text-align: center;
    padding: 0;
    color: #b17e7e;
  }

.not-found a {
    color: #78b4ff;
  }

.not-found .art-wrapper {
    height: 100px;
    width: 320px;
    margin: 1em auto 9em;
  }

.not-found .pixelart-notfound {
    position: absolute;
    animation: notfound 1s infinite;
    -webkit-animation: notfound 1s infinite;
    -moz-animation: notfound 1s infinite;
    -o-animation: notfound 1s infinite;
  }

@keyframes notfound {
  0%,
  25% {
    box-shadow: 20px 40px 0 0 rgba(187, 187, 187, 1),
      80px 40px 0 0 rgba(187, 187, 187, 1),
      140px 40px 0 0 rgba(187, 187, 187, 1),
      160px 40px 0 0 rgba(187, 187, 187, 1),
      220px 40px 0 0 rgba(187, 187, 187, 1),
      280px 40px 0 0 rgba(187, 187, 187, 1),
      20px 60px 0 0 rgba(187, 187, 187, 1), 80px 60px 0 0 rgba(187, 187, 187, 1),
      120px 60px 0 0 rgba(187, 187, 187, 1),
      180px 60px 0 0 rgba(187, 187, 187, 1),
      220px 60px 0 0 rgba(187, 187, 187, 1),
      280px 60px 0 0 rgba(187, 187, 187, 1),
      20px 80px 0 0 rgba(187, 187, 187, 1), 40px 80px 0 0 rgba(187, 187, 187, 1),
      60px 80px 0 0 rgba(187, 187, 187, 1), 80px 80px 0 0 rgba(187, 187, 187, 1),
      120px 80px 0 0 rgba(187, 187, 187, 1),
      180px 80px 0 0 rgba(187, 187, 187, 1),
      220px 80px 0 0 rgba(187, 187, 187, 1),
      240px 80px 0 0 rgba(187, 187, 187, 1),
      260px 80px 0 0 rgba(187, 187, 187, 1),
      280px 80px 0 0 rgba(187, 187, 187, 1),
      80px 100px 0 0 rgba(187, 187, 187, 1),
      120px 100px 0 0 rgba(187, 187, 187, 1),
      180px 100px 0 0 rgba(187, 187, 187, 1),
      280px 100px 0 0 rgba(187, 187, 187, 1),
      80px 120px 0 0 rgba(187, 187, 187, 1),
      140px 120px 0 0 rgba(187, 187, 187, 1),
      160px 120px 0 0 rgba(187, 187, 187, 1),
      280px 120px 0 0 rgba(187, 187, 187, 1);
    height: 20px;
    width: 20px;
  }
  25.01%,
  50% {
    box-shadow: 20px 20px 0 0 rgba(187, 187, 187, 1),
      80px 20px 0 0 rgba(187, 187, 187, 1), 20px 40px 0 0 rgba(187, 187, 187, 1),
      80px 40px 0 0 rgba(187, 187, 187, 1),
      140px 40px 0 0 rgba(187, 187, 187, 1),
      160px 40px 0 0 rgba(187, 187, 187, 1),
      220px 40px 0 0 rgba(187, 187, 187, 1),
      280px 40px 0 0 rgba(187, 187, 187, 1),
      20px 60px 0 0 rgba(187, 187, 187, 1), 40px 60px 0 0 rgba(187, 187, 187, 1),
      60px 60px 0 0 rgba(187, 187, 187, 1), 80px 60px 0 0 rgba(187, 187, 187, 1),
      120px 60px 0 0 rgba(187, 187, 187, 1),
      180px 60px 0 0 rgba(187, 187, 187, 1),
      220px 60px 0 0 rgba(187, 187, 187, 1),
      280px 60px 0 0 rgba(187, 187, 187, 1),
      80px 80px 0 0 rgba(187, 187, 187, 1),
      120px 80px 0 0 rgba(187, 187, 187, 1),
      180px 80px 0 0 rgba(187, 187, 187, 1),
      220px 80px 0 0 rgba(187, 187, 187, 1),
      240px 80px 0 0 rgba(187, 187, 187, 1),
      260px 80px 0 0 rgba(187, 187, 187, 1),
      280px 80px 0 0 rgba(187, 187, 187, 1),
      80px 100px 0 0 rgba(187, 187, 187, 1),
      120px 100px 0 0 rgba(187, 187, 187, 1),
      180px 100px 0 0 rgba(187, 187, 187, 1),
      280px 100px 0 0 rgba(187, 187, 187, 1),
      140px 120px 0 0 rgba(187, 187, 187, 1),
      160px 120px 0 0 rgba(187, 187, 187, 1),
      280px 120px 0 0 rgba(187, 187, 187, 1);
    height: 20px;
    width: 20px;
  }
  50.01%,
  75% {
    box-shadow: 140px 20px 0 0 rgba(187, 187, 187, 1),
      160px 20px 0 0 rgba(187, 187, 187, 1),
      20px 40px 0 0 rgba(187, 187, 187, 1), 80px 40px 0 0 rgba(187, 187, 187, 1),
      120px 40px 0 0 rgba(187, 187, 187, 1),
      180px 40px 0 0 rgba(187, 187, 187, 1),
      220px 40px 0 0 rgba(187, 187, 187, 1),
      280px 40px 0 0 rgba(187, 187, 187, 1),
      20px 60px 0 0 rgba(187, 187, 187, 1), 80px 60px 0 0 rgba(187, 187, 187, 1),
      120px 60px 0 0 rgba(187, 187, 187, 1),
      180px 60px 0 0 rgba(187, 187, 187, 1),
      220px 60px 0 0 rgba(187, 187, 187, 1),
      280px 60px 0 0 rgba(187, 187, 187, 1),
      20px 80px 0 0 rgba(187, 187, 187, 1), 40px 80px 0 0 rgba(187, 187, 187, 1),
      60px 80px 0 0 rgba(187, 187, 187, 1), 80px 80px 0 0 rgba(187, 187, 187, 1),
      120px 80px 0 0 rgba(187, 187, 187, 1),
      180px 80px 0 0 rgba(187, 187, 187, 1),
      220px 80px 0 0 rgba(187, 187, 187, 1),
      240px 80px 0 0 rgba(187, 187, 187, 1),
      260px 80px 0 0 rgba(187, 187, 187, 1),
      280px 80px 0 0 rgba(187, 187, 187, 1),
      80px 100px 0 0 rgba(187, 187, 187, 1),
      140px 100px 0 0 rgba(187, 187, 187, 1),
      160px 100px 0 0 rgba(187, 187, 187, 1),
      280px 100px 0 0 rgba(187, 187, 187, 1),
      80px 120px 0 0 rgba(187, 187, 187, 1),
      280px 120px 0 0 rgba(187, 187, 187, 1);
    height: 20px;
    width: 20px;
  }
  75.01%,
  100% {
    box-shadow: 220px 20px 0 0 rgba(187, 187, 187, 1),
      280px 20px 0 0 rgba(187, 187, 187, 1),
      20px 40px 0 0 rgba(187, 187, 187, 1), 80px 40px 0 0 rgba(187, 187, 187, 1),
      140px 40px 0 0 rgba(187, 187, 187, 1),
      160px 40px 0 0 rgba(187, 187, 187, 1),
      220px 40px 0 0 rgba(187, 187, 187, 1),
      280px 40px 0 0 rgba(187, 187, 187, 1),
      20px 60px 0 0 rgba(187, 187, 187, 1), 80px 60px 0 0 rgba(187, 187, 187, 1),
      120px 60px 0 0 rgba(187, 187, 187, 1),
      180px 60px 0 0 rgba(187, 187, 187, 1),
      220px 60px 0 0 rgba(187, 187, 187, 1),
      240px 60px 0 0 rgba(187, 187, 187, 1),
      260px 60px 0 0 rgba(187, 187, 187, 1),
      280px 60px 0 0 rgba(187, 187, 187, 1),
      20px 80px 0 0 rgba(187, 187, 187, 1), 40px 80px 0 0 rgba(187, 187, 187, 1),
      60px 80px 0 0 rgba(187, 187, 187, 1), 80px 80px 0 0 rgba(187, 187, 187, 1),
      120px 80px 0 0 rgba(187, 187, 187, 1),
      180px 80px 0 0 rgba(187, 187, 187, 1),
      280px 80px 0 0 rgba(187, 187, 187, 1),
      80px 100px 0 0 rgba(187, 187, 187, 1),
      120px 100px 0 0 rgba(187, 187, 187, 1),
      180px 100px 0 0 rgba(187, 187, 187, 1),
      280px 100px 0 0 rgba(187, 187, 187, 1),
      80px 120px 0 0 rgba(187, 187, 187, 1),
      140px 120px 0 0 rgba(187, 187, 187, 1),
      160px 120px 0 0 rgba(187, 187, 187, 1);
    height: 20px;
    width: 20px;
  }
}

.active-palette-selected{
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #4b4949!important;
    background-color: #141414!important;
    box-shadow: 0 0 0 2px #bbb!important;
    color: #fff!important;
    
}

.active-palette-selected svg{
        fill: #fff!important;
    }

.active-palette-buttons-disabled{
    pointer-events: none;
    opacity: 0.5;
}

.delete-active-palette {
    width: 40px;
    /* margin-top: 20px;
    
    margin-top: 0!important;
    margin-bottom: 0.8em!important; */
    
  
    background: none;
    border: none;
    outline: none;
    border-radius: 2px;
    font-size: 1em;
    text-decoration: none;
    transition-duration: 0.1s;
    color: #bbb;
    background-color: #313131;
    box-shadow: 0 5px 0 0 #707070;
    height: 40px;
    padding: 0px!important;

    /* display: flex;
    align-items: center;
    
    justify-content: center; */
  }

.delete-active-palette div{
        display: flex;
        justify-content: center;
        height: 100%;
        width: 100%;
        align-items: center;
    }

.delete-active-palette:active{
        transform: translate(0, 5px);
        box-shadow: 0 1px 0 #4b4949;
        background-color: #4b4949;
    }

.delete-active-palette:hover{
        background-color: #413f3f;
    }

.delete-active-palette svg{
        height: 20px;
        width: 20px;
        fill: #bbb;
        padding: 0px!important;
    }

.eyedropper-active-palette {
    width: 40px;
    display: table;
    margin-top: 20px;
    margin-top: 0!important;
    margin-bottom: 0.8em!important;
    margin-right: 0.5em!important;
  display: inline-block;
  font: normal normal normal 14px/1 WebFontIcons;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale

  }

.eyedropper-active-palette::before {
      content: '\\6f'
  }

.eyedropper-active-palette {
  
    background: none;
    border: none;
    outline: none;
    border-radius: 2px;
    padding: 12px;
    font-size: 1em;
    text-decoration: none;
    transition-duration: 0.1s;
    color: #bbb;
    background-color: #313131;
    box-shadow: 0 5px 0 0 #707070

  }

.eyedropper-active-palette:active{
        transform: translate(0, 5px);
        box-shadow: 0 1px 0 #4b4949;
        background-color: #4b4949;
    }

.eyedropper-active-palette:hover{
        background-color: #413f3f;
    }

.border-color-picker input{
        width: 36px;
        height: 36px;
    }

.grid-container {
  line-height: 0;
  min-height: 1px;
  margin: 0 auto;
  width: 90%;
  border: 1px solid #272727;
  border-width: 1px 0 0 1px;
}

.grid-container:before {
  content: '';
  display: table;
}

.grid-container:after {
  content: '';
  display: table;
  clear: both;
}

.grid-container div {
    float: left;
    border: 1px solid #272727;
    border-width: 0 1px 1px 0;
  }

.grid-container.cell {
    cursor: cell;
  }

.grid-container.context-menu {
    cursor: context-menu;
  }

.grid-container.copy {
    cursor: copy;
  }

.grid-container.all-scroll {
    cursor: all-scroll;
  }

.simple-notification {
  background-color: #313131;
  color: #bbb;
  width: 250px;
  text-align: center;
  padding: 1em;
  position: fixed;
  z-index: 1;
  left: 50%;
  margin-left: -125px;
  top: 1em;
  border: 1px solid orange;
}

/* ReactCSSTransitionGroup related rules */

.simple-notification-enter {
  opacity: 0.01;
}

.simple-notification-enter.simple-notification-enter-active {
  opacity: 1;
  transition: opacity 1000ms ease-in;
}

.simple-notification-exit {
  opacity: 1;
}

.simple-notification-exit.simple-notification-exit-active {
  opacity: 0.01;
  transition: opacity 1000ms ease-out;
}

.simple-spinner {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.4;
  top: 0;
  display: none
}

.simple-spinner.display {
    display: block;
  }

.simple-spinner .circle {
    height: 60px;
    width: 60px;
    margin: 94px auto 0;
    position: fixed;
    animation: spin-rotation 0.6s infinite linear;
    border-left: 6px solid rgba(119, 239, 50, 0.726);
    border-right: 6px solid rgba(28, 121, 228, 0.733);
    border-bottom: 6px solid rgba(226, 26, 42, 0.664);
    border-top: 6px solid rgba(219, 109, 26, 1);
    border-radius: 100%;
    top: 50%;
    left: 50%;
    margin-top: -30px;
    margin-left: -30px;
  }

@keyframes spin-rotation {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(359deg);
  }
}

.simple-spinner-card {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.4;
  top: 0;
  display: none
}

.simple-spinner-card.display {
    display: block;
  }

.simple-spinner-card .circle {
    height: 60px;
    width: 60px;
    margin: 94px auto 0;
    position: absolute;
    animation: spin-rotation 0.6s infinite linear;
    border-left: 6px solid rgba(119, 239, 50, 0.726);
    border-right: 6px solid rgba(28, 121, 228, 0.733);
    border-bottom: 6px solid rgba(226, 26, 42, 0.664);
    border-top: 6px solid rgba(219, 109, 26, 1);
    border-radius: 100%;
    top: 50%;
    left: 50%;
    margin-top: -30px;
    margin-left: -30px;
  }

.load-drawing {
  text-align: center;
}

.load-drawing h2 {
    padding: 2em 0 0;
    margin-bottom: 0;
    font-size: 1.2em;
    text-align: center;

    display: flex;
    flex-direction: column;
    overflow: auto;
    min-width: auto;
  }

.load-drawing .load-drawing__container {
    overflow: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    text-align: center
  }

.load-drawing .load-drawing__container.empty {
      overflow-y: hidden;
      display: block;
    }

.load-drawing .load-drawing__container .load-drawing__drawing {
      position: relative;
      border: 3px solid black;
      cursor: pointer;
      flex: 0 1 auto;
      margin: 0.5em;
      padding-right: 2em;
    }

.load-drawing .load-drawing__container .load-drawing__drawing .drawing__delete {
  display: inline-block;
  font: normal normal normal 14px/1 WebFontIcons;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
      }

.load-drawing .load-drawing__container .load-drawing__drawing .drawing__delete::before {
      content: '\\74'
  }

.load-drawing .load-drawing__container .load-drawing__drawing .drawing__delete {

        position: absolute;
        font-size: 1.7em;
        color: white;
        top: 0;
        right: 0;
        cursor: no-drop;
        padding: 0.1em;
        background-color: #313131;
        border: 2px solid black;
        border-width: 0 0 2px 2px;
      }

.load-drawing .load-drawing__container .load-drawing__drawing .preview {
        margin: 0 auto;
      }

.load-drawing .load-drawing__export {
    overflow-x: scroll;
    width: 100%;
    margin: 0 auto;
    background-color: #313131;
    color: #bbb;
    padding: 0.5em;
    text-align: left;
  }

.load-drawing .load-drawing__import {
    font-family: 'monospace';
    display: block;
    width: 90%;
    resize: none;
    height: 6em;
    margin: 0 auto;
    padding: 0.5em;
    background-color: #313131;
    color: #bbb;
  }

.load-drawing .import__button {
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #961818;
  box-shadow: 0 5px 0 0 #6b1010;
  }

.load-drawing .import__button:hover,
  .load-drawing .import__button.selected {
    background-color: #741515;
  }

.load-drawing .import__button:hover {
    cursor: pointer;
  }

.load-drawing .import__button:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #741515;
    background-color: #741515;
  }

.load-drawing .import__button {

    margin: 1.5em auto;
    display: table;
  }

.import-your-own-container{
  max-width: 500px;
  margin:0 auto;
  text-align: center;
  padding: 0 20px;
}

.close-import-file-container{
  margin-top: 20px;
  margin-left: 40px;
  text-align: left;
}

.close-import-file{
  padding-left:20px!important;
  padding-right:20px!important;
}

.canvas-preview{
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0,0,0,0.5);
  border: 3px solid #252525;
}

.import-button{
  padding-top:6px!important;
  padding-bottom:8px!important;
  padding-left:10px!important;
  padding-right:10px!important;
}

.import-button span{
    font-size:1.2rem!important;
    padding: 0 10px!important;
  }

.import-button{
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #f5f5f5;
  background-color: #349338;
  box-shadow: 0 5px 0 0 #2b752b;
}

.import-button:hover,
  .import-button.selected {
    background-color: #2e6a2e;
  }

.import-button:hover {
    cursor: pointer;
  }

.import-button:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #2e6a2e;
    background-color: #2e6a2e;
  }

.palette-select{
  max-width: 400px;
  margin:auto;
}

.palette-select label{
    display: block;
    text-align: center;
    margin: 0px;
    font-size: 1.1rem;
    top: 0px;
    color: whitesmoke;
  }

/* animation that slides in from right */

.slide-in-right{
  animation: slide-in-right 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s 1 normal forwards;
}

@keyframes slide-in-right {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}

.sidebar{
  background-color: rgb(89, 89, 89);
  border-bottom-color: rgb(49, 49, 49);
  border-bottom-style: solid;
  border-bottom-width: 0px;
  border-left-color: rgb(49, 49, 49);
  border-left-style: solid;
  border-left-width: 1px;
  border-right-color: rgb(49, 49, 49);
  border-right-style: solid;
  border-right-width: 0px;
  border-top-color: rgb(49, 49, 49);
  border-top-style: solid;
  border-top-width: 0px;
  box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.1) 0px 4px 6px -4px;
  box-sizing: border-box;
  color: rgb(249, 249, 251);
  display: flex;
  flex-direction: column;
  height: 100vh;
  line-height: 24px;
  overflow-y: scroll;
  padding-bottom: 24px;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 24px;
  position: fixed;
  right: 0px;
  -moz-tab-size: 4;
    -o-tab-size: 4;
       tab-size: 4;
  -webkit-text-size-adjust: 100%;
     -moz-text-size-adjust: 100%;
          text-size-adjust: 100%;
  top: 0px;
  transform: matrix(1, 0, 0, 1, 0, 0);
  transition-duration: 0.2s;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  width: auto;
  z-index: 50;
}

.sidebar__button{
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #313131;
  box-shadow: 0 5px 0 0 #707070;
}

.sidebar__button:hover,
  .sidebar__button.selected {
    background-color: #4b4949;
  }

.sidebar__button:hover {
    cursor: pointer;
  }

.sidebar__button:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #4b4949;
    background-color: #4b4949;
  }

.sidebar__button{
  width: 14rem;
}

.sidebar__button__palette{
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #313131;
  box-shadow: 0 5px 0 0 #707070;
}

.sidebar__button__palette:hover,
  .sidebar__button__palette.selected {
    background-color: #4b4949;
  }

.sidebar__button__palette:hover {
    cursor: pointer;
  }

.sidebar__button__palette:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #4b4949;
    background-color: #4b4949;
  }

.sidebar__button__palette{
  width: 14rem;
  margin-top: 1.5rem;
  border-radius: 10px!important;
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
  overflow: hidden;
}

.color-div{
  height:30px;
  /* flex all colors within the row evenly */
  flex: 1 1 auto;
}

.palette-select__button{
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #313131;
  box-shadow: 0 5px 0 0 #707070
}

.palette-select__button:hover,
  .palette-select__button.selected {
    background-color: #4b4949;
  }

.palette-select__button:hover {
    cursor: pointer;
  }

.palette-select__button:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #4b4949;
    background-color: #4b4949;
  }

.palette-select__button{

  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  padding-top:6px!important;
  padding-bottom:8px!important;
  padding-left:10px!important;
  padding-right:10px!important;
}

.palette-select__button span{
    font-size:1.2rem!important;
    padding: 0 10px!important;
  }

.palette-select__button--disabled{
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #313131;
  box-shadow: 0 5px 0 0 #707070
}

.palette-select__button--disabled:hover,
  .palette-select__button--disabled.selected {
    background-color: #4b4949;
  }

.palette-select__button--disabled:hover {
    cursor: pointer;
  }

.palette-select__button--disabled:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #4b4949;
    background-color: #4b4949;
  }

.palette-select__button--disabled{

  padding-top:6px!important;
  padding-bottom:8px!important;
  padding-left:10px!important;
  padding-right:10px!important;
}

.palette-select__button--disabled span{
    font-size:1.2rem!important;
    padding: 0 10px!important;
  }

.palette-select__button--disabled{
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}

.palette-select__button--disabled:hover{
    background-color: #313131!important;
    cursor: not-allowed;
    pointer-events: none;
  }

.palette-select__radio{
  cursor: pointer;
}

.palette-select__radio input{
    cursor: pointer;
    margin-right: 5px;
  }

.palette-select__radio label{
    cursor: pointer;
  }

.selected-palette{
  max-width: 400px;
  margin:auto;
  padding-top: 0.5rem;
}

.save-drawing button {
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #313131;
  box-shadow: 0 5px 0 0 #707070;
  }

.save-drawing button:hover,
  .save-drawing button.selected {
    background-color: #4b4949;
  }

.save-drawing button:hover {
    cursor: pointer;
  }

.save-drawing button:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #4b4949;
    background-color: #4b4949;
  }

.save-drawing button {

    width: 100%;
  }

.new-project button {
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #313131;
  box-shadow: 0 5px 0 0 #707070;
  }

.new-project button:hover,
  .new-project button.selected {
    background-color: #4b4949;
  }

.new-project button:hover {
    cursor: pointer;
  }

.new-project button:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #4b4949;
    background-color: #4b4949;
  }

.new-project button {

    width: 100%;
    padding: 0.5em;
    margin-bottom: 0.6em;
  }

.undo-redo:before {
  content: '';
  display: table;
}

.undo-redo:after {
  content: '';
  display: table;
  clear: both;
}

.undo-redo button {
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #313131;
  box-shadow: 0 5px 0 0 #707070;
  }

.undo-redo button:hover,
  .undo-redo button.selected {
    background-color: #4b4949;
  }

.undo-redo button:hover {
    cursor: pointer;
  }

.undo-redo button:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #4b4949;
    background-color: #4b4949;
  }

.undo-redo button {

    width: calc(99.9% * 1/2 - (0.5em - 0.5em * 1/2));
    font-size: 1.2em;
  }

.undo-redo button:nth-child(1n) {

    float: left;

    margin-right: 0.5em;

    clear: none;
  }

.undo-redo button:last-child {

    margin-right: 0;
  }

.undo-redo button:nth-child(0n) {

    float: right;
  }

.undo-redo .undo-redo__icon--undo {
  display: inline-block;
  font: normal normal normal 14px/1 WebFontIcons;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  }

.undo-redo .undo-redo__icon--undo::before {
      content: '\\70'
  }

.undo-redo .undo-redo__icon--undo {

    display: block;
  }

.undo-redo .undo-redo__icon--redo {
  display: inline-block;
  font: normal normal normal 14px/1 WebFontIcons;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  }

.undo-redo .undo-redo__icon--redo::before {
      content: '\\71'
  }

.undo-redo .undo-redo__icon--redo {

    display: block;
  }

#app .app__main-container:before,
  #app .app__central-container:before {
    content: '';
    display: table;
  }

#app .app__main-container:after,
  #app .app__central-container:after {
    content: '';
    display: table;
    clear: both;
  }

#app .app__background {
    /* background-color: \$color-scorpion; */
  background-image: radial-gradient(#434343 2px, transparent 2px),radial-gradient(#515151 2px, transparent 2px);
  background-color: #515151;
  background-position: 0 0,50px 50px;
  background-size: 20px 20px;
  background-repeat: repeat;
  min-height: 95vh;
  }

#app .app__main,
  #app .app__central-container {
    padding: 2em 3em;
  }

#app .app__frames-container {
    margin-bottom: 1em;
  }

#app .app__frames-container[data-tooltip]::after {
    width: 80%;
    margin-left: -40%;
  }

#app .app__load-save-container {
    margin-bottom: 2em;
  }

#app .app__load-save-container .app__load-button {
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #313131;
  box-shadow: 0 5px 0 0 #707070;
    }

#app .app__load-save-container .app__load-button:hover,
  #app .app__load-save-container .app__load-button.selected {
    background-color: #4b4949;
  }

#app .app__load-save-container .app__load-button:hover {
    cursor: pointer;
  }

#app .app__load-save-container .app__load-button:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #4b4949;
    background-color: #4b4949;
  }

#app .app__load-save-container:before{

    content: '';

    display: table;
}

#app .app__load-save-container:after{

    content: '';

    display: table;

    clear: both;
}

#app .app__load-save-container > div,
    #app .app__load-save-container > button {
      width: calc(99.9% * 995/2000 - (0.5em - 0.5em * 995/2000));
    }

#app .app__load-save-container > div:nth-child(1n),
    #app .app__load-save-container > button:nth-child(1n) {
      float: left;
      margin-right: 0.5em;
      clear: none;
    }

#app .app__load-save-container > div:last-child,
    #app .app__load-save-container > button:last-child {
      margin-right: 0;
    }

#app .app__load-save-container > div:nth-child(0n),
    #app .app__load-save-container > button:nth-child(0n) {
      float: right;
    }

#app .app__social-container .app__tour-button {
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #164075;
  box-shadow: 0 5px 0 0 #2f5382;
    }

#app .app__social-container .app__tour-button:hover,
  #app .app__social-container .app__tour-button.selected {
    background-color: #253c5a;
  }

#app .app__social-container .app__tour-button:hover {
    cursor: pointer;
  }

#app .app__social-container .app__tour-button:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #253c5a;
    background-color: #253c5a;
  }

#app .app__social-container .app__tour-button {

      width: 100%;
      /* margin-top: 1em; */
    }

#app .app__social-container .app__download-button {
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #803c3c;
  box-shadow: 0 5px 0 0 #733939;
    }

#app .app__social-container .app__download-button:hover,
  #app .app__social-container .app__download-button.selected {
    background-color: #552a2a;
  }

#app .app__social-container .app__download-button:hover {
    cursor: pointer;
  }

#app .app__social-container .app__download-button:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #552a2a;
    background-color: #552a2a;
  }

#app .app__social-container .app__download-button {
      /* @include icon(download); */

      width: 100%;
      /* margin-top: 1em; */
    }

#app .app__help-container {
    margin: 1em 0;
  }

#app .app__help-container:before {
    content: '';
    display: table;
  }

#app .app__help-container:after {
    content: '';
    display: table;
    clear: both;
  }

#app .app__help-container > div {
      width: calc(99.9% * 1/2 - (0.5em - 0.5em * 1/2));
    }

#app .app__help-container > div:nth-child(1n) {
      float: left;
      margin-right: 0.5em;
      clear: none;
    }

#app .app__help-container > div:last-child {
      margin-right: 0;
    }

#app .app__help-container > div:nth-child(0n) {
      float: right;
    }

#app .app__help-container .app__toggle-help-button {
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #164075;
  box-shadow: 0 5px 0 0 #2f5382;
    }

#app .app__help-container .app__toggle-help-button:hover,
  #app .app__help-container .app__toggle-help-button.selected {
    background-color: #253c5a;
  }

#app .app__help-container .app__toggle-help-button:hover {
    cursor: pointer;
  }

#app .app__help-container .app__toggle-help-button:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #253c5a;
    background-color: #253c5a;
  }

#app .app__help-container .app__toggle-help-button {
  display: inline-block;
  font: normal normal normal 14px/1 WebFontIcons;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
    }

#app .app__help-container .app__toggle-help-button::before {
      content: '\\73'
  }

#app .app__help-container .app__toggle-help-button.selected {
        box-shadow: 0 0 0 2px #bbb;
      }

#app .app__help-container .app__toggle-help-button {

      width: 100%;
    }

#app .app__help-container .app__shortcuts-button {
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #164075;
  box-shadow: 0 5px 0 0 #2f5382;
    }

#app .app__help-container .app__shortcuts-button:hover,
  #app .app__help-container .app__shortcuts-button.selected {
    background-color: #253c5a;
  }

#app .app__help-container .app__shortcuts-button:hover {
    cursor: pointer;
  }

#app .app__help-container .app__shortcuts-button:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #253c5a;
    background-color: #253c5a;
  }

#app .app__help-container .app__shortcuts-button {
  display: inline-block;
  font: normal normal normal 14px/1 WebFontIcons;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
    }

#app .app__help-container .app__shortcuts-button::before {
      content: '\\62'
  }

#app .app__help-container .app__shortcuts-button {

      width: 100%;
    }

#app .app__copycss-button {
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: black;
  background-color: #e0e0e0;
  box-shadow: 0 5px 0 0 #a0a0a0;
  }

#app .app__copycss-button:hover,
  #app .app__copycss-button.selected {
    background-color: #b7b7b7;
  }

#app .app__copycss-button:hover {
    cursor: pointer;
  }

#app .app__copycss-button:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #b7b7b7;
    background-color: #b7b7b7;
  }

#app .app__copycss-button {

    width: 100%;
    margin-top: 1em;
    font-weight: bold !important;
    color: #313131;
  }

#app .app__preview-button {
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #313131;
  box-shadow: 0 5px 0 0 #707070;
  }

#app .app__preview-button:hover,
  #app .app__preview-button.selected {
    background-color: #4b4949;
  }

#app .app__preview-button:hover {
    cursor: pointer;
  }

#app .app__preview-button:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #4b4949;
    background-color: #4b4949;
  }

#app .app__preview-button {

    width: 100%;
    margin: 0 0 0.6em;
    display: table;
  }

#app .app__tools-wrapper {
    text-align: center;
    margin: 1em 0 0.6em;
  }

#app .app__tools-wrapper > div button {
        font-size: 1.8em;
        text-align: center;
        color: #313131;
        padding: 0.4em 0;
        width: 100%;
        border: none;
        background-color: transparent;
        transition: background-color 0.1s ease-in-out
      }

#app .app__tools-wrapper > div button:focus {
          outline: 0;
        }

#app .app__tools-wrapper > div button:hover {
          background-color: #616161;
        }

#app .app__tools-wrapper > div button.selected {
          color: #bbb;
          background-color: #313131
        }

#app .app__tools-wrapper > div button.selected > div {
            background-color: #313131;
          }

#app .app__left-side,
  #app .app__right-side {
    width: 80%;
  }

#app .app__right-side {
    margin-left: auto;
    margin-right: 0;
  }

.mobile-button{

  border: 2px solid #2d2d2d !important;
  margin: 1% !important;
  
}

.mobile-button button{
    padding:30px !important;
  }

.mobile-button-no-border{
  border: none !important;
  margin: 1% !important;
}

.mobile-button-no-border button{
    padding:30px !important;
  }

.reset {
  width: 100%;
  margin: 0.5em auto;
  display: table;
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #313131;
  box-shadow: 0 5px 0 0 #707070;
}

.reset:hover,
  .reset.selected {
    background-color: #4b4949;
  }

.reset:hover {
    cursor: pointer;
  }

.reset:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #4b4949;
    background-color: #4b4949;
  }

.radio-selector {
  border: none;
  text-align: center;
  margin: 0 auto;
}

.radio-selector label span {
      padding: 0.6em 1em;
      border: 1px solid #585858;
      transition: all 0.3s;
    }

.radio-selector label input {
      display: none
    }

.radio-selector label input:checked + span {
        color: white;
        background-color: black;
      }

.radio-selector label input:not(:checked) + span:hover {
          box-shadow: 0 0 0 2px #585858 inset;
        }

.radio-selector label{

    margin: 0 0.5em;
}

.palette-grid {
  text-align: center;
  margin: 0.5em 0;
}

.palette-grid:before {
  content: '';
  display: table;
}

.palette-grid:after {
  content: '';
  display: table;
  clear: both;
}

.active-palette-grid{
  border: 3px solid #757575;
  background-color: #4b4949;
  text-align: center;
  margin: 0.5em 0;
  padding:10px;
}

.active-palette-grid:before{
  content: '';
  display: table;
}

.active-palette-grid:after{
  content: '';
  display: table;
  clear: both;
}

.active-palette-grid p{
    color: #bbbbbb;
    padding-bottom: 0;
    margin-bottom: 0;
  }

.active-palette{
  display: inline-block;
  width: 100%;
}

.border-checkbox{
  margin-top: 10px;
  margin-left: 10px;
  margin-right: 10px;

}

.border-checkbox input{
    cursor: pointer;
  }

.border-checkbox label{
    cursor: pointer;
    color: #bbbbbb;
    font-size: 1.1rem;
    padding-left: 5px;
    /* do not allow text selection */
    -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */ /* Konqueror HTML */
         -moz-user-select: none; /* Firefox */ /* Internet Explorer/Edge */
              user-select: none; /* Non-prefixed version, currently
                                    supported by Chrome and Opera */
  }

.border-color-select{
  cursor: pointer;
}

.border-color-mode{
  padding-bottom: 10px;
}

.border-color-mode label{
    color: #bbbbbb;
    font-size: 1rem;
    padding-left: 5px;
    /* do not allow text selection */
    -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */ /* Konqueror HTML */
         -moz-user-select: none; /* Firefox */ /* Internet Explorer/Edge */
              user-select: none; /* Non-prefixed version, currently
                                    supported by Chrome and Opera */
    cursor: pointer;
  }

.border-color-mode input{
    cursor: pointer;
  }

.border-color-mode .active{
    color: #bbbbbb;
  }

.border-color-mode .not-active{
    color: #9c9c9c;
  }

.color-cost-info{
  margin-top: 10px;
  margin-bottom: 20px;
  background-color: #4b4949;
  color: #bbbbbb;
  border: 3px solid #757575;
  padding: 10px 15px;
  padding-bottom: 0;
  padding-top: 12px;
  font-size: 0.9rem;
}

.color-cost-info p{
    margin-bottom: 8px;
  }

.additional-cost-notice{
  background-color: #313131;
  color: #bbbbbb;
  border: 3px solid #757575;
  padding: 10px 15px;
  padding-bottom: 10px;
  padding-top: 15px;
  margin-top: 20px;
}

.additional-cost-notice p{
    margin-bottom: 0;
  }

.warning-text{
  color: #e6e6e6;
}

.palette-color {
  float: left;
  border: 2px solid #585858;
  border-width: 2px
}

.palette-color.selected {
    border-color: white;
  }

.modal {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-x: hidden;
}

.modal .modal__header {
    text-align: right;
    padding-bottom: 1em;
  }

.modal .modal__header button.close {
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #5786c1;
  box-shadow: 0 5px 0 0 #4171ae;
    }

.modal .modal__header button.close:hover,
  .modal .modal__header button.close.selected {
    background-color: #3a587f;
  }

.modal .modal__header button.close:hover {
    cursor: pointer;
  }

.modal .modal__header button.close:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #3a587f;
    background-color: #3a587f;
  }

.modal .modal__header button.close {
      padding: 0.4em 0.7em 0.3em 0.8em;
    }

.modal .product {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-height: 800px;
  }

.modal .product img {
      max-height: 800px;
    }

.modal .modal__body {
    overflow: auto;
  }

.modal .modal__preview .modal__preview--wrapper, .modal .modal__load .modal__preview--wrapper {
      margin: 1em auto;
      display: table;
    }

.modal .modal__load fieldset, .modal .modal__preview fieldset, .modal .modal__body fieldset {
      padding: 1em 0;
    }

.modal .modal__load fieldset label, .modal .modal__preview fieldset label, .modal .modal__body fieldset label {
        margin: 1em 0.5em;
        display: inline-block;
      }

.ReactModal__Overlay {
  display:flex;
  align-items: center;
  justify-content: center;
}

.frames-handler:before {
  content: '';
  display: table;
}

.frames-handler:after {
  content: '';
  display: table;
  clear: both;
}

.frames-handler .frames-handler__add {
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #313131;
  box-shadow: 0 5px 0 0 #707070;
  }

.frames-handler .frames-handler__add:hover,
  .frames-handler .frames-handler__add.selected {
    background-color: #4b4949;
  }

.frames-handler .frames-handler__add:hover {
    cursor: pointer;
  }

.frames-handler .frames-handler__add:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #4b4949;
    background-color: #4b4949;
  }

.frames-handler .frames-handler__add {

    height: 86px;
    float: left;
  }

.frames-handler .frame-handler__list {
    display: flex;
    background-color: rgba(51, 50, 50, 0.2);
    padding: 0.2em;
  }

.frames-handler .frame-handler__list .list__container {
      height: 85px;
      display: flex;
      flex-wrap: nowrap;
      padding-bottom: 0.5em;
    }

.frame {
  border: 1px solid #313131;
  background-color: #bbb;
  color: white;
  width: 70px;
  height: 84px;
  margin: 0 0.3em;
  flex: 0 0 auto;
  position: relative;
  overflow: hidden;
  opacity: 0.4;
}

.frame .delete,
  .frame .duplicate {
    position: absolute;
    color: white;
    right: 0;
    background-color: #313131;
    border: 1px solid #4b4949;
    padding: 0.1em;
  }

.frame .delete {
  display: inline-block;
  font: normal normal normal 14px/1 WebFontIcons;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  }

.frame .delete::before {
      content: '\\74'
  }

.frame .delete {

    font-size: 1.2em;
    top: 0;
    border-width: 0 0 2px 2px;
  }

.frame .duplicate {
  display: inline-block;
  font: normal normal normal 14px/1 WebFontIcons;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  }

.frame .duplicate::before {
      content: '\\64'
  }

.frame .duplicate {

    bottom: 23px;
    border-width: 2px 0 0 2px;
  }

.frame .frame__percentage {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 23px;
    border-top: 2px solid #4b4949;
  }

.frame.active {
    border: 2px solid #961818;
    opacity: 1;
  }

.frame.active .delete {
      cursor: no-drop;
    }

.frame.active .duplicate {
      cursor: copy;
    }

.frame.active .delete,
    .frame.active .duplicate {
      border-color: #961818;
    }

.frame.active .frame__percentage {
      border-color: #961818;
    }

.embroider {
    width: 100%;
    margin: 0.5em auto;
    display: table;
    margin-top: 20px;
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #f5f5f5;
  background-color: #349338;
  box-shadow: 0 5px 0 0 #2b752b;
  }

.embroider:hover,
  .embroider.selected {
    background-color: #2e6a2e;
  }

.embroider:hover {
    cursor: pointer;
  }

.embroider:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #2e6a2e;
    background-color: #2e6a2e;
  }

.download-pes {
    width: 100%;
    margin: 0.5em auto;
    display: table;
    margin-top: 20px;
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #961818;
  box-shadow: 0 5px 0 0 #6b1010;
  }

.download-pes:hover,
  .download-pes.selected {
    background-color: #741515;
  }

.download-pes:hover {
    cursor: pointer;
  }

.download-pes:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #741515;
    background-color: #741515;
  }

.eyedropper {
  display: inline-block;
  font: normal normal normal 14px/1 WebFontIcons;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale
}

.eyedropper::before {
      content: '\\6f'
  }

.eyedropper:hover {
    cursor: pointer;
  }

.trash-icon-btn{
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: center;
}

.trash-icon-btn svg{
        fill: #313131;
        width: 25px;
    }

.trash-icon-btn.selected svg{
        fill: #bbb;
    }

.eraser {
  display: inline-block;
  font: normal normal normal 14px/1 WebFontIcons;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale
}

.eraser::before {
      content: '\\65'
  }

.eraser:hover {
    cursor: pointer;
  }

.bucket {
  display: inline-block;
  font: normal normal normal 14px/1 WebFontIcons;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale
}

.bucket::before {
      content: '\\6e'
  }

.bucket:hover {
    cursor: pointer;
  }

.useful-data {
  text-align: center;
}

.useful-data .useful-data__rows {
    border: none;
    background-color: #e0e0e0;
    padding: 1em 0;
  }

.useful-data .useful-data__rows .checkbox {
      padding: 0.4em 0;
    }

.useful-data .useful-data__export {
    font-family: 'monospace';
    overflow-x: hidden;
    margin: 1em auto;
    background-color: #313131;
    color: #bbb;
    padding: 0.5em;
    text-align: left;
    display: block;
    width: 100%;
    resize: none;
    height: 20em;
  }

.useful-data .useful-data__options:before {
    content: '';
    display: table;
  }

.useful-data .useful-data__options:after {
    content: '';
    display: table;
    clear: both;
  }

.useful-data .useful-data__options fieldset.useful-data__rows,
    .useful-data .useful-data__options .useful-data__output {
      width: calc(99.9% * 1/2);
    }

.useful-data .useful-data__options fieldset.useful-data__rows:nth-child(1n),
    .useful-data .useful-data__options .useful-data__output:nth-child(1n) {
      float: left;
      margin-right: 0;
      clear: none;
    }

.useful-data .useful-data__options fieldset.useful-data__rows:last-child,
    .useful-data .useful-data__options .useful-data__output:last-child {
      margin-right: 0;
    }

.useful-data .useful-data__options fieldset.useful-data__rows:nth-child(0n),
    .useful-data .useful-data__options .useful-data__output:nth-child(0n) {
      float: right;
    }

.useful-data .useful-data__options fieldset.useful-data__rows {
      margin: 0;
      height: 20em;
    }

.useful-data .useful-data__options fieldset.useful-data__rows:before {
      content: '';
      display: table;
    }

.useful-data .useful-data__options fieldset.useful-data__rows:after {
      content: '';
      display: table;
      clear: both;
    }

.useful-data .useful-data__options fieldset.useful-data__rows .useful-data__pixel-format,
      .useful-data .useful-data__options fieldset.useful-data__rows .useful-data__reverse-rows {
        width: calc(99.9% * 1/2);
      }

.useful-data .useful-data__options fieldset.useful-data__rows .useful-data__pixel-format:nth-child(1n),
      .useful-data .useful-data__options fieldset.useful-data__rows .useful-data__reverse-rows:nth-child(1n) {
        float: left;
        margin-right: 0;
        clear: none;
      }

.useful-data .useful-data__options fieldset.useful-data__rows .useful-data__pixel-format:last-child,
      .useful-data .useful-data__options fieldset.useful-data__rows .useful-data__reverse-rows:last-child {
        margin-right: 0;
      }

.useful-data .useful-data__options fieldset.useful-data__rows .useful-data__pixel-format:nth-child(0n),
      .useful-data .useful-data__options fieldset.useful-data__rows .useful-data__reverse-rows:nth-child(0n) {
        float: right;
      }

@media only screen and (max-width: 730px) {
      .useful-data .useful-data__options fieldset.useful-data__rows,
      .useful-data .useful-data__options .useful-data__output {
        width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
      }
      .useful-data .useful-data__options fieldset.useful-data__rows:nth-child(1n),
      .useful-data .useful-data__options .useful-data__output:nth-child(1n) {
        float: left;
        margin-right: 30px;
        clear: none;
      }
      .useful-data .useful-data__options fieldset.useful-data__rows:last-child,
      .useful-data .useful-data__options .useful-data__output:last-child {
        margin-right: 0;
      }
      .useful-data .useful-data__options fieldset.useful-data__rows:nth-child(1n),
      .useful-data .useful-data__options .useful-data__output:nth-child(1n) {
        margin-right: 0;
        float: right;
      }
      .useful-data .useful-data__options fieldset.useful-data__rows:nth-child(1n + 1),
      .useful-data .useful-data__options .useful-data__output:nth-child(1n + 1) {
        clear: both;
      }
      .useful-data .useful-data__options fieldset.useful-data__rows {
        height: auto;
      }
        .useful-data .useful-data__options fieldset.useful-data__rows .useful-data__pixel-format,
        .useful-data .useful-data__options fieldset.useful-data__rows .useful-data__reverse-rows {
          width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
        }
        .useful-data .useful-data__options fieldset.useful-data__rows .useful-data__pixel-format:nth-child(1n),
        .useful-data .useful-data__options fieldset.useful-data__rows .useful-data__reverse-rows:nth-child(1n) {
          float: left;
          margin-right: 30px;
          clear: none;
        }
        .useful-data .useful-data__options fieldset.useful-data__rows .useful-data__pixel-format:last-child,
        .useful-data .useful-data__options fieldset.useful-data__rows .useful-data__reverse-rows:last-child {
          margin-right: 0;
        }
        .useful-data .useful-data__options fieldset.useful-data__rows .useful-data__pixel-format:nth-child(1n),
        .useful-data .useful-data__options fieldset.useful-data__rows .useful-data__reverse-rows:nth-child(1n) {
          margin-right: 0;
          float: right;
        }
        .useful-data .useful-data__options fieldset.useful-data__rows .useful-data__pixel-format:nth-child(1n + 1),
        .useful-data .useful-data__options fieldset.useful-data__rows .useful-data__reverse-rows:nth-child(1n + 1) {
          clear: both;
        }
}

.output {
  position: relative;
  text-align: center;
}

.output .copy-to-clipboard__container {
    position: absolute;
    left: 0;
    top: 0;
  }

.output .copy-to-clipboard__container button.copy-to-clipboard {
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #803c3c;
  box-shadow: 0 5px 0 0 #733939;
    }

.output .copy-to-clipboard__container button.copy-to-clipboard:hover,
  .output .copy-to-clipboard__container button.copy-to-clipboard.selected {
    background-color: #552a2a;
  }

.output .copy-to-clipboard__container button.copy-to-clipboard:hover {
    cursor: pointer;
  }

.output .copy-to-clipboard__container button.copy-to-clipboard:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #552a2a;
    background-color: #552a2a;
  }

.output .copy-to-clipboard__container button.copy-to-clipboard {
      padding: 0.1em 0.4em 0em 0.5em;
      margin: 0.5em 0.5em 0;
    }

.output .copy-to-clipboard__container span {
      background-color: #0e8044;
      color: white;
      padding: 0.1em 1.6em;
      display: none
    }

.output .copy-to-clipboard__container span.show {
        display: inline;
      }

.output .output__text {
    font-family: 'monospace';
    overflow-x: auto;
    background-color: #313131;
    color: #bbb;
    padding: 3em 0.5em 0;
    text-align: left;
    display: block;
    width: 100%;
    resize: none;
    height: 20em;
  }

.output .output__pre {
    white-space: pre;
  }

.checkbox {
  border: none;
  text-align: center;
  margin: 0 auto;
  padding: 1em 0;
}

.checkbox label span {
      padding: 0.6em 1em;
      transition: all 0.3s;
    }

.checkbox label input {
      display: none
    }

.checkbox label input:checked + span {
        color: white;
        background-color: black;
      }

.checkbox label input:not(:checked) + span:hover {
          box-shadow: 0 0 0 2px #585858 inset;
        }

.checkbox label{

    margin: 0 0.5em;
}

.move {
  display: inline-block;
  font: normal normal normal 14px/1 WebFontIcons;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale
}

.move::before {
      content: '\\69'
  }

.move:hover {
    cursor: pointer;
  }

.download-btn {
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #803c3c;
  box-shadow: 0 5px 0 0 #733939;
}

.download-btn:hover,
  .download-btn.selected {
    background-color: #552a2a;
  }

.download-btn:hover {
    cursor: pointer;
  }

.download-btn:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #552a2a;
    background-color: #552a2a;
  }

.download-btn {

  margin: 1.5em auto;
  display: table;
}

.dimensions {
  margin: 1em 0 0;
  padding: 0.5em 0;
}

.picker {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.picker label.picker__columns {
  display: inline-block;
  font: normal normal normal 14px/1 WebFontIcons;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  }

.picker label.picker__columns::before {
      content: '\\6c'
  }

.picker label.picker__rows {
  display: inline-block;
  font: normal normal normal 14px/1 WebFontIcons;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  }

.picker label.picker__rows::before {
      content: '\\6d'
  }

.picker label.picker__columns,
  .picker label.picker__rows {
    display: flex;
    flex: 0 0 100%;
  }

.picker label {
    flex: 1;
    font-size: 2em !important;
    color: #313131;
    position: relative;
    margin: 0 auto;
    text-align: center
  }

.picker label::before {
      display: inline-block;
      width: 1.2em;
      text-align: left;
    }

.picker .picker__container,
  .picker label {
    display: flex;
    align-items: center;
    justify-content: center;
  }

.picker .picker__value,
  .picker .picker__buttons {
    flex: 1;
    font-family: 'Nunito', 'Helvetica Neue Light', 'Helvetica Neue', 'Helvetica',
  'Arial', sans-serif;
    font-weight: 700;
    font-size: 1.1em;
  }

.picker .picker__container {
    /* font-family: \$font-pixel; */
    font-size: 16px;
    color: #bbb;
    background-color: #4b4949;
    border: 3px solid #757575;
    flex: 1;
  }

.picker .picker__container button {
      color: #bbb;
      background-color: #313131;
      border: none;
      outline: none;
      display: block;
      width: 100%;
      height: 2em;
      border-left: 3px solid #757575;
    }

.picker .picker__container button:hover {
      background-color: #4b4949;
    }

.picker .picker__container .button-add {
      border-bottom: 1px solid #757575;
    }

.picker .picker__container .picker-disabled {
      opacity: 0.5;
    }

.picker .picker__container .picker-disabled:hover {
      background-color: #313131;
    }

.cell-size {
  border: 3px solid #757575;
  background-color: #313131;
  color: #bbb;
  text-align: center;
}

.cell-size label,
  .cell-size input {
    padding-top: 0.2em;
  }

.cell-size label {
    display: block;
  }

.css-display {
  position: absolute;
  top: -1.6em;
  left: 0;
  opacity: 0.1;
  z-index: -1;
  padding: 1em;
  margin-top: 1em;
  color: black;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  font-size: 0.8em;
}

.copy-css h2 {
    padding: 2em 0 1em;
    margin-bottom: 0;
    font-size: 1em;
    display: block;
    text-align: center;
  }

.copy-css h2 span {
      color: #961818;
    }

.copy-css .copy-css__string {
    overflow-x: scroll;
    background-color: #313131;
    color: #bbb;
    padding: 0.5em;
    text-align: left;
  }

.color-picker .color-picker__button {
  display: inline-block;
  font: normal normal normal 14px/1 WebFontIcons;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  }

.color-picker .color-picker__button::before {
      content: '\\68'
  }

.color-picker .color-picker__button {

    display: block;
  }

.color-picker:hover {
    cursor: pointer;
  }

.color-picker {

  height: 3.2em;
  border: none;

  
}

.color-picker input{
    height: 100%;
    width: 100%;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 0;
  }

.color-picker button{
    padding: 0!important;
    height: 100%;
    background-color: transparent!important;
  }

.duration {
  margin-top: 1em;
  border: 3px solid #757575;
  background-color: #313131;
  color: #bbb;
  text-align: center;
}

.duration label,
  .duration input {
    padding-top: 0.2em;
  }

.duration label {
    display: block;
  }

.cellinfo {
  color: #bbb;
  text-align: center;
  margin-top: 0.5em;
}

.preview-box .buttons {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    margin-bottom: 0.5rem;
    align-items: center;
    
  }

.preview-box .preview-box__container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
    background-color: rgba(51, 50, 50, 0.2);
    padding: 0.8em 0 0.8em 0;
    margin: 0.8em 0;
    align-items: center;
  }

.preview-box .play {
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #313131;
  box-shadow: 0 5px 0 0 #707070;
  }

.preview-box .play:hover,
  .preview-box .play.selected {
    background-color: #4b4949;
  }

.preview-box .play:hover {
    cursor: pointer;
  }

.preview-box .play:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #4b4949;
    background-color: #4b4949;
  }

.preview-box .play {
  display: inline-block;
  font: normal normal normal 14px/1 WebFontIcons;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  }

.preview-box .play::before {
      content: '\\63'
  }

.preview-box .pause {
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #803c3c;
  box-shadow: 0 5px 0 0 #733939;
  }

.preview-box .pause:hover,
  .preview-box .pause.selected {
    background-color: #552a2a;
  }

.preview-box .pause:hover {
    cursor: pointer;
  }

.preview-box .pause:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #552a2a;
    background-color: #552a2a;
  }

.preview-box .pause {
  display: inline-block;
  font: normal normal normal 14px/1 WebFontIcons;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  }

.preview-box .pause::before {
      content: '\\66'
  }

.preview-box .screen-full {
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #313131;
  box-shadow: 0 5px 0 0 #707070;
  }

.preview-box .screen-full:hover,
  .preview-box .screen-full.selected {
    background-color: #4b4949;
  }

.preview-box .screen-full:hover {
    cursor: pointer;
  }

.preview-box .screen-full:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #4b4949;
    background-color: #4b4949;
  }

.preview-box .screen-full {
  display: inline-block;
  font: normal normal normal 14px/1 WebFontIcons;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  }

.preview-box .screen-full::before {
      content: '\\67'
  }

.preview-box .screen-normal {
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #313131;
  box-shadow: 0 5px 0 0 #707070;
  }

.preview-box .screen-normal:hover,
  .preview-box .screen-normal.selected {
    background-color: #4b4949;
  }

.preview-box .screen-normal:hover {
    cursor: pointer;
  }

.preview-box .screen-normal:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #4b4949;
    background-color: #4b4949;
  }

.preview-box .screen-normal {
  display: inline-block;
  font: normal normal normal 14px/1 WebFontIcons;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  }

.preview-box .screen-normal::before {
      content: '\\6a'
  }

.preview-box .cross-stitch {
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #313131;
  box-shadow: 0 5px 0 0 #707070
  }

.preview-box .cross-stitch:hover,
  .preview-box .cross-stitch.selected {
    background-color: #4b4949;
  }

.preview-box .cross-stitch:hover {
    cursor: pointer;
  }

.preview-box .cross-stitch:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #4b4949;
    background-color: #4b4949;
  }

.preview-box .cross-stitch {
    height: 36px;
  }

.preview-box .cross-stitch img {
      height: 18px;
      width: 16px;
      vertical-align: top;
    }

.preview-box .square {
    padding-left: 0!important
    /* use before to render a square with color #bbb */
  }

.preview-box .square:before {
      content: '';
      display: block;
      width: 16px;
      height: 16px;
      background-color: #bbb;
      
    }

.preview-box .preview-button-group{
    display:flex;
    flex-direction:row
    /* give second div padding-left 0.4 */
  }

.preview-box .preview-button-group > div:nth-child(2) {
      padding-left: 0.4rem;
    }

.preview-box .frames {
  background: none;
  border: none;
  outline: none;
  border-radius: 2px;
  padding: 10px;
  font-size: 1.2em;
  text-decoration: none;
  transition-duration: 0.1s;
  color: #bbb;
  background-color: #313131;
  box-shadow: 0 5px 0 0 #707070;
  }

.preview-box .frames:hover,
  .preview-box .frames.selected {
    background-color: #4b4949;
  }

.preview-box .frames:hover {
    cursor: pointer;
  }

.preview-box .frames:active {
    transform: translate(0, 5px);
    box-shadow: 0 1px 0 #4b4949;
    background-color: #4b4949;
  }

.preview-box .frames {
  display: inline-block;
  font: normal normal normal 14px/1 WebFontIcons;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  }

.preview-box .frames::before {
      content: '\\6b'
  }

.cross-stitch-container {
  position: relative;
  overflow: hidden; /* to make sure the rotated divs don't overflow */
}

.cross-stitch-diagonal {
  width: 1px; /* thickness of the stitch */
  height: 100%;
  position: absolute;
  top: 0;
  left: 50%;
  transform-origin: 50% 50%;
}

.import-your-own{
    display:flex;
    height:100px;
    width:100%;
    border: 1px dashed #bbb;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    cursor: pointer;
    background-color: #313131;
    border-radius: 8px;
    color: #bbb;
    font-size: 12px;
    padding: 20px 20px;
    /* disable text highlighting */
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */ /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */ /* Internet Explorer/Edge */
    user-select: none;
}

/* Non-prefixed version, currently supported by Chrome, Opera and Firefox */

.import-your-own p{
        margin: 0;
        padding-left: 10px;
    }

.import-your-own:hover{
    border: 1px dashed #9b9b9b;
}

.image-upload-icon{
    width: 24px;
    height: 24px;
}
`, "",{"version":3,"sources":["webpack://./frontend/pixel-app/src/css/imports.css","webpack://./frontend/pixel-app/src/css/_normalize.css","webpack://./frontend/pixel-app/src/css/fonts/_fonts.css","webpack://./frontend/pixel-app/src/css/_variables.css","webpack://./frontend/pixel-app/src/css/_utils.css","webpack://./frontend/pixel-app/src/css/_base.css","webpack://./frontend/pixel-app/src/css/layout/_grid.css","webpack://./frontend/pixel-app/src/css/layout/_header.css","webpack://./frontend/pixel-app/src/css/layout/_queries.css","<no source>","webpack://./frontend/pixel-app/src/css/input/_inputText.css","webpack://./frontend/pixel-app/src/css/views/_cookies.css","webpack://./frontend/pixel-app/src/css/views/_notFound.css","webpack://./frontend/pixel-app/src/css/components/_ActivePaletteControls.css","webpack://./frontend/pixel-app/src/css/components/_ActivePaletteGrid.css","webpack://./frontend/pixel-app/src/css/components/_PixelGrid.css","webpack://./frontend/pixel-app/src/css/components/_SimpleNotification.css","webpack://./frontend/pixel-app/src/css/components/_SimpleSpinner.css","webpack://./frontend/pixel-app/src/css/components/_LoadDrawing.css","webpack://./frontend/pixel-app/src/css/input/_button.css","webpack://./frontend/pixel-app/src/css/components/_SaveDrawing.css","webpack://./frontend/pixel-app/src/css/components/_NewProject.css","webpack://./frontend/pixel-app/src/css/components/_UndoRedo.css","webpack://./frontend/pixel-app/src/css/components/_App.css","webpack://./frontend/pixel-app/src/css/components/_Reset.css","webpack://./frontend/pixel-app/src/css/components/_RadioSelector.css","webpack://./frontend/pixel-app/src/css/components/_PaletteGrid.css","webpack://./frontend/pixel-app/src/css/components/_PaletteColor.css","webpack://./frontend/pixel-app/src/css/components/_Modal.css","webpack://./frontend/pixel-app/src/css/components/_FramesHandler.css","webpack://./frontend/pixel-app/src/css/components/_Frame.css","webpack://./frontend/pixel-app/src/css/components/_Embroider.css","webpack://./frontend/pixel-app/src/css/components/_EyeDropper.css","webpack://./frontend/pixel-app/src/css/components/_BulkErase.css","webpack://./frontend/pixel-app/src/css/components/_Eraser.css","webpack://./frontend/pixel-app/src/css/components/_Bucket.css","webpack://./frontend/pixel-app/src/css/components/_UsefulData.css","webpack://./frontend/pixel-app/src/css/components/_Output.css","webpack://./frontend/pixel-app/src/css/components/_Checkbox.css","webpack://./frontend/pixel-app/src/css/components/_Move.css","webpack://./frontend/pixel-app/src/css/components/_DownloadDrawing.css","webpack://./frontend/pixel-app/src/css/components/_Dimensions.css","webpack://./frontend/pixel-app/src/css/components/_Picker.css","webpack://./frontend/pixel-app/src/css/components/_CellSize.css","webpack://./frontend/pixel-app/src/css/components/_CssDisplay.css","webpack://./frontend/pixel-app/src/css/components/_CopyCss.css","webpack://./frontend/pixel-app/src/css/components/_ColorPicker.css","webpack://./frontend/pixel-app/src/css/components/_Duration.css","webpack://./frontend/pixel-app/src/css/components/_CellInfo.css","webpack://./frontend/pixel-app/src/css/components/_PreviewBox.css","webpack://./frontend/pixel-app/src/css/layout/_flex.css","webpack://./frontend/pixel-app/src/css/components/_ImportYourOwn.css"],"names":[],"mappings":"AAAA,gBAAgB;;ACAhB,sBAAsB;;AACtB,oBAAoB;;AACpB,2EAA2E;;AAE3E;;;EAGE;;AAEF;EACE,uBAAuB,EAAE,MAAM;EAC/B,0BAA0B,EAAE,MAAM;EAClC,8BAA8B,EAAE,MAAM;AACxC;;AAEA;;EAEE;;AAEF;EACE,SAAS;AACX;;AAEA;+EAC+E;;AAE/E;;;;EAIE;;AAEF;;;;;;;;;;;;EAYE,MAAM;EACN,cAAc;AAChB;;AAEA;;EAEE;;AAEF;;;;EAIE,qBAAqB;AACvB;;AAEA;;EAEE;;AAEF;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE;;AAEF;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE;;AAEF;;EAEE,aAAa;AACf;;AAEA;+EAC+E;;AAE/E;;;EAGE;;AAEF;EACE,6BAA6B,EAAE,MAAM;EACrC,qCAAqC,EAAE,MAAM;AAC/C;;AAEA;;;EAGE;;AAEF;;EAEE,gBAAgB;AAClB;;AAEA;+EAC+E;;AAE/E;;;EAGE;;AAEF;EACE,mBAAmB,EAAE,MAAM;EAC3B,0BAA0B,EAAE,MAAM;EAClC,yCAAiC;UAAjC,iCAAiC,EAAE,MAAM;AAC3C;;AAEA;;EAEE;;AAEF;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE;;AAEF;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE;;AAEF;EACE,kBAAkB;AACpB;;AAEA;;;EAGE;;AAEF;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE;;AAEF;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE;;AAEF;EACE,cAAc;AAChB;;AAEA;;;EAGE;;AAEF;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;+EAC+E;;AAE/E;;EAEE;;AAEF;EACE,kBAAkB;AACpB;;AAEA;;EAEE;;AAEF;EACE,gBAAgB;AAClB;;AAEA;+EAC+E;;AAE/E;;;EAGE;;AAEF;;;;EAIE,iCAAiC,EAAE,MAAM;EACzC,cAAc,EAAE,MAAM;AACxB;;AAEA;;EAEE;;AAEF;EACE,gBAAgB;AAClB;;AAEA;;;EAGE;;AAEF;EACE,uBAAuB,EAAE,MAAM;EAC/B,SAAS,EAAE,MAAM;EACjB,iBAAiB,EAAE,MAAM;AAC3B;;AAEA;+EAC+E;;AAE/E;;;EAGE;;AAEF;;;;;EAKE,aAAa,EAAE,MAAM;EACrB,SAAS,EAAE,MAAM;AACnB;;AAEA;;EAEE;;AAEF;EACE,iBAAiB;AACnB;;AAEA;;;EAGE;;AAEF;;EAEE,MAAM;EACN,iBAAiB;AACnB;;AAEA;;;EAGE;;AAEF;;EAEE,MAAM;EACN,oBAAoB;AACtB;;AAEA;;;;EAIE;;AAEF;;;;EAIE,0BAA0B,EAAE,MAAM;AACpC;;AAEA;;EAEE;;AAEF;;;;EAIE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE;;AAEF;;;;EAIE,8BAA8B;AAChC;;AAEA;;EAEE;;AAEF;EACE,yBAAyB;EACzB,aAAa;EACb,8BAA8B;AAChC;;AAEA;;;;;EAKE;;AAEF;EACE,sBAAsB,EAAE,MAAM;EAC9B,cAAc,EAAE,MAAM;EACtB,cAAc,EAAE,MAAM;EACtB,eAAe,EAAE,MAAM;EACvB,UAAU,EAAE,MAAM;EAClB,mBAAmB,EAAE,MAAM;AAC7B;;AAEA;;EAEE;;AAEF;EACE,cAAc;AAChB;;AAEA;;;EAGE;;AAEF;;EAEE,sBAAsB,EAAE,MAAM;EAC9B,UAAU,EAAE,MAAM;AACpB;;AAEA;;EAEE;;AAEF;;EAEE,YAAY;AACd;;AAEA;;;EAGE;;AAEF;EACE,6BAA6B,EAAE,MAAM;EACrC,oBAAoB,EAAE,MAAM;AAC9B;;AAEA;;EAEE;;AAEF;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE;;AAEF;EACE,cAAc;EACd,aAAa;AACf;;AAEA;;;EAGE;;AAEF;EACE,0BAA0B,EAAE,MAAM;EAClC,aAAa,EAAE,MAAM;AACvB;;ACxaA;EACE,iCAAiC;EACjC,4CAAuD;EACvD;;;;;;mBAMiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAAuE;AACzE;;AAEA;EACE,uBAAuB;EACvB,+DAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,4CAAiD;EACjD;;;;0DAIyE;EACzE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,6BAA6B;;AAyE7B;EAvEE,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;AAoEpC;;AAlEE;MAwDI;EAKJ;;ACxFF,kBAAkB;;AClBlB;;EAEE;;AAEF;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV;sDACoD;EACpD,+BAA+B;EAC/B,oBAAoB;EACpB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;EAIE,mBAAmB;EACnB,UAAU;EACV,4BAA4B;AAC9B;;ACtDA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB;qBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE;kCAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE;kCAA2B;EAC3B,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;GAMG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AClGA;EACE,WAAsB;EAAtB,cAAsB;AACxB;;AAFA;EACE,WAAsB;EAAtB,cAAsB;EAAtB,WAAsB;AACxB;;AAEA;EACE,8CAAgB;AAClB;;AAFA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAClB;;AAFA;EACE,eAAgB;AAClB;;AAFA;EACE,eAAgB;EAAhB,YAAgB;AAClB;;AAFA;EACE,WAAgB;AAClB;;AAEA;EACE,8CAAgB;AAClB;;AAFA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAClB;;AAFA;EACE,eAAgB;AAClB;;AAFA;EACE,eAAgB;EAAhB,YAAgB;AAClB;;AAFA;EACE,WAAgB;AAClB;;AAEA;EACE,8CAAgB;AAClB;;AAFA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAClB;;AAFA;EACE,eAAgB;AAClB;;AAFA;EACE,eAAgB;EAAhB,YAAgB;AAClB;;AAFA;EACE,WAAgB;AAClB;;AAEA;EACE,8CAAgB;AAClB;;AAFA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAClB;;AAFA;EACE,eAAgB;AAClB;;AAFA;EACE,eAAgB;EAAhB,YAAgB;AAClB;;AAFA;EACE,WAAgB;AAClB;;AAEA;EACE,8CAAgB;AAClB;;AAFA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAClB;;AAFA;EACE,eAAgB;AAClB;;AAFA;EACE,eAAgB;EAAhB,YAAgB;AAClB;;AAFA;EACE,WAAgB;AAClB;;AAEA;;EAEE,8CAAgB;AAClB;;AAHA;;EAEE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAClB;;AAHA;;EAEE,eAAgB;AAClB;;AAHA;;EAEE,eAAgB;EAAhB,YAAgB;AAClB;;AAHA;;EAEE,WAAgB;AAClB;;AAEA;EACE,8CAAgB;AAClB;;AAFA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAClB;;AAFA;EACE,eAAgB;AAClB;;AAFA;EACE,eAAgB;EAAhB,YAAgB;AAClB;;AAFA;EACE,WAAgB;AAClB;;AAEA;EACE,8CAAgB;AAClB;;AAFA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAClB;;AAFA;EACE,eAAgB;AAClB;;AAFA;EACE,eAAgB;EAAhB,YAAgB;AAClB;;AAFA;EACE,WAAgB;AAClB;;AAEA;EACE,WAAsB;EAAtB;AAKF;;AANA;EACE,WAAsB;EAAtB,cAAsB;EAAtB;AAKF;;AAHE;IACE,wBAAoB;EACtB;;AAFA;IACE,WAAoB;IAApB,eAAoB;IAApB,WAAoB;EACtB;;AAFA;IACE,eAAoB;EACtB;;AAFA;IACE,eAAoB;IAApB,YAAoB;EACtB;;AAFA;IACE,WAAoB;EACtB;;AAGF;EACE,WAAsB;EAAtB;AAKF;;AANA;EACE,WAAsB;EAAtB,cAAsB;EAAtB;AAKF;;AAHE;IACE,wBAAoB;EACtB;;AAFA;IACE,WAAoB;IAApB,eAAoB;IAApB,WAAoB;EACtB;;AAFA;IACE,eAAoB;EACtB;;AAFA;IACE,eAAoB;IAApB,YAAoB;EACtB;;AAFA;IACE,WAAoB;EACtB;;AAGF;EACE,WAAsB;EAAtB;AAKF;;AANA;EACE,WAAsB;EAAtB,cAAsB;EAAtB;AAKF;;AAHE;IACE,wBAAoB;EACtB;;AAFA;IACE,WAAoB;IAApB,eAAoB;IAApB,WAAoB;EACtB;;AAFA;IACE,eAAoB;EACtB;;AAFA;IACE,eAAoB;IAApB,YAAoB;EACtB;;AAFA;IACE,WAAoB;EACtB;;AAGF;EACE,eAA+B;AACjC;;AAEA;EACE,eAA+B;EAC/B,cAAc;AAChB;;ACpEA;EACE,WAAoB;EAEpB,aAAa;AA6Cf;;AAhDA;EAEE,WAAsB;EAAtB,cAAsB;AA8CxB;;AAhDA;EAEE,WAAsB;EAAtB,cAAsB;EAAtB,WAAsB;AA8CxB;;AA5CE;IACE,qBAAqB;IACrB;EAMF;;AALE;;;MAGE,cAAc;IAChB;;AAEF;IACE,SAAS;EACX;;AAEA;IACE,iBAAiB;EA6BnB;;AA3BE;MACE,eAAe;MACf,oBAAoB;IAwBtB;;AAtBE;QACE,WAAoB;MACtB;;AAEA;QACE,cAAwB;MAC1B;;AAEA;QACE,cAAc;QACd,gBAAgB;QAChB,oBAAoB;QACpB,kBAAkB;QAClB,SAAS;QACT,MAAM;MACR;;AAGE;UACE,qBAAqB;QACvB;;AAMR;IAEI;;MAEE,8CAAgB;IAClB;IAHA;;MAEE,WAAgB;MAAhB,kBAAgB;MAAhB,WAAgB;IAClB;IAHA;;MAEE,eAAgB;IAClB;IAHA;;MAEE,eAAgB;MAAhB,YAAgB;IAClB;IAHA;;MAEE,WAAgB;IAClB;EAEF;IACE,gBAAgB;EAClB;AACF;;AC5DA;EACE;;IAEE,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;IAEI;MACE,2BAA2B;MAC3B,WAAW;IACb;;EAGF;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;;;;GAIC;EACD;;IAEE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;MAII;QACE,WAAiB;MASnB;MAVA;QACE,WAAiB;QAAjB,WAAiB;QAAjB,eAAiB;QAAjB,WAAiB;MASnB;MAVA;QACE,WAAiB;QAAjB,WAAiB;QAAjB,eAAiB;QAAjB,WAAiB;MASnB;MAVA;QACE,WAAiB;QAAjB,WAAiB;QAAjB,eAAiB;QAAjB,WAAiB;MASnB;;QAPE;UACE,uBAAuB;QACzB;;QAEA;UACE,SAAS;QACX;;MAGF;QACE,WAAiB;MACnB;;MAFA;QACE,WAAiB;QAAjB,WAAiB;QAAjB,eAAiB;QAAjB,WAAiB;MACnB;;MAFA;QACE,WAAiB;QAAjB,WAAiB;QAAjB,eAAiB;QAAjB,WAAiB;MACnB;;MAFA;QACE,WAAiB;QAAjB,WAAiB;QAAjB,eAAiB;QAAjB,WAAiB;MACnB;;IAGF;MACE,2BAA2B;MAC3B;IASF;MARE;QACE,WAAiB;MAMnB;MAPA;QACE,WAAiB;QAAjB,WAAiB;QAAjB,eAAiB;QAAjB,WAAiB;MAMnB;MAPA;QACE,WAAiB;QAAjB,WAAiB;QAAjB,eAAiB;QAAjB,WAAiB;MAMnB;MAPA;QACE,WAAiB;QAAjB,WAAiB;QAAjB,eAAiB;QAAjB,WAAiB;MAMnB;;QAJE;UACE,2BAA2B;UAC3B,WAAW;QACb;;EAKN;IACE,WAAsB;IAAtB,cAAsB;EAOxB;;EARA;IACE,WAAsB;IAAtB,cAAsB;IAAtB,WAAsB;EAOxB;;IALE;MACE,8CAAgB;IAClB;;IAFA;MACE,WAAgB;MAAhB,kBAAgB;MAAhB,WAAgB;IAClB;;IAFA;MACE,eAAgB;IAClB;;IAFA;MACE,eAAgB;MAAhB,YAAgB;IAClB;;IAFA;MACE,WAAgB;IAClB;;IC3FJ;;ID6FI;GC7FJ;;EDgGE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;;;;;;;;KAUG;;EAEH;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAI5B;IAHE;MACE,uBAAuB;IACzB;;EAGF;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;IAGE;;MAEE,oCAAwC;IAC1C;IAIA;;MAEE,oCAAgD;IAClD;;EAGF;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;IAGE;MACE,aAAa;MACb,iBAAiB;IACnB;;EAGF;IACE,iCAAiC;IACjC,yCAAyC;EAC3C;;EAEA;IACE,8BAA8B;IAC9B,2BAA2B;IAC3B,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0CAA0C;IAC1C,wBAAwB;IACxB,8BAA8B;IAC9B,0BAA0B;EAI5B;IAHE;MACE,0BAA0B;IAC5B;IAIA;MACE,4BAA4B;IAC9B;AAEJ;;AACA;;;;;;;;;;GAUG;;AExOH;;;GAGG;;AAEH;;;;;;;GAOG;;AC/BH;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAoB;EACpB,UAAU;EACV,cAAc;AA+GhB;;AA9GE;IACE,gBAAgB;IAChB,MAAM;IACN,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,UAAU;EACZ;;AACA;IACE,gBAAgB;EAClB;;AACA;IACE,qBAAqB;IACrB,cAAc;EAChB;;AACA;IACE,qBAAqB;EACvB;;AACA;IACE,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;AACA;IACE,aAAa;IACb,YAAY;IACZ,gBAAgB;EAClB;;AACA;IACE;;;;;;;;;;;;;;;;;;;;;;;;gDAwB4C;IAC5C;;;;;;;;;;;;;;;;;;;;;;;;sEAwBkE;IAClE;;;;;;;;;;;;;;;;;;;;;;;;sEAwBkE;IAClE,YAAY;IACZ,WAAW;EACb;;AACA;IACE,cAAwB;EAC1B;;AAGF;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AChIA;EACE,kBAAkB;AA0BpB;;AAzBE;IACE,gBAAgB;IAChB,MAAM;IACN,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,cAAwB;EAC1B;;AACA;IACE,cAAc;EAChB;;AACA;IACE,aAAa;IACb,YAAY;IACZ,oBAAoB;EACtB;;AAEA;IACE,kBAAkB;IAClB,+BAA+B;IAC/B,uCAAuC;IACvC,oCAAoC;IACpC,kCAAkC;EACpC;;AAGF;EACE;;IAEE;;;;;;;;;;;;;;;;;;;;;;;;;;4CA0BwC;IACxC,YAAY;IACZ,WAAW;EACb;EACA;;IAEE;;;;;;;;;;;;;;;;;;;;;;;;;;4CA0BwC;IACxC,YAAY;IACZ,WAAW;EACb;EACA;;IAEE;;;;;;;;;;;;;;;;;;;;;;;;;4CAyBwC;IACxC,YAAY;IACZ,WAAW;EACb;EACA;;IAEE;;;;;;;;;;;;;;;;;;;;;;;;;4CAyBwC;IACxC,YAAY;IACZ,WAAW;EACb;AACF;;AC5JA;IACI,4BAA4B;IAC5B,qCAAqC;IACrC,mCAAmC;IACnC,oCAAoC;IACpC,qBAAqB;;AAKzB;;AAJI;QACI,oBAAoB;IACxB;;AAIJ;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX;;;qCAGiC;;;IAGjC,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,WAAW;IACX,yBAAyB;IACzB,6BAA6B;IAC7B,YAAY;IACZ,sBAAsB;;IAUtB;;;8BAG0B;EAqB5B;;AAhCE;QACI,aAAa;QACb,uBAAuB;QACvB,YAAY;QACZ,WAAW;QACX,mBAAmB;IACvB;;AAQA;QACI,4BAA4B;QAC5B,2BAA2B;QAC3B,yBAAyB;IAC7B;;AAIA;QACI,yBAAyB;IAC7B;;AAEA;QACI,YAAY;QACZ,WAAW;QACX,UAAU;QACV,sBAAsB;IAC1B;;AAGJ;IACI,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,8BAA8B;IAC9B,6BAA6B;EXxC/B,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC;;EW6DA;;AX3DA;MA4CI;EAiBJ;;AWlCF;;IAUI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,WAAW;IACX,yBAAyB;IACzB;;EAYF;;AAVE;QACI,4BAA4B;QAC5B,2BAA2B;QAC3B,yBAAyB;IAC7B;;AAEA;QACI,yBAAyB;IAC7B;;ACrGA;QACI,WAAW;QACX,YAAY;IAChB;;ACJJ;EAEE,cAAc;EACd,eAAe;EACf,cAAc;EACd,UAAU;EACV,yBAAyB;EACzB,yBAAyB;AAwB3B;;AA/BA;EACE,WAAsB;EAAtB,cAAsB;AA8BxB;;AA/BA;EACE,WAAsB;EAAtB,cAAsB;EAAtB,WAAsB;AA8BxB;;AArBE;IACE,WAAW;IACX,yBAAyB;IACzB,yBAAyB;EAC3B;;AAEA;IACE,YAAY;EACd;;AAEA;IACE,oBAAoB;EACtB;;AAEA;IACE,YAAY;EACd;;AAEA;IACE,kBAAkB;EACpB;;AC9BF;EACE,yBAAyB;EACzB,WAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;AAC1B;;AAEA,0CAA0C;;AAC1C;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AC/BA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,MAAM;EACN;AAsBF;;AApBE;IACE,cAAc;EAChB;;AAEA;IACE,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,6CAA6C;IAC7C,gDAAgD;IAChD,iDAAiD;IACjD,iDAAiD;IACjD,2CAA2C;IAC3C,mBAAmB;IACnB,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,kBAAkB;EACpB;;AAGF;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,MAAM;EACN;AAsBF;;AApBE;IACE,cAAc;EAChB;;AAEA;IACE,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,6CAA6C;IAC7C,gDAAgD;IAChD,iDAAiD;IACjD,iDAAiD;IACjD,2CAA2C;IAC3C,mBAAmB;IACnB,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,kBAAkB;EACpB;;AC/EF;EACE,kBAAkB;AAkFpB;;AAjFE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;;IAElB,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,eAAe;EACjB;;AAEA;IACE,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf;EAkCF;;AAhCE;MACE,kBAAkB;MAClB,cAAc;IAChB;;AAEA;MACE,kBAAkB;MAClB,uBAAuB;MACvB,eAAe;MACf,cAAc;MACd,aAAa;MACb,kBAAkB;IAoBpB;;AAlBE;EhBIJ,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;MgBI9B;;AhBFJ;MA2DI;EAEJ;;AgBxEI;;QAGE,kBAAkB;QAClB,gBAAgB;QAChB,YAAY;QACZ,MAAM;QACN,QAAQ;QACR,eAAe;QACf,cAAc;QACd,yBAAkC;QAClC,uBAAuB;QACvB,yBAAyB;MAC3B;;AAEA;QACE,cAAc;MAChB;;AAIJ;IACE,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,yBAAkC;IAClC,WAAoB;IACpB,cAAc;IACd,gBAAgB;EAClB;;AAEA;IACE,wBAA4B;IAC5B,cAAc;IACd,UAAU;IACV,YAAY;IACZ,WAAW;IACX,cAAc;IACd,cAAc;IACd,yBAAkC;IAClC,WAAoB;EACtB;;AAEA;EC5EA,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;EDuEtC;;ACrEA;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;ADmDA;;IAGE,kBAAkB;IAClB,cAAc;EAChB;;AAGF;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;AAO9B;;AANE;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;;ATrHF;EUCE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAkB;EAClB,yBAA2B;EAC3B;CVXF;;AUaE;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;ADgGF;EACE,gBAAgB;EAChB,WAAW;AASb;;AARE;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,QAAQ;IACR,iBAAiB;EACnB;;AAGF,wCAAwC;;AACxC;EACE,gFAAgF;AAClF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;AACF;;AAGA;EACE,iCAA+B;EAC/B,oCAAkC;EAClC,0BAA0B;EAC1B,wBAAwB;EACxB,kCAAgC;EAChC,wBAAwB;EACxB,sBAAsB;EACtB,mCAAiC;EACjC,yBAAyB;EACzB,uBAAuB;EACvB,iCAA+B;EAC/B,uBAAuB;EACvB,qBAAqB;EACrB,0JAA0J;EAC1J,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,gBAAW;IAAX,cAAW;OAAX,WAAW;EACX,8BAAsB;KAAtB,2BAAsB;UAAtB,sBAAsB;EACtB,QAAQ;EACR,mCAAmC;EACnC,yBAAyB;EACzB,wBAAwB;EACxB,wDAAwD;EACxD,WAAW;EACX,WAAW;AACb;;AAEA;EC5LE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;ADqLxC;;ACnLE;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;ADmKF;EAEE,YAAY;AACd;;AAEA;ECjME,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;ADgMxC;;AC9LE;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;ADwKF;EAEE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAGA;EACE,WAAW;EACX,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;ECnNE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B;ADsNF;;ACpNE;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;AD0LF;;EAGE,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;AAK9B;;AAJE;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;;AAGF;EClOE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B;AD4OF;;AC1OE;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;ADyMF;;EAGE,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;AAc9B;;AAbE;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;;AT7OF;ES8OE,mBAAmB;EACnB,YAAY;EACZ;CThPF;;ASkPE;IACE,mCAAmC;IACnC,mBAAmB;IACnB,oBAAoB;EACtB;;AAGF;EACE,eAAe;AAQjB;;AAPE;IACE,eAAe;IACf,iBAAiB;EACnB;;AACA;IACE,eAAe;EACjB;;AAGF;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AEvQE;EDAA,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;ECNtC;;ADQA;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;ACzBA;;IAGE,WAAW;EACb;;ACJA;EFAA,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;EEJtC;;AFMA;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;AEzBA;;IAGE,WAAW;IACX,cAAc;IACd,oBAAoB;EACtB;;ACPF;EACE,WAAsB;EAAtB,cAAsB;AAoBxB;;AArBA;EACE,WAAsB;EAAtB,cAAsB;EAAtB,WAAsB;AAoBxB;;AAlBE;EHFA,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;EGHtC;;AHKA;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;AGvBA;;IAGE,gDAAwB;IACxB,gBAAgB;EAClB;;AALA;;IAGE,WAAwB;;IAAxB,mBAAwB;;IAAxB,WAAwB;EAE1B;;AALA;;IAGE,eAAwB;EAE1B;;AALA;;IAGE,YAAwB;EAE1B;;AAEA;EpB4BA,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;EoB7BlC;;ApB+BA;MA+CI;EAcJ;;AoBhGA;;IAGE,cAAc;EAChB;;AAEA;EpBsBA,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;EoBvBlC;;ApByBA;MAkDI;EAWJ;;AoB1FA;;IAGE,cAAc;EAChB;;ACnBA;;IAEE,WAAsB;IAAtB,cAAsB;EACxB;;AAHA;;IAEE,WAAsB;IAAtB,cAAsB;IAAtB,WAAsB;EACxB;;AAEA;IACE,uCAAuC;EACzC,6GAA6G;EAC7G,yBAAyB;EACzB,kCAAkC;EAClC,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB;;AAEA;;IAEE,gBAAgB;EAClB;;AAEA;IACE,kBAAkB;EACpB;;AAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;AAEA;IACE,kBAAkB;EAYpB;;AAVE;EJhCF,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;IIwBpC;;AJtBF;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;AV1BF;;IcqCI,WAAsB;;IAAtB;CdrCJ;;AAAA;;IcqCI,WAAsB;;IAAtB,cAAsB;;IAAtB;CdrCJ;;AcuCI;;MAEE,0DAA6B;IAC/B;;AAHA;;MAEE,WAA6B;MAA7B,mBAA6B;MAA7B,WAA6B;IAC/B;;AAHA;;MAEE,eAA6B;IAC/B;;AAHA;;MAEE,YAA6B;IAC/B;;AAIA;EJ7CF,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;IIwCpC;;AJtCF;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;AIoBE;;MAGE,WAAW;MACX,qBAAqB;IACvB;;AAEA;EJpDF,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;IIgDpC;;AJ9CF;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;AI2BE;MAEE,6BAA6B;;MAE7B,WAAW;MACX,qBAAqB;IACvB;;AAGF;IAEE,aAAa;EAuBf;;AAzBA;IACE,WAAsB;IAAtB,cAAsB;EAwBxB;;AAzBA;IACE,WAAsB;IAAtB,cAAsB;IAAtB,WAAsB;EAwBxB;;AArBE;MACE,gDAAwB;IAC1B;;AAFA;MACE,WAAwB;MAAxB,mBAAwB;MAAxB,WAAwB;IAC1B;;AAFA;MACE,eAAwB;IAC1B;;AAFA;MACE,YAAwB;IAC1B;;AAEA;EJrEF,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;IIoEpC;;AJlEF;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;AI4CE;ErBhCF,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;IqBoChC;;ArBlCF;MAwDI;EAKJ;;AqBhCI;QACE,0BAAmC;MACrC;;AANF;;MAQE,WAAW;IACb;;AAEA;EJhFF,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;II2EpC;;AJzEF;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;AIuDE;ErB3CF,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;IqB2ChC;;ArBzCF;MAKI;EAwDJ;;AqBzBE;;MAIE,WAAW;IACb;;AAGF;EJxFA,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,YAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;EIqFtC;;AJnFA;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;AI+DA;;IAGE,WAAW;IACX,eAAe;IACf,4BAA4B;IAC5B,cAAuB;EACzB;;AAEA;EJjGA,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;EI6FtC;;AJ3FA;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;AIwEA;;IAGE,WAAW;IACX,iBAAiB;IACjB,cAAc;EAChB;;AAEA;IACE,kBAAkB;IAClB,mBAAmB;EA+BrB;;AA5BI;QACE,gBAAgB;QAChB,kBAAkB;QAClB,cAAuB;QACvB,gBAAgB;QAChB,WAAW;QACX,YAAY;QACZ,6BAA6B;QAC7B;MAkBF;;AAhBE;UACE,UAAU;QACZ;;AAEA;UACE,yBAAyB;QAC3B;;AAEA;UACE,WAAoB;UACpB;QAKF;;AAHE;YACE,yBAAkC;UACpC;;AAMR;;IAEE,UAAU;EACZ;;AAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;AAGF;;EAEE,oCAAoC;EACpC,qBAAqB;;AAMvB;;AAJE;IACE,uBAAuB;EACzB;;AAIF;EACE,uBAAuB;EACvB,qBAAqB;AAIvB;;AAHE;IACE,uBAAuB;EACzB;;ACxKF;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;ELFd,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;AKLxC;;ALOE;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;AM1BF;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;AA0BhB;;AAvBI;MACE,kBAAkB;MAClB,yBAAiC;MACjC,oBAAoB;IACtB;;AAEA;MACE;IAYF;;AAVE;QACE,YAAY;QACZ,uBAAuB;MACzB;;AAGE;UACE,mCAA2C;QAC7C;;AhBvBR;;IgB2BI;ChB3BJ;;AiBAA;EAEE,kBAAkB;EAClB,eAAe;AACjB;;AAJA;EACE,WAAsB;EAAtB,cAAsB;AAGxB;;AAJA;EACE,WAAsB;EAAtB,cAAsB;EAAtB,WAAsB;AAGxB;;AAEA;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;AAMd;;AAZA;EACE,WAAsB;EAAtB,cAAsB;AAWxB;;AAZA;EACE,WAAsB;EAAtB,cAAsB;EAAtB,WAAsB;AAWxB;;AALE;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;;AAGF;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;;AAmBpB;;AAlBE;IACE,eAAe;EACjB;;AACA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,gCAAgC;IAChC,2BAA2B,EAAE,eAAe;MAC1C,yBAAyB,EAAE,WAAW,EACX,mBAAmB;SAC3C,sBAAsB,EAAE,YAAY,EACZ,2BAA2B;cAC9C,iBAAiB,EAAE;mEACkC;EACjE;;AAIF;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AA0BtB;;AAxBE;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gCAAgC;IAChC,2BAA2B,EAAE,eAAe;MAC1C,yBAAyB,EAAE,WAAW,EACX,mBAAmB;SAC3C,sBAAsB,EAAE,YAAY,EACZ,2BAA2B;cAC9C,iBAAiB,EAAE;mEACkC;IAC/D,eAAe;EACjB;;AACA;IACE,eAAe;EACjB;;AAEA;IACE,cAAc;EAChB;;AACA;IACE,cAAc;EAChB;;AAGF;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AAInB;;AAHE;IACE,kBAAkB;EACpB;;AAGF;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAIlB;;AAHE;IACE,gBAAgB;EAClB;;AAGF;EACE,cAAc;AAChB;;AChHA;EACE,WAAW;EACX,yBAAiC;EACjC;AAKF;;AAHE;IACE,mBAAmB;EACrB;;ACPF;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,kBAAkB;AA0CpB;;AAzCE;IACE,iBAAiB;IACjB,mBAAmB;EAKrB;;AAJE;ETPF,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;ISApC;;ATEF;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;ASlBE;MAEE,gCAAgC;IAClC;;AAEF;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;EAInB;;AAHE;MACE,iBAAiB;IACnB;;AAEF;IACE,cAAc;EAChB;;AAGE;MACE,gBAAgB;MAChB,cAAc;IAChB;;AAMA;MACE,cAAc;IAMhB;;AAJE;QACE,iBAAiB;QACjB,qBAAqB;MACvB;;AAKN;EACE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;ACpDA;EACE,WAAsB;EAAtB,cAAsB;AAqBxB;;AAtBA;EACE,WAAsB;EAAtB,cAAsB;EAAtB,WAAsB;AAqBxB;;AAnBE;EVFA,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;EUHtC;;AVKA;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;AUvBA;;IAGE,YAAY;IACZ,WAAW;EACb;;AAEA;IACE,aAAa;IACb,uCAAoC;IACpC,cAAc;EAQhB;;AANE;MACE,YAAY;MACZ,aAAa;MACb,iBAAiB;MACjB,qBAAqB;IACvB;;ACpBJ;EACE,yBAAkC;EAClC,sBAA+B;EAC/B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AAwDd;;AAtDE;;IAEE,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,yBAAkC;IAClC,yBAAgC;IAChC,cAAc;EAChB;;AAEA;E5BgBA,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;E4BflC;;A5BiBA;MA2DI;EAEJ;;A4BpFA;;IAGE,gBAAgB;IAChB,MAAM;IACN,yBAAyB;EAC3B;;AAEA;E5BQA,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;E4BRlC;;A5BUA;MAWI;EAkDJ;;A4B5EA;;IAGE,YAAY;IACZ,yBAAyB;EAC3B;;AAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,6BAAoC;EACtC;;AAEA;IACE,yBAAkC;IAClC,UAAU;EAkBZ;;AAhBE;MACE,eAAe;IACjB;;AAEA;MACE,YAAY;IACd;;AAEA;;MAEE,qBAA8B;IAChC;;AAEA;MACE,qBAA8B;IAChC;;AChEJ;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EZHlB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;EYJtC;;AZMA;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;AYjBA;IACE,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EZZlB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;EYKtC;;AZHA;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;Aa1BF;E9BsCE,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC;A8BrCF;;A9BuCE;MA4CI;EAiBJ;;A8BvGA;IACE,eAAe;EACjB;;ACLF;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;AAQ3B;;AAPI;QACI,aAAa;QACb,WAAW;IACf;;AACA;QACI,UAAU;IACd;;ACXJ;EhCsCE,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC;AgCrCF;;AhCuCE;MAcI;EA+CJ;;AgCvGA;IACE,eAAe;EACjB;;ACLF;EjCsCE,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC;AiCrCF;;AjCuCE;MAyCI;EAoBJ;;AiCvGA;IACE,eAAe;EACjB;;ACLF;EACE,kBAAkB;AAsCpB;;AArCE;IACE,YAAY;IACZ,yBAA6B;IAC7B,cAAc;EAIhB;;AAHE;MACE,gBAAgB;IAClB;;AAEF;IACE,wBAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,yBAAkC;IAClC,WAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;AACA;IACE,WAAsB;IAAtB,cAAsB;EAcxB;;AAfA;IACE,WAAsB;IAAtB,cAAsB;IAAtB,WAAsB;EAcxB;;AAbE;;MAEE,wBAAoB;IACtB;;AAHA;;MAEE,WAAoB;MAApB,eAAoB;MAApB,WAAoB;IACtB;;AAHA;;MAEE,eAAoB;IACtB;;AAHA;;MAEE,YAAoB;IACtB;;AACA;MAEE,SAAS;MACT,YAAY;IAKd;;AARA;MACE,WAAsB;MAAtB,cAAsB;IAOxB;;AARA;MACE,WAAsB;MAAtB,cAAsB;MAAtB,WAAsB;IAOxB;;AAJE;;QAEE,wBAAoB;MACtB;;AAHA;;QAEE,WAAoB;QAApB,eAAoB;QAApB,WAAoB;MACtB;;AAHA;;QAEE,eAAoB;MACtB;;AAHA;;QAEE,YAAoB;MACtB;;AAKN;MAGM;;QAEE,8CAAgB;MAClB;MAHA;;QAEE,WAAgB;QAAhB,kBAAgB;QAAhB,WAAgB;MAClB;MAHA;;QAEE,eAAgB;MAClB;MAHA;;QAEE,eAAgB;QAAhB,YAAgB;MAClB;MAHA;;QAEE,WAAgB;MAClB;MACA;QACE,YAAY;MAKd;QAJE;;UAEE,8CAAgB;QAClB;QAHA;;UAEE,WAAgB;UAAhB,kBAAgB;UAAhB,WAAgB;QAClB;QAHA;;UAEE,eAAgB;QAClB;QAHA;;UAEE,eAAgB;UAAhB,YAAgB;QAClB;QAHA;;UAEE,WAAgB;QAClB;AAIR;;ACzDA;EACE,kBAAkB;EAClB,kBAAkB;AAmCpB;;AAlCE;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;EAeR;;AAdE;ElBNF,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;IkBApC;;AlBEF;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;AkBnBE;MAEE,8BAA8B;MAC9B,qBAAqB;IACvB;;AACA;MACE,yBAA8B;MAC9B,YAAY;MACZ,oBAAoB;MACpB;IAIF;;AAHE;QACE,eAAe;MACjB;;AAGJ;IACE,wBAA4B;IAC5B,gBAAgB;IAChB,yBAAkC;IAClC,WAAoB;IACpB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;AACA;IACE,gBAAgB;EAClB;;ACpCF;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,cAAc;AAyBhB;;AAtBI;MACE,kBAAkB;MAClB,oBAAoB;IACtB;;AAEA;MACE;IAYF;;AAVE;QACE,YAAY;QACZ,uBAAuB;MACzB;;AAGE;UACE,mCAA2C;QAC7C;;A7BvBR;;I6B2BI;C7B3BJ;;A8BAA;ErCsCE,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC;AqCrCF;;ArCuCE;MA0BI;EAmCJ;;AqCvGA;IACE,eAAe;EACjB;;ACLF;ErBCE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;AqBNxC;;ArBQE;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;AqB1BF;;EAGE,kBAAkB;EAClB,cAAc;AAChB;;ACLA;EACE,eAAe;EACf,gBAAgB;AAClB;;ACHA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AAiFpB;;AA/EE;ExCgCA,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;EwCnClC;;AxCqCA;MAmCI;EA0BJ;;AwChGA;ExC4BA,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;EwC/BlC;;AxCiCA;MAsCI;EAuBJ;;AwC5FA;;IAEE,aAAa;IACb,cAAc;EAChB;;AAEA;IACE,OAAO;IACP,yBAAyB;IACzB,cAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd;EAOF;;AALE;MACE,qBAAqB;MACrB,YAAY;MACZ,gBAAgB;IAClB;;AAGF;;IAEE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;AAEA;;IAEE,OAAO;IACP;qBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;EAClB;;AAEA;IACE,8BAA8B;IAC9B,eAAe;IACf,WAAoB;IACpB,yBAAgC;IAChC,yBAAgC;IAChC,OAAO;EA4BT;;AA1BE;MACE,WAAoB;MACpB,yBAAkC;MAClC,YAAY;MACZ,aAAa;MACb,cAAc;MACd,WAAW;MACX,WAAW;MACX,8BAAqC;IACvC;;AAEA;MACE,yBAAgC;IAClC;;AAEA;MACE,gCAAuC;IACzC;;AAEA;MACE,YAAY;IACd;;AAEA;MACE,yBAAkC;IACpC;;ACnFJ;EACE,yBAAgC;EAChC,yBAAkC;EAClC,WAAoB;EACpB,kBAAkB;AAUpB;;AARE;;IAEE,kBAAkB;EACpB;;AAEA;IACE,cAAc;EAChB;;ACbF;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;ACVE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,kBAAkB;EAKpB;;AAHE;MACE,cAAuB;IACzB;;AAGF;IACE,kBAAkB;IAClB,yBAAkC;IAClC,WAAoB;IACpB,cAAc;IACd,gBAAgB;EAClB;;AClBA;E5CqCA,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;E4CtClC;;A5CwCA;MAuBI;EAsCJ;;A4CzGA;;IAGE,cAAc;EAChB;;AAEA;IACE,eAAe;EACjB;;AATF;;EAWE,aAAa;EACb,YAAY;;;AAkBd;;AAhBE;IACE,YAAY;IACZ,WAAW;IACX,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;EAClB;;AAEA;IACE,oBAAoB;IACpB,YAAY;IACZ,uCAAuC;EACzC;;AC3BF;EACE,eAAe;EACf,yBAAgC;EAChC,yBAAkC;EAClC,WAAoB;EACpB,kBAAkB;AAUpB;;AARE;;IAEE,kBAAkB;EACpB;;AAEA;IACE,cAAc;EAChB;;ACdF;EACE,WAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;;ACHE;IACE,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,qBAAqB;IACrB,mBAAmB;;EAErB;;AAEA;ECTA,aAAa;EACb,qBAAqB;EACrB,uBAAuB;IDSrB,uCAAoC;IACpC,wBAAwB;IACxB,eAAe;IACf,mBAAmB;EACrB;;AAEA;E9BjBA,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;E8BUtC;;A9BRA;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;A8BRA;E/CoBA,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;E+CtBlC;;A/CwBA;MAQI;EAqDJ;;A+CnFA;E9BtBA,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;E8BetC;;A9BbA;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;A8BHA;E/CeA,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;E+CjBlC;;A/CmBA;MAiBI;EA4CJ;;A+C9EA;E9B3BA,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;E8BoBtC;;A9BlBA;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;A8BEA;E/CUA,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;E+CZlC;;A/CcA;MAoBI;EAyCJ;;A+CzEA;E9BhCA,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;E8ByBtC;;A9BvBA;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;A8BOA;E/CKA,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;E+CPlC;;A/CSA;MA6BI;EAgCJ;;A+CpEA;E9BrCA,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B;E8BmCA;;A9BjCA;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;A8BYA;IAEE,YAAY;EAMd;;AALE;MACE,YAAY;MACZ,WAAW;MACX,mBAAmB;IACrB;;AAGF;IACE,wBAAyB;IACzB,kDAAkD;EASpD;;AARE;MACE,WAAW;MACX,cAAc;MACd,WAAW;MACX,YAAY;MACZ,sBAAsB;;IAExB;;AAGF;IACE,YAAY;IACZ,iBAAkB;IAClB,qCAAqC;EAIvC;;AAHE;MACE,oBAAoB;IACtB;;AAGF;E9BrEA,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAkB;EAClB,yBAA2B;EAC3B,6BAAsC;E8B8DtC;;A9B5DA;;IAEE,yBAAkC;EACpC;;AAEA;IACE,eAAe;EACjB;;AAEA;IACE,4BAA4B;IAC5B,2BAAoC;IACpC,yBAAkC;EACpC;;A8B4CA;E/ChCA,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;E+C8BlC;;A/C5BA;MAgCI;EA6BJ;;A+C/BF;EACE,kBAAkB;EAClB,gBAAgB,EAAE,iDAAiD;AACrE;;AAEA;EACE,UAAU,EAAE,4BAA4B;EACxC,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,yBAAyB;AAC3B;;AEvFA;IACI,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,8BAA8B;IAC9B,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB;IAC7C,sBAAsB,EAAE,YAAY,EACb,2BAA2B;IAClD,iBAAiB;AAMrB;;AANuB,2EAA2E;;AAE9F;QACI,SAAS;QACT,kBAAkB;IACtB;;AAGJ;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":["@charset 'UTF-8';\n\n@import '_normalize.css';\n@import 'fonts/_fonts.css';\n@import '_variables.css';\n@import '_utils.css';\n@import '_base.css';\n@import 'layout/_grid.css';\n@import 'layout/_header.css';\n@import 'layout/_queries.css';\n@import 'layout/_flex.css';\n@import 'input/_inputText.css';\n@import 'input/_button.css';\n@import 'views/_cookies.css';\n@import 'views/_notFound.css';\n@import 'components/_ActivePaletteControls.css';\n@import 'components/_ActivePaletteGrid.css';\n@import 'components/_PixelGrid.css';\n@import 'components/_SimpleNotification.css';\n@import 'components/_SimpleSpinner.css';\n@import 'components/_LoadDrawing.css';\n@import 'components/_SaveDrawing.css';\n@import 'components/_NewProject.css';\n@import 'components/_UndoRedo.css';\n@import 'components/_App.css';\n@import 'components/_Reset.css';\n@import 'components/_RadioSelector.css';\n@import 'components/_PaletteGrid.css';\n@import 'components/_PaletteColor.css';\n@import 'components/_Modal.css';\n@import 'components/_FramesHandler.css';\n@import 'components/_Frame.css';\n@import 'components/_Embroider.css';\n@import 'components/_EyeDropper.css';\n@import 'components/_BulkErase.css';\n@import 'components/_Eraser.css';\n@import 'components/_Bucket.css';\n@import 'components/_UsefulData.css';\n@import 'components/_Output.css';\n@import 'components/_Checkbox.css';\n@import 'components/_Move.css';\n@import 'components/_DownloadDrawing.css';\n@import 'components/_Dimensions.css';\n@import 'components/_Picker.css';\n@import 'components/_CellSize.css';\n@import 'components/_CssDisplay.css';\n@import 'components/_CopyCss.css';\n@import 'components/_ColorPicker.css';\n@import 'components/_Duration.css';\n@import 'components/_CellInfo.css';\n@import 'components/_PreviewBox.css';\n@import 'components/_ImportYourOwn.css';\n","/* stylelint-disable */\n/* prettier-ignore */\n/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css */\n\n/**\n * 1. Change the default font family in all browsers (opinionated).\n * 2. Prevent adjustments of font size after orientation changes in IE and iOS.\n */\n\nhtml {\n  font-family: sans-serif; /* 1 */\n  -ms-text-size-adjust: 100%; /* 2 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n}\n\n/**\n * Remove the margin in all browsers (opinionated).\n */\n\nbody {\n  margin: 0;\n}\n\n/* HTML5 display definitions\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */\n\narticle,\naside,\ndetails, /* 1 */\nfigcaption,\nfigure,\nfooter,\nheader,\nmain, /* 2 */\nmenu,\nnav,\nsection,\nsummary {\n  /* 1 */\n  display: block;\n}\n\n/**\n * Add the correct display in IE 9-.\n */\n\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n}\n\n/**\n * Add the correct display in iOS 4-7.\n */\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\n\nprogress {\n  vertical-align: baseline;\n}\n\n/**\n * Add the correct display in IE 10-.\n * 1. Add the correct display in IE.\n */\n\ntemplate, /* 1 */\n[hidden] {\n  display: none;\n}\n\n/* Links\n   ========================================================================== */\n\n/**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */\n\na {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}\n\n/**\n * Remove the outline on focused links when they are also active or hovered\n * in all browsers (opinionated).\n */\n\na:active,\na:hover {\n  outline-width: 0;\n}\n\n/* Text-level semantics\n   ========================================================================== */\n\n/**\n * 1. Remove the bottom border in Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\n\nabbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}\n\n/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */\n\nb,\nstrong {\n  font-weight: inherit;\n}\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/**\n * Add the correct font style in Android 4.3-.\n */\n\ndfn {\n  font-style: italic;\n}\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n/**\n * Add the correct background and color in IE 9-.\n */\n\nmark {\n  background-color: #ff0;\n  color: #000;\n}\n\n/**\n * Add the correct font size in all browsers.\n */\n\nsmall {\n  font-size: 80%;\n}\n\n/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/* Embedded content\n   ========================================================================== */\n\n/**\n * Remove the border on images inside links in IE 10-.\n */\n\nimg {\n  border-style: none;\n}\n\n/**\n * Hide the overflow in IE.\n */\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\n/* Grouping content\n   ========================================================================== */\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n * Add the correct margin in IE 8.\n */\n\nfigure {\n  margin: 1em 40px;\n}\n\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\n\nhr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}\n\n/* Forms\n   ========================================================================== */\n\n/**\n * 1. Change font properties to `inherit` in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font: inherit; /* 1 */\n  margin: 0; /* 2 */\n}\n\n/**\n * Restore the font weight unset by the previous rule.\n */\n\noptgroup {\n  font-weight: bold;\n}\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\n\nbutton,\ninput {\n  /* 1 */\n  overflow: visible;\n}\n\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\n\nbutton,\nselect {\n  /* 1 */\n  text-transform: none;\n}\n\n/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */\n\nbutton,\nhtml [type=\"button\"], /* 1 */\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}\n\n/**\n * Remove the inner border and padding in Firefox.\n */\n\nbutton::-moz-focus-inner,\n[type='button']::-moz-focus-inner,\n[type='reset']::-moz-focus-inner,\n[type='submit']::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\n\nbutton:-moz-focusring,\n[type='button']:-moz-focusring,\n[type='reset']:-moz-focusring,\n[type='submit']:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n * Change the border, margin, and padding in all browsers (opinionated).\n */\n\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */\n\nlegend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}\n\n/**\n * Remove the default vertical scrollbar in IE.\n */\n\ntextarea {\n  overflow: auto;\n}\n\n/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */\n\n[type='checkbox'],\n[type='radio'] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n\n[type='number']::-webkit-inner-spin-button,\n[type='number']::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n\n[type='search'] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.\n */\n\n[type='search']::-webkit-search-cancel-button,\n[type='search']::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * Correct the text style of placeholders in Chrome, Edge, and Safari.\n */\n\n::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}\n\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n","@font-face {\n  font-family: 'minecraftiaregular';\n  src: url('fonts/files/minecraftia-regular-webfont.eot');\n  src: url('fonts/files/minecraftia-regular-webfont.eot?#iefix')\n      format('embedded-opentype'),\n    url('fonts/files/minecraftia-regular-webfont.woff2') format('woff2'),\n    url('fonts/files/minecraftia-regular-webfont.woff') format('woff'),\n    url('fonts/files/minecraftia-regular-webfont.ttf') format('truetype'),\n    url('fonts/files/minecraftia-regular-webfont.svg#minecraftiaregular')\n      format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face{\n  font-family: 'Nunito';\n  src: url('fonts/files/Nunito-VariableFont_wght.ttf') format('truetype');\n}\n\n@font-face{\n  font-family: 'pixelify';\n  src: url('fonts/files/PixelifySans-VariableFont_wght.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'WebFontIcons';\n  src: url('fonts/files/webfont-icons.eot?v=4.5.0');\n  src: url('fonts/files/webfont-icons.eot?#iefix&v=4.5.0')\n      format('embedded-opentype'),\n    url('fonts/files/webfont-icons.woff?v=4.5.0') format('woff'),\n    url('fonts/files/webfont-icons.ttf?v=4.5.0') format('truetype'),\n    url('fonts/files/webfont-icons.svg?v=4.5.0#webfonticons') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n/* define a new type 'icon' */\n@mixin icon($icon) {\n  display: inline-block;\n  font: normal normal normal 14px/1 WebFontIcons;\n  font-size: inherit;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  &::before {\n    @if $icon == twitter {\n      content: '\\61';\n    } \n    @if $icon == keybindings {\n      content: '\\62';\n    } \n    @if $icon == play {\n      content: '\\63';\n    } \n    @if $icon == duplicate {\n      content: '\\64';\n    } \n    @if $icon == eraser {\n      content: '\\65';\n    } \n    @if $icon == pause {\n      content: '\\66';\n    } \n    @if $icon == screen-full {\n      content: '\\67';\n    } \n    @if $icon == paint-brush {\n      content: '\\68';\n    } \n    @if $icon == move {\n      content: '\\69';\n    } \n    @if $icon == screen-normal {\n      content: '\\6a';\n    } \n    @if $icon == frames {\n      content: '\\6b';\n    } \n    @if $icon == columns {\n      content: '\\6c';\n    } \n    @if $icon == rows {\n      content: '\\6d';\n    } \n    @if $icon == bucket {\n      content: '\\6e';\n    } \n    @if $icon == eyedropper {\n      content: '\\6f';\n    } \n    @if $icon == undo {\n      content: '\\70';\n    } \n    @if $icon == redo {\n      content: '\\71';\n    } \n    @if $icon == download {\n      content: '\\72';\n    } \n    @if $icon == help {\n      content: '\\73';\n    } \n    @if $icon == trash {\n      content: '\\74';\n    }\n  }\n}\n\n.icon-help {\n  @include icon(help);\n}\n","$font-pixel: 'minecraftiaregular', 'Helvetica Neue Light', 'Helvetica Neue',\n  'Helvetica', 'Arial', sans-serif;\n$font-nunito: 'Nunito', 'Helvetica Neue Light', 'Helvetica Neue', 'Helvetica',\n  'Arial', sans-serif;\n$font-pixelify: 'pixelify', 'Helvetica Neue Light', 'Helvetica Neue',\n  'Helvetica', 'Arial', sans-serif;\n$font-icons: 'WebFontIcons';\n$font-monospace: 'monospace';\n\n$max-width-container: 20em;\n\n$color-scorpion: #585858;\n$color-boulder: #757575;\n$color-dustyGray: #969696;\n$color-silver: #bbb;\n$color-silverChalice: #f5f5f5;\n$color-brandyRose: #b17e7e;\n\n/* Button colors */\n$color-tamarillo: #961818;\n$color-darkTan: #6b1010;\n$color-moccaccino: #741515;\n\n$color-mineShaft: #313131;\n$color-doveGray: #707070;\n$color-tundora: #4b4949;\n\n$color-lotus: #803c3c;\n$color-buccaneer: #733939;\n$color-cowboy: #552a2a;\n\n$color-steelblue: #5786c1;\n$color-sanMarino: #4171ae;\n$color-eastBay: #3a587f;\n\n$color-chathamsBlue: #164075;\n$color-chambray: #2f5382;\n$color-cloudBurst: #253c5a;\n\n$color-shrub: #0e8044;\n\n$color-alto: #e0e0e0;\n$color-silveChalice: #a0a0a0;\n$color-nobel: #b7b7b7;\n\n$color-fern: #349338;\n$color-forestGreen: #2b752b;\n$color-woodland: #2e6a2e;\n\n$color-back-frames: rgba(51, 50, 50, 0.2);\n","/**\n * Tooltip\n */\n\n[data-tooltip] {\n  position: relative;\n  cursor: pointer;\n  text-align: center;\n}\n\n[data-tooltip]::before,\n[data-tooltip]::after {\n  position: absolute;\n  opacity: 0;\n  transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out,\n    transform 0.2s cubic-bezier(0.71, 1.7, 0.77, 1.24);\n  transform: translate3d(0, 0, 0);\n  pointer-events: none;\n  bottom: 100%;\n  left: 50%;\n}\n\n[data-tooltip]::before {\n  z-index: 1001;\n  border: 6px solid transparent;\n  background: transparent;\n  content: '';\n  margin-left: -6px;\n  margin-bottom: -12px;\n  border-top-color: black;\n  border-top-color: #4caf50;\n}\n\n[data-tooltip]::after {\n  z-index: 1000;\n  padding: 8px;\n  width: 160px;\n  background-color: black;\n  background-color: #4caf50;\n  color: white;\n  content: attr(data-tooltip);\n  font-size: 14px;\n  line-height: 1.2;\n  font-weight: normal;\n  margin-left: -80px;\n}\n\n[data-tooltip]:hover::before,\n[data-tooltip]:hover::after,\n[data-tooltip]:focus::before,\n[data-tooltip]:focus::after {\n  visibility: visible;\n  opacity: 1;\n  transform: translateY(-12px);\n}\n","html {\n  box-sizing: border-box;\n  background-color: #515151;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: inherit;\n}\n\nhtml,\nbody {\n  position: relative;\n  font-family: $font-nunito;\n  /* font-weight: 700; */\n}\n\n.main-header{\n  font-family: $font-pixelify;\n  font-size: 1.5em;\n}\n\n.main-title{\n  font-family: $font-pixelify;\n  font-size: 4em!important;\n  font-weight: 400!important;\n}\n\nbody {\n  overflow: auto;\n  /* no background color */\n  background-color: transparent;\n}\n\n.app-container {\n  height: 100%;\n  width: 90%;\n  margin: 0 auto;\n  padding: 0;\n}\n\np{\n  font-size: 1.2em;\n}\n\nh1 {\n  font-size: 2em;\n}\n\n/* h2 {\n  font-size: 0.8em;\n  padding-right: 1em;\n  display: inline;\n  position: relative;\n  top: -0.9em;\n} */\n\nh3 {\n  font-size: 1em;\n}\n\n.block {\n  display: block;\n}\n\n.hidden {\n  display: none;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-2xl {\n  font-size: 1.5rem;\n  line-height: 2rem;\n}\n\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.flex {\n  display: flex;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.flex-col {\n  flex-direction: column;\n}\n\n.flex-row {\n  flex-direction: row;\n}",".clearfix {\n  lost-utility: clearfix;\n}\n\n.col-1-3 {\n  lost-column: 1/3;\n}\n\n.col-2-3 {\n  lost-column: 2/3;\n}\n\n.col-1-2 {\n  lost-column: 1/2;\n}\n\n.col-1-4 {\n  lost-column: 1/4;\n}\n\n.col-2-4 {\n  lost-column: 2/4;\n}\n\n.col-3-4,\n.col-6-8 {\n  lost-column: 3/4;\n}\n\n.col-1-8 {\n  lost-column: 1/8;\n}\n\n.col-7-8 {\n  lost-column: 7/8;\n}\n\n.grid-3 {\n  lost-utility: clearfix;\n\n  & > div {\n    lost-column: 1/3 3 0;\n  }\n}\n\n.grid-4 {\n  lost-utility: clearfix;\n\n  & > div {\n    lost-column: 1/4 4 0;\n  }\n}\n\n.grid-2 {\n  lost-utility: clearfix;\n\n  & > div {\n    lost-column: 1/2 2 0;\n  }\n}\n\n.max-width-container {\n  max-width: $max-width-container;\n}\n\n.max-width-container-centered {\n  max-width: $max-width-container;\n  margin: 0 auto;\n}\n","header {\n  color: $color-silver;\n  lost-utility: clearfix;\n  margin: 1em 0;\n  a {\n    text-decoration: none;\n    color: inherit;\n    &:visited,\n    &:hover,\n    &:active {\n      color: inherit;\n    }\n  }\n  h1 {\n    margin: 0;\n  }\n\n  .header__social {\n    text-align: right;\n\n    .header__credits {\n      font-size: 12px;\n      margin-bottom: 0.2em;\n\n      a {\n        color: $color-silver;\n      }\n\n      span {\n        color: $color-brandyRose;\n      }\n\n      h2 {\n        display: block;\n        font-size: 0.8em;\n        padding-right: 1.3em;\n        position: relative;\n        margin: 0;\n        top: 0;\n      }\n\n      &:hover {\n        img {\n          transform: scale(1.2);\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 460px) {\n  header {\n    .col-2-3,\n    .col-1-3 {\n      lost-column: 1/2;\n    }\n  }\n  h1 {\n    font-size: 1.5em;\n  }\n}\n","@media only screen and (max-width: 1250px) {\n  .app__left-side,\n  .app__right-side {\n    width: 100% !important;\n  }\n\n  .app__central-container{\n    padding: 2em 1em !important;\n  }\n}\n\n@media only screen and (max-width: 780px) {\n  .dimensions {\n    label {\n      font-size: 1.5em !important;\n      top: -0.2em;\n    }\n  }\n\n  .app__central-container{\n    padding: 2em 0em !important;\n  }\n}\n\n@media only screen and (min-width: 730px) {\n  /*\n    Fix small vertical scrollbar glitch for some resolutions\n    inside frames-handler\n    Detected in Chrome\n  */\n  .app__frames-container::-webkit-scrollbar,\n  .app__frames-container div::-webkit-scrollbar {\n    width: 1em !important;\n  }\n}\n\n@media only screen and (max-width: 730px) {\n  .app__main, #app .app__central-container {\n    padding: 1em 0.5em!important;\n  }\n\n  .app__copycss-button {\n    margin-top: 1.4em !important;\n  }\n\n  .app__mobile--container .app__mobile--group {\n    width: 100%!important;\n  }\n\n  .max-width-container-centered {\n    max-width: 100% !important;\n  }\n\n  .app__central-container {\n    .col-1-4 {\n      &.left {\n        lost-column: none;\n\n        .app__copycss-button {\n          padding: 4px !important;\n        }\n\n        .palette-grid {\n          margin: 0;\n        }\n      }\n\n      &.right {\n        lost-column: none;\n      }\n    }\n\n    .col-2-4 {\n      margin-right: 2em!important;\n      margin-left: 2em!important;\n      &.center {\n        lost-column: none;\n\n        .grid-container {\n          margin: 1em auto !important;\n          width: 100%;\n        }\n      }\n    }\n  }\n\n  .app__mobile--container {\n    lost-utility: clearfix;\n\n    .app__mobile--group {\n      lost-column: 1/2;\n    }\n\n    max-width: none;\n  }\n\n  .app__preview-button {\n    margin-top: 1em !important;\n  }\n\n  body {\n    width: 100% !important;\n  }\n\n  /* Avoid button hover effect in mobile devices\n  .undo-redo,\n  .app__load-save-container,\n  .new-project,\n  .frames-handler,\n  .app__right-side {\n    button:hover,\n    button.selected {\n      background-color: $color-mineShaft !important;\n    }\n  } */\n\n  .app__load-save-container{\n    margin-bottom: 5em !important;\n  }\n\n  .undo-redo {\n    margin-top: 1em !important;\n    button {\n      padding:20px !important;\n    }\n  }\n\n  .app__tools-wrapper {\n    margin-top: 2em !important;\n    margin-bottom: 2em !important;\n  }\n\n  .app__social-container {\n    margin-bottom: 0.5em !important;\n  }\n\n  .dimensions{\n    margin-top: 2em !important;\n  }\n\n  .color-cost-info{\n    margin-top:1em !important;\n  }\n\n  .grid-3 > div {\n    width: calc(94% * 1/3);\n  }\n\n  .color-picker{\n    height: 5.8em !important;\n  }\n\n  button.app__copycss-button {\n    &:hover,\n    &.selected {\n      background-color: $color-alto !important;\n    }\n  }\n\n  .app__toggle-help-button {\n    &:hover,\n    &.selected {\n      background-color: $color-chathamsBlue !important;\n    }\n  }\n\n  .load-drawing__import {\n    height: 10em !important;\n  }\n\n  .sidebar{\n    width: 100% !important;\n  }\n\n  .sidebar__button{\n    width: 100% !important;\n  }\n\n  .sidebar__button__palette{\n    width: 100% !important;\n  }\n\n  .edit-this-design{\n    h2{\n      margin:0 10px;\n      font-size: 1.2rem;\n    }\n  }\n\n  .sizing-modal-layout{\n    flex-direction: column !important;\n    flex-direction: column-reverse !important;\n  }\n\n  .sizing-modal-sidebar{\n    flex-direction: row !important;\n    overflow-x: auto !important;\n    padding-bottom: 0 !important;\n    margin-right: 0 !important;\n  }\n\n  .sizing-modal-sidebar-img{\n    margin-right: 10px !important;\n  }\n\n  .sizing-modal-desc{\n    margin-bottom: 0 !important;\n  }\n\n  .sizing-modal-content{\n    max-height: 75% !important;\n  }\n\n  .home-splash-padding{\n    padding-top:120px!important;\n  }\n\n  .main-title{\n    font-size: 3rem !important;\n  }\n\n  .main-paragraph{\n    font-size: 1.2rem !important;\n  }\n\n  .footer-links{\n    /* flex so that it is a row but can wrap */\n    display: flex !important;\n    flex-direction: row !important;\n    flex-wrap: wrap !important;\n    a{\n      font-size: 1rem !important;\n    }\n  }\n\n  .footer{\n    span{\n      font-size: 0.8rem !important;\n    }\n  }\n}\n/* \n@media only screen and (max-width: 360px) {\n  button,\n  .dimensions {\n    font-size: 0.8em !important;\n  }\n\n  .app__central-container{\n    margin: 2em 0em !important;\n  }\n} */\n",null,"@mixin inputText {\n  appearance: none;\n  box-shadow: none;\n  border-radius: none;\n  text-align: center;\n  font-size: 1em;\n  color: $color-silver;\n  border: none;\n  width: 100%;\n  background-color: $color-tundora;\n  transition: background-color 0.3s;\n\n  &:focus {\n    color: $color-mineShaft;\n    background-color: $color-dustyGray;\n    outline: none;\n  }\n}\n\n/* input[type='text'],\ninput[type='number'] {\n  @mixin inputText;\n} */\n\n/* input[type='number'] {\n  -moz-appearance: textfield;\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n} */\n",".cookies-disclaimer {\n  padding: 2em;\n  text-align: left;\n  color: $color-silver;\n  width: 50%;\n  margin: 0 auto;\n  h2 {\n    font-size: 2.5em;\n    top: 0;\n    margin: 1em 0 1.5em 0;\n    display: block;\n    text-align: center;\n    padding: 0;\n  }\n  h3 {\n    font-size: 1.5em;\n  }\n  a {\n    text-decoration: none;\n    color: #78b4ff;\n  }\n  li {\n    list-style-type: none;\n  }\n  ul li:before {\n    content: '•';\n    font-size: 100%;\n    padding-right: 10px;\n  }\n  .art-wrapper {\n    height: 100px;\n    width: 100px;\n    margin: 1em auto;\n  }\n  .pixelart-cookie {\n    box-shadow: 40px 10px 0 #ac7d40, 50px 10px 0 #ac7d40, 60px 10px 0 #332413,\n      70px 10px 0 #eea64b, 30px 20px 0 #ac7d40, 40px 20px 0 #eea64b,\n      50px 20px 0 #eea64b, 60px 20px 0 #eea64b, 70px 20px 0 #eea64b,\n      80px 20px 0 #ac7d40, 20px 30px 0 #ac7d40, 30px 30px 0 #332413,\n      40px 30px 0 #eea64b, 50px 30px 0 #eea64b, 60px 30px 0 #eea64b,\n      70px 30px 0 #332413, 80px 30px 0 #332413, 90px 30px 0 #eea64b,\n      20px 40px 0 #eea64b, 30px 40px 0 #eea64b, 40px 40px 0 #eea64b,\n      50px 40px 0 #332413, 60px 40px 0 #eea64b, 70px 40px 0 #332413,\n      80px 40px 0 #332413, 90px 40px 0 #eea64b, 10px 50px 0 #ac7d40,\n      20px 50px 0 #332413, 30px 50px 0 #eea64b, 40px 50px 0 #eea64b,\n      50px 50px 0 #eea64b, 60px 50px 0 #eea64b, 70px 50px 0 #eea64b,\n      80px 50px 0 #eea64b, 90px 50px 0 #eea64b, 100px 50px 0 #ac7d40,\n      10px 60px 0 #ac7d40, 20px 60px 0 #eea64b, 30px 60px 0 #eea64b,\n      40px 60px 0 #332413, 50px 60px 0 #eea64b, 60px 60px 0 #eea64b,\n      70px 60px 0 #eea64b, 80px 60px 0 #eea64b, 90px 60px 0 #332413,\n      100px 60px 0 #ac7d40, 10px 70px 0 #9a4719, 20px 70px 0 #332413,\n      30px 70px 0 #eea64b, 40px 70px 0 #eea64b, 50px 70px 0 #eea64b,\n      60px 70px 0 #332413, 70px 70px 0 #eea64b, 80px 70px 0 #dc9736,\n      90px 70px 0 #dc9736, 100px 70px 0 #9a4719, 20px 80px 0 #9a4719,\n      30px 80px 0 #dc9736, 40px 80px 0 #dc9736, 50px 80px 0 #dc9736,\n      60px 80px 0 #dc9736, 70px 80px 0 #dc9736, 80px 80px 0 #dc9736,\n      90px 80px 0 #9a4719, 30px 90px 0 #9a4719, 40px 90px 0 #dc9736,\n      50px 90px 0 #dc9736, 60px 90px 0 #dc9736, 70px 90px 0 #332413,\n      80px 90px 0 #9a4719, 40px 100px 0 #9a4719, 50px 100px 0 #9a4719,\n      60px 100px 0 #9a4719, 70px 100px 0 #9a4719;\n    -webkit-box-shadow: 40px 10px 0 #ac7d40, 50px 10px 0 #ac7d40,\n      60px 10px 0 #332413, 70px 10px 0 #eea64b, 30px 20px 0 #ac7d40,\n      40px 20px 0 #eea64b, 50px 20px 0 #eea64b, 60px 20px 0 #eea64b,\n      70px 20px 0 #eea64b, 80px 20px 0 #ac7d40, 20px 30px 0 #ac7d40,\n      30px 30px 0 #332413, 40px 30px 0 #eea64b, 50px 30px 0 #eea64b,\n      60px 30px 0 #eea64b, 70px 30px 0 #332413, 80px 30px 0 #332413,\n      90px 30px 0 #eea64b, 20px 40px 0 #eea64b, 30px 40px 0 #eea64b,\n      40px 40px 0 #eea64b, 50px 40px 0 #332413, 60px 40px 0 #eea64b,\n      70px 40px 0 #332413, 80px 40px 0 #332413, 90px 40px 0 #eea64b,\n      10px 50px 0 #ac7d40, 20px 50px 0 #332413, 30px 50px 0 #eea64b,\n      40px 50px 0 #eea64b, 50px 50px 0 #eea64b, 60px 50px 0 #eea64b,\n      70px 50px 0 #eea64b, 80px 50px 0 #eea64b, 90px 50px 0 #eea64b,\n      100px 50px 0 #ac7d40, 10px 60px 0 #ac7d40, 20px 60px 0 #eea64b,\n      30px 60px 0 #eea64b, 40px 60px 0 #332413, 50px 60px 0 #eea64b,\n      60px 60px 0 #eea64b, 70px 60px 0 #eea64b, 80px 60px 0 #eea64b,\n      90px 60px 0 #332413, 100px 60px 0 #ac7d40, 10px 70px 0 #9a4719,\n      20px 70px 0 #332413, 30px 70px 0 #eea64b, 40px 70px 0 #eea64b,\n      50px 70px 0 #eea64b, 60px 70px 0 #332413, 70px 70px 0 #eea64b,\n      80px 70px 0 #dc9736, 90px 70px 0 #dc9736, 100px 70px 0 #9a4719,\n      20px 80px 0 #9a4719, 30px 80px 0 #dc9736, 40px 80px 0 #dc9736,\n      50px 80px 0 #dc9736, 60px 80px 0 #dc9736, 70px 80px 0 #dc9736,\n      80px 80px 0 #dc9736, 90px 80px 0 #9a4719, 30px 90px 0 #9a4719,\n      40px 90px 0 #dc9736, 50px 90px 0 #dc9736, 60px 90px 0 #dc9736,\n      70px 90px 0 #332413, 80px 90px 0 #9a4719, 40px 100px 0 #9a4719,\n      50px 100px 0 #9a4719, 60px 100px 0 #9a4719, 70px 100px 0 #9a4719;\n    -moz-box-shadow: 40px 10px 0 #ac7d40, 50px 10px 0 #ac7d40,\n      60px 10px 0 #332413, 70px 10px 0 #eea64b, 30px 20px 0 #ac7d40,\n      40px 20px 0 #eea64b, 50px 20px 0 #eea64b, 60px 20px 0 #eea64b,\n      70px 20px 0 #eea64b, 80px 20px 0 #ac7d40, 20px 30px 0 #ac7d40,\n      30px 30px 0 #332413, 40px 30px 0 #eea64b, 50px 30px 0 #eea64b,\n      60px 30px 0 #eea64b, 70px 30px 0 #332413, 80px 30px 0 #332413,\n      90px 30px 0 #eea64b, 20px 40px 0 #eea64b, 30px 40px 0 #eea64b,\n      40px 40px 0 #eea64b, 50px 40px 0 #332413, 60px 40px 0 #eea64b,\n      70px 40px 0 #332413, 80px 40px 0 #332413, 90px 40px 0 #eea64b,\n      10px 50px 0 #ac7d40, 20px 50px 0 #332413, 30px 50px 0 #eea64b,\n      40px 50px 0 #eea64b, 50px 50px 0 #eea64b, 60px 50px 0 #eea64b,\n      70px 50px 0 #eea64b, 80px 50px 0 #eea64b, 90px 50px 0 #eea64b,\n      100px 50px 0 #ac7d40, 10px 60px 0 #ac7d40, 20px 60px 0 #eea64b,\n      30px 60px 0 #eea64b, 40px 60px 0 #332413, 50px 60px 0 #eea64b,\n      60px 60px 0 #eea64b, 70px 60px 0 #eea64b, 80px 60px 0 #eea64b,\n      90px 60px 0 #332413, 100px 60px 0 #ac7d40, 10px 70px 0 #9a4719,\n      20px 70px 0 #332413, 30px 70px 0 #eea64b, 40px 70px 0 #eea64b,\n      50px 70px 0 #eea64b, 60px 70px 0 #332413, 70px 70px 0 #eea64b,\n      80px 70px 0 #dc9736, 90px 70px 0 #dc9736, 100px 70px 0 #9a4719,\n      20px 80px 0 #9a4719, 30px 80px 0 #dc9736, 40px 80px 0 #dc9736,\n      50px 80px 0 #dc9736, 60px 80px 0 #dc9736, 70px 80px 0 #dc9736,\n      80px 80px 0 #dc9736, 90px 80px 0 #9a4719, 30px 90px 0 #9a4719,\n      40px 90px 0 #dc9736, 50px 90px 0 #dc9736, 60px 90px 0 #dc9736,\n      70px 90px 0 #332413, 80px 90px 0 #9a4719, 40px 100px 0 #9a4719,\n      50px 100px 0 #9a4719, 60px 100px 0 #9a4719, 70px 100px 0 #9a4719;\n    height: 10px;\n    width: 10px;\n  }\n  span.highlight {\n    color: $color-brandyRose;\n  }\n}\n\n@media only screen and (max-width: 1200px) {\n  .cookies-disclaimer {\n    width: 80%;\n  }\n}\n\n@media only screen and (max-width: 700px) {\n  .cookies-disclaimer {\n    width: 90%;\n  }\n}\n",".not-found {\n  text-align: center;\n  h2 {\n    font-size: 2.5em;\n    top: 0;\n    margin: 1em 0 1em 0;\n    display: block;\n    text-align: center;\n    padding: 0;\n    color: $color-brandyRose;\n  }\n  a {\n    color: #78b4ff;\n  }\n  .art-wrapper {\n    height: 100px;\n    width: 320px;\n    margin: 1em auto 9em;\n  }\n\n  .pixelart-notfound {\n    position: absolute;\n    animation: notfound 1s infinite;\n    -webkit-animation: notfound 1s infinite;\n    -moz-animation: notfound 1s infinite;\n    -o-animation: notfound 1s infinite;\n  }\n}\n\n@keyframes notfound {\n  0%,\n  25% {\n    box-shadow: 20px 40px 0 0 rgba(187, 187, 187, 1),\n      80px 40px 0 0 rgba(187, 187, 187, 1),\n      140px 40px 0 0 rgba(187, 187, 187, 1),\n      160px 40px 0 0 rgba(187, 187, 187, 1),\n      220px 40px 0 0 rgba(187, 187, 187, 1),\n      280px 40px 0 0 rgba(187, 187, 187, 1),\n      20px 60px 0 0 rgba(187, 187, 187, 1), 80px 60px 0 0 rgba(187, 187, 187, 1),\n      120px 60px 0 0 rgba(187, 187, 187, 1),\n      180px 60px 0 0 rgba(187, 187, 187, 1),\n      220px 60px 0 0 rgba(187, 187, 187, 1),\n      280px 60px 0 0 rgba(187, 187, 187, 1),\n      20px 80px 0 0 rgba(187, 187, 187, 1), 40px 80px 0 0 rgba(187, 187, 187, 1),\n      60px 80px 0 0 rgba(187, 187, 187, 1), 80px 80px 0 0 rgba(187, 187, 187, 1),\n      120px 80px 0 0 rgba(187, 187, 187, 1),\n      180px 80px 0 0 rgba(187, 187, 187, 1),\n      220px 80px 0 0 rgba(187, 187, 187, 1),\n      240px 80px 0 0 rgba(187, 187, 187, 1),\n      260px 80px 0 0 rgba(187, 187, 187, 1),\n      280px 80px 0 0 rgba(187, 187, 187, 1),\n      80px 100px 0 0 rgba(187, 187, 187, 1),\n      120px 100px 0 0 rgba(187, 187, 187, 1),\n      180px 100px 0 0 rgba(187, 187, 187, 1),\n      280px 100px 0 0 rgba(187, 187, 187, 1),\n      80px 120px 0 0 rgba(187, 187, 187, 1),\n      140px 120px 0 0 rgba(187, 187, 187, 1),\n      160px 120px 0 0 rgba(187, 187, 187, 1),\n      280px 120px 0 0 rgba(187, 187, 187, 1);\n    height: 20px;\n    width: 20px;\n  }\n  25.01%,\n  50% {\n    box-shadow: 20px 20px 0 0 rgba(187, 187, 187, 1),\n      80px 20px 0 0 rgba(187, 187, 187, 1), 20px 40px 0 0 rgba(187, 187, 187, 1),\n      80px 40px 0 0 rgba(187, 187, 187, 1),\n      140px 40px 0 0 rgba(187, 187, 187, 1),\n      160px 40px 0 0 rgba(187, 187, 187, 1),\n      220px 40px 0 0 rgba(187, 187, 187, 1),\n      280px 40px 0 0 rgba(187, 187, 187, 1),\n      20px 60px 0 0 rgba(187, 187, 187, 1), 40px 60px 0 0 rgba(187, 187, 187, 1),\n      60px 60px 0 0 rgba(187, 187, 187, 1), 80px 60px 0 0 rgba(187, 187, 187, 1),\n      120px 60px 0 0 rgba(187, 187, 187, 1),\n      180px 60px 0 0 rgba(187, 187, 187, 1),\n      220px 60px 0 0 rgba(187, 187, 187, 1),\n      280px 60px 0 0 rgba(187, 187, 187, 1),\n      80px 80px 0 0 rgba(187, 187, 187, 1),\n      120px 80px 0 0 rgba(187, 187, 187, 1),\n      180px 80px 0 0 rgba(187, 187, 187, 1),\n      220px 80px 0 0 rgba(187, 187, 187, 1),\n      240px 80px 0 0 rgba(187, 187, 187, 1),\n      260px 80px 0 0 rgba(187, 187, 187, 1),\n      280px 80px 0 0 rgba(187, 187, 187, 1),\n      80px 100px 0 0 rgba(187, 187, 187, 1),\n      120px 100px 0 0 rgba(187, 187, 187, 1),\n      180px 100px 0 0 rgba(187, 187, 187, 1),\n      280px 100px 0 0 rgba(187, 187, 187, 1),\n      140px 120px 0 0 rgba(187, 187, 187, 1),\n      160px 120px 0 0 rgba(187, 187, 187, 1),\n      280px 120px 0 0 rgba(187, 187, 187, 1);\n    height: 20px;\n    width: 20px;\n  }\n  50.01%,\n  75% {\n    box-shadow: 140px 20px 0 0 rgba(187, 187, 187, 1),\n      160px 20px 0 0 rgba(187, 187, 187, 1),\n      20px 40px 0 0 rgba(187, 187, 187, 1), 80px 40px 0 0 rgba(187, 187, 187, 1),\n      120px 40px 0 0 rgba(187, 187, 187, 1),\n      180px 40px 0 0 rgba(187, 187, 187, 1),\n      220px 40px 0 0 rgba(187, 187, 187, 1),\n      280px 40px 0 0 rgba(187, 187, 187, 1),\n      20px 60px 0 0 rgba(187, 187, 187, 1), 80px 60px 0 0 rgba(187, 187, 187, 1),\n      120px 60px 0 0 rgba(187, 187, 187, 1),\n      180px 60px 0 0 rgba(187, 187, 187, 1),\n      220px 60px 0 0 rgba(187, 187, 187, 1),\n      280px 60px 0 0 rgba(187, 187, 187, 1),\n      20px 80px 0 0 rgba(187, 187, 187, 1), 40px 80px 0 0 rgba(187, 187, 187, 1),\n      60px 80px 0 0 rgba(187, 187, 187, 1), 80px 80px 0 0 rgba(187, 187, 187, 1),\n      120px 80px 0 0 rgba(187, 187, 187, 1),\n      180px 80px 0 0 rgba(187, 187, 187, 1),\n      220px 80px 0 0 rgba(187, 187, 187, 1),\n      240px 80px 0 0 rgba(187, 187, 187, 1),\n      260px 80px 0 0 rgba(187, 187, 187, 1),\n      280px 80px 0 0 rgba(187, 187, 187, 1),\n      80px 100px 0 0 rgba(187, 187, 187, 1),\n      140px 100px 0 0 rgba(187, 187, 187, 1),\n      160px 100px 0 0 rgba(187, 187, 187, 1),\n      280px 100px 0 0 rgba(187, 187, 187, 1),\n      80px 120px 0 0 rgba(187, 187, 187, 1),\n      280px 120px 0 0 rgba(187, 187, 187, 1);\n    height: 20px;\n    width: 20px;\n  }\n  75.01%,\n  100% {\n    box-shadow: 220px 20px 0 0 rgba(187, 187, 187, 1),\n      280px 20px 0 0 rgba(187, 187, 187, 1),\n      20px 40px 0 0 rgba(187, 187, 187, 1), 80px 40px 0 0 rgba(187, 187, 187, 1),\n      140px 40px 0 0 rgba(187, 187, 187, 1),\n      160px 40px 0 0 rgba(187, 187, 187, 1),\n      220px 40px 0 0 rgba(187, 187, 187, 1),\n      280px 40px 0 0 rgba(187, 187, 187, 1),\n      20px 60px 0 0 rgba(187, 187, 187, 1), 80px 60px 0 0 rgba(187, 187, 187, 1),\n      120px 60px 0 0 rgba(187, 187, 187, 1),\n      180px 60px 0 0 rgba(187, 187, 187, 1),\n      220px 60px 0 0 rgba(187, 187, 187, 1),\n      240px 60px 0 0 rgba(187, 187, 187, 1),\n      260px 60px 0 0 rgba(187, 187, 187, 1),\n      280px 60px 0 0 rgba(187, 187, 187, 1),\n      20px 80px 0 0 rgba(187, 187, 187, 1), 40px 80px 0 0 rgba(187, 187, 187, 1),\n      60px 80px 0 0 rgba(187, 187, 187, 1), 80px 80px 0 0 rgba(187, 187, 187, 1),\n      120px 80px 0 0 rgba(187, 187, 187, 1),\n      180px 80px 0 0 rgba(187, 187, 187, 1),\n      280px 80px 0 0 rgba(187, 187, 187, 1),\n      80px 100px 0 0 rgba(187, 187, 187, 1),\n      120px 100px 0 0 rgba(187, 187, 187, 1),\n      180px 100px 0 0 rgba(187, 187, 187, 1),\n      280px 100px 0 0 rgba(187, 187, 187, 1),\n      80px 120px 0 0 rgba(187, 187, 187, 1),\n      140px 120px 0 0 rgba(187, 187, 187, 1),\n      160px 120px 0 0 rgba(187, 187, 187, 1);\n    height: 20px;\n    width: 20px;\n  }\n}\n",".active-palette-selected{\n    transform: translate(0, 5px);\n    box-shadow: 0 1px 0 #4b4949!important;\n    background-color: #141414!important;\n    box-shadow: 0 0 0 2px #bbb!important;\n    color: #fff!important;\n    svg{\n        fill: #fff!important;\n    }\n    \n}\n\n.active-palette-buttons-disabled{\n    pointer-events: none;\n    opacity: 0.5;\n}\n\n.delete-active-palette {\n    width: 40px;\n    /* margin-top: 20px;\n    \n    margin-top: 0!important;\n    margin-bottom: 0.8em!important; */\n    \n  \n    background: none;\n    border: none;\n    outline: none;\n    border-radius: 2px;\n    font-size: 1em;\n    text-decoration: none;\n    transition-duration: 0.1s;\n    color: #bbb;\n    background-color: #313131;\n    box-shadow: 0 5px 0 0 #707070;\n    height: 40px;\n    padding: 0px!important;\n\n    div{\n        display: flex;\n        justify-content: center;\n        height: 100%;\n        width: 100%;\n        align-items: center;\n    }\n\n    /* display: flex;\n    align-items: center;\n    \n    justify-content: center; */\n    \n\n    &:active{\n        transform: translate(0, 5px);\n        box-shadow: 0 1px 0 #4b4949;\n        background-color: #4b4949;\n    }\n\n    \n\n    &:hover{\n        background-color: #413f3f;\n    }\n\n    svg{\n        height: 20px;\n        width: 20px;\n        fill: #bbb;\n        padding: 0px!important;\n    }\n  }\n\n.eyedropper-active-palette {\n    width: 40px;\n    display: table;\n    margin-top: 20px;\n    margin-top: 0!important;\n    margin-bottom: 0.8em!important;\n    margin-right: 0.5em!important;\n\n    @include icon(eyedropper);\n  \n    background: none;\n    border: none;\n    outline: none;\n    border-radius: 2px;\n    padding: 12px;\n    font-size: 1em;\n    text-decoration: none;\n    transition-duration: 0.1s;\n    color: #bbb;\n    background-color: #313131;\n    box-shadow: 0 5px 0 0 #707070;\n\n    &:active{\n        transform: translate(0, 5px);\n        box-shadow: 0 1px 0 #4b4949;\n        background-color: #4b4949;\n    }\n\n    &:hover{\n        background-color: #413f3f;\n    }\n\n  }",".border-color-picker{\n    input{\n        width: 36px;\n        height: 36px;\n    }\n}",".grid-container {\n  lost-utility: clearfix;\n  line-height: 0;\n  min-height: 1px;\n  margin: 0 auto;\n  width: 90%;\n  border: 1px solid #272727;\n  border-width: 1px 0 0 1px;\n\n\n  div {\n    float: left;\n    border: 1px solid #272727;\n    border-width: 0 1px 1px 0;\n  }\n\n  &.cell {\n    cursor: cell;\n  }\n\n  &.context-menu {\n    cursor: context-menu;\n  }\n\n  &.copy {\n    cursor: copy;\n  }\n\n  &.all-scroll {\n    cursor: all-scroll;\n  }\n}\n",".simple-notification {\n  background-color: #313131;\n  color: $color-silver;\n  width: 250px;\n  text-align: center;\n  padding: 1em;\n  position: fixed;\n  z-index: 1;\n  left: 50%;\n  margin-left: -125px;\n  top: 1em;\n  border: 1px solid orange;\n}\n\n/* ReactCSSTransitionGroup related rules */\n.simple-notification-enter {\n  opacity: 0.01;\n}\n\n.simple-notification-enter.simple-notification-enter-active {\n  opacity: 1;\n  transition: opacity 1000ms ease-in;\n}\n\n.simple-notification-exit {\n  opacity: 1;\n}\n\n.simple-notification-exit.simple-notification-exit-active {\n  opacity: 0.01;\n  transition: opacity 1000ms ease-out;\n}\n",".simple-spinner {\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n  height: 100%;\n  background-color: black;\n  opacity: 0.4;\n  top: 0;\n  display: none;\n\n  &.display {\n    display: block;\n  }\n\n  .circle {\n    height: 60px;\n    width: 60px;\n    margin: 94px auto 0;\n    position: fixed;\n    animation: spin-rotation 0.6s infinite linear;\n    border-left: 6px solid rgba(119, 239, 50, 0.726);\n    border-right: 6px solid rgba(28, 121, 228, 0.733);\n    border-bottom: 6px solid rgba(226, 26, 42, 0.664);\n    border-top: 6px solid rgba(219, 109, 26, 1);\n    border-radius: 100%;\n    top: 50%;\n    left: 50%;\n    margin-top: -30px;\n    margin-left: -30px;\n  }\n}\n\n@keyframes spin-rotation {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(359deg);\n  }\n}\n\n.simple-spinner-card {\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n  height: 100%;\n  background-color: black;\n  opacity: 0.4;\n  top: 0;\n  display: none;\n\n  &.display {\n    display: block;\n  }\n\n  .circle {\n    height: 60px;\n    width: 60px;\n    margin: 94px auto 0;\n    position: absolute;\n    animation: spin-rotation 0.6s infinite linear;\n    border-left: 6px solid rgba(119, 239, 50, 0.726);\n    border-right: 6px solid rgba(28, 121, 228, 0.733);\n    border-bottom: 6px solid rgba(226, 26, 42, 0.664);\n    border-top: 6px solid rgba(219, 109, 26, 1);\n    border-radius: 100%;\n    top: 50%;\n    left: 50%;\n    margin-top: -30px;\n    margin-left: -30px;\n  }\n}",".load-drawing {\n  text-align: center;\n  h2 {\n    padding: 2em 0 0;\n    margin-bottom: 0;\n    font-size: 1.2em;\n    text-align: center;\n\n    display: flex;\n    flex-direction: column;\n    overflow: auto;\n    min-width: auto;\n  }\n\n  .load-drawing__container {\n    overflow: auto;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    text-align: center;\n\n    &.empty {\n      overflow-y: hidden;\n      display: block;\n    }\n\n    .load-drawing__drawing {\n      position: relative;\n      border: 3px solid black;\n      cursor: pointer;\n      flex: 0 1 auto;\n      margin: 0.5em;\n      padding-right: 2em;\n\n      .drawing__delete {\n        @include icon(trash);\n\n        position: absolute;\n        font-size: 1.7em;\n        color: white;\n        top: 0;\n        right: 0;\n        cursor: no-drop;\n        padding: 0.1em;\n        background-color: $color-mineShaft;\n        border: 2px solid black;\n        border-width: 0 0 2px 2px;\n      }\n\n      .preview {\n        margin: 0 auto;\n      }\n    }\n  }\n\n  .load-drawing__export {\n    overflow-x: scroll;\n    width: 100%;\n    margin: 0 auto;\n    background-color: $color-mineShaft;\n    color: $color-silver;\n    padding: 0.5em;\n    text-align: left;\n  }\n\n  .load-drawing__import {\n    font-family: $font-monospace;\n    display: block;\n    width: 90%;\n    resize: none;\n    height: 6em;\n    margin: 0 auto;\n    padding: 0.5em;\n    background-color: $color-mineShaft;\n    color: $color-silver;\n  }\n\n  .import__button {\n    @include button(red);\n\n    margin: 1.5em auto;\n    display: table;\n  }\n}\n\n.import-your-own-container{\n  max-width: 500px;\n  margin:0 auto;\n  text-align: center;\n  padding: 0 20px;\n}\n\n.close-import-file-container{\n  margin-top: 20px;\n  margin-left: 40px;\n  text-align: left;\n}\n\n.close-import-file{\n  padding-left:20px!important;\n  padding-right:20px!important;\n}\n\n.canvas-preview{\n  border-radius: 10px;\n  box-shadow: 0 0 10px rgba(0,0,0,0.5);\n  border: 3px solid #252525;\n}\n\n.import-button{\n  padding-top:6px!important;\n  padding-bottom:8px!important;\n  padding-left:10px!important;\n  padding-right:10px!important;\n  span{\n    font-size:1.2rem!important;\n    padding: 0 10px!important;\n  }\n  \n  @include button(green);\n}\n\n.palette-select{\n  max-width: 400px;\n  margin:auto;\n  label{\n    display: block;\n    text-align: center;\n    margin: 0px;\n    font-size: 1.1rem;\n    top: 0px;\n    color: whitesmoke;\n  }\n}\n\n/* animation that slides in from right */\n.slide-in-right{\n  animation: slide-in-right 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s 1 normal forwards;\n}\n\n@keyframes slide-in-right {\n  0% {\n    transform: translateX(100%);\n  }\n  100% {\n    transform: translateX(0%);\n  }\n}\n\n\n.sidebar{\n  background-color: rgb(89 89 89);\n  border-bottom-color: rgb(49 49 49);\n  border-bottom-style: solid;\n  border-bottom-width: 0px;\n  border-left-color: rgb(49 49 49);\n  border-left-style: solid;\n  border-left-width: 1px;\n  border-right-color: rgb(49 49 49);\n  border-right-style: solid;\n  border-right-width: 0px;\n  border-top-color: rgb(49 49 49);\n  border-top-style: solid;\n  border-top-width: 0px;\n  box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.1) 0px 4px 6px -4px;\n  box-sizing: border-box;\n  color: rgb(249, 249, 251);\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  line-height: 24px;\n  overflow-y: scroll;\n  padding-bottom: 24px;\n  padding-left: 24px;\n  padding-right: 24px;\n  padding-top: 24px;\n  position: fixed;\n  right: 0px;\n  tab-size: 4;\n  text-size-adjust: 100%;\n  top: 0px;\n  transform: matrix(1, 0, 0, 1, 0, 0);\n  transition-duration: 0.2s;\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  width: auto;\n  z-index: 50;\n}\n\n.sidebar__button{\n  @include button(gray);\n  width: 14rem;\n}\n\n.sidebar__button__palette{\n  @include button(gray);\n  width: 14rem;\n  margin-top: 1.5rem;\n  border-radius: 10px!important;\n  padding-top: 0;\n  padding-left: 0;\n  padding-right: 0;\n  overflow: hidden;\n}\n\n\n.color-div{\n  height:30px;\n  /* flex all colors within the row evenly */\n  flex: 1 1 auto;\n}\n\n.palette-select__button{\n  @include button(gray);\n\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n  padding-top:6px!important;\n  padding-bottom:8px!important;\n  padding-left:10px!important;\n  padding-right:10px!important;\n  span{\n    font-size:1.2rem!important;\n    padding: 0 10px!important;\n  }\n}\n\n.palette-select__button--disabled{\n  @include button(gray);\n\n  padding-top:6px!important;\n  padding-bottom:8px!important;\n  padding-left:10px!important;\n  padding-right:10px!important;\n  span{\n    font-size:1.2rem!important;\n    padding: 0 10px!important;\n  }\n  cursor: not-allowed;\n  opacity: 0.5;\n  pointer-events: none;\n\n  &:hover{\n    background-color: #313131!important;\n    cursor: not-allowed;\n    pointer-events: none;\n  }\n}\n\n.palette-select__radio{\n  cursor: pointer;\n  input{\n    cursor: pointer;\n    margin-right: 5px;\n  }\n  label{\n    cursor: pointer;\n  }\n}\n\n.selected-palette{\n  max-width: 400px;\n  margin:auto;\n  padding-top: 0.5rem;\n}","@mixin generate-button($color-text, $color-bg, $color-boxshadow, $color-bg-active) {\n  background: none;\n  border: none;\n  outline: none;\n  border-radius: 2px;\n  padding: 10px;\n  font-size: 1.2em;\n  text-decoration: none;\n  transition-duration: 0.1s;\n  color: $color-text;\n  background-color: $color-bg;\n  box-shadow: 0 5px 0 0 $color-boxshadow;\n\n  &:hover,\n  &.selected {\n    background-color: $color-bg-active;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  &:active {\n    transform: translate(0, 5px);\n    box-shadow: 0 1px 0 $color-bg-active;\n    background-color: $color-bg-active;\n  }\n}\n\n@mixin button($color) {\n  @if $color == red {\n    @include generate-button($color-silver, $color-tamarillo, $color-darkTan, $color-moccaccino)\n  }\n\n  @if $color == gray {\n    @include generate-button($color-silver, $color-mineShaft, $color-doveGray, $color-tundora)\n  }\n\n  @if $color == brown {\n    @include generate-button($color-silver, $color-lotus, $color-buccaneer, $color-cowboy)\n  }\n\n  @if $color == blue {\n    @include generate-button($color-silver, $color-steelblue, $color-sanMarino, $color-eastBay)\n  }\n\n  @if $color == darkblue {\n    @include generate-button($color-silver, $color-chathamsBlue, $color-chambray, $color-cloudBurst)\n  }\n\n  @if $color == white {\n    @include generate-button(black, $color-alto, $color-silveChalice, $color-nobel)\n  }\n\n  @if $color == green {\n    @include generate-button($color-silverChalice, $color-fern, $color-forestGreen, $color-woodland)\n  }\n}\n",".save-drawing {\n  button {\n    @include button(gray);\n\n    width: 100%;\n  }\n}\n",".new-project {\n  button {\n    @include button(gray);\n\n    width: 100%;\n    padding: 0.5em;\n    margin-bottom: 0.6em;\n  }\n}\n",".undo-redo {\n  lost-utility: clearfix;\n\n  button {\n    @include button(gray);\n\n    lost-column: 1/2 0 0.5em;\n    font-size: 1.2em;\n  }\n\n  .undo-redo__icon--undo {\n    @include icon(undo);\n\n    display: block;\n  }\n\n  .undo-redo__icon--redo {\n    @include icon(redo);\n\n    display: block;\n  }\n}\n","#app {\n  .app__main-container,\n  .app__central-container {\n    lost-utility: clearfix;\n  }\n\n  .app__background {\n    /* background-color: $color-scorpion; */\n  background-image: radial-gradient(#434343 2px, transparent 2px),radial-gradient(#515151 2px, transparent 2px);\n  background-color: #515151;\n  background-position: 0 0,50px 50px;\n  background-size: 20px 20px;\n  background-repeat: repeat;\n  min-height: 95vh;\n  }\n\n  .app__main,\n  .app__central-container {\n    padding: 2em 3em;\n  }\n\n  .app__frames-container {\n    margin-bottom: 1em;\n  }\n\n  .app__frames-container[data-tooltip]::after {\n    width: 80%;\n    margin-left: -40%;\n  }\n\n  .app__load-save-container {\n    margin-bottom: 2em;\n\n    .app__load-button {\n      @include button(gray);\n    }\n\n    lost-utility: clearfix;\n\n    > div,\n    > button {\n      lost-column: 995/2000 0 0.5em;\n    }\n  }\n\n  .app__social-container {\n    .app__tour-button {\n      @include button(darkblue);\n\n      width: 100%;\n      /* margin-top: 1em; */\n    }\n\n    .app__download-button {\n      @include button(brown);\n      /* @include icon(download); */\n\n      width: 100%;\n      /* margin-top: 1em; */\n    }\n  }\n\n  .app__help-container {\n    lost-utility: clearfix;\n    margin: 1em 0;\n\n    > div {\n      lost-column: 1/2 0 0.5em;\n    }\n\n    .app__toggle-help-button {\n      @include button(darkblue);\n      @include icon(help);\n\n      &.selected {\n        box-shadow: 0 0 0 2px $color-silver;\n      }\n\n      width: 100%;\n    }\n\n    .app__shortcuts-button {\n      @include button(darkblue);\n      @include icon(keybindings);\n\n      width: 100%;\n    }\n  }\n\n  .app__copycss-button {\n    @include button(white);\n\n    width: 100%;\n    margin-top: 1em;\n    font-weight: bold !important;\n    color: $color-mineShaft;\n  }\n\n  .app__preview-button {\n    @include button(gray);\n\n    width: 100%;\n    margin: 0 0 0.6em;\n    display: table;\n  }\n\n  .app__tools-wrapper {\n    text-align: center;\n    margin: 1em 0 0.6em;\n\n    > div {\n      button {\n        font-size: 1.8em;\n        text-align: center;\n        color: $color-mineShaft;\n        padding: 0.4em 0;\n        width: 100%;\n        border: none;\n        background-color: transparent;\n        transition: background-color 0.1s ease-in-out;\n\n        &:focus {\n          outline: 0;\n        } \n\n        &:hover {\n          background-color: #616161;\n        }\n\n        &.selected {\n          color: $color-silver;\n          background-color: $color-mineShaft;\n\n          & > div {\n            background-color: $color-mineShaft;\n          }\n        }\n      }\n    }\n  }\n\n  .app__left-side,\n  .app__right-side {\n    width: 80%;\n  }\n\n  .app__right-side {\n    margin-left: auto;\n    margin-right: 0;\n  }\n}\n\n.mobile-button{\n\n  border: 2px solid #2d2d2d !important;\n  margin: 1% !important;\n\n  button{\n    padding:30px !important;\n  }\n  \n}\n\n.mobile-button-no-border{\n  border: none !important;\n  margin: 1% !important;\n  button{\n    padding:30px !important;\n  }\n}",".reset {\n  width: 100%;\n  margin: 0.5em auto;\n  display: table;\n\n  @include button(gray);\n}\n",".radio-selector {\n  border: none;\n  text-align: center;\n  margin: 0 auto;\n\n  label {\n    span {\n      padding: 0.6em 1em;\n      border: 1px solid $color-scorpion;\n      transition: all 0.3s;\n    }\n\n    input {\n      display: none;\n\n      &:checked + span {\n        color: white;\n        background-color: black;\n      }\n\n      &:not(:checked) + span {\n        &:hover {\n          box-shadow: 0 0 0 2px $color-scorpion inset;\n        }\n      }\n    }\n\n    margin: 0 0.5em;\n  }\n}\n",".palette-grid {\n  lost-utility: clearfix;\n  text-align: center;\n  margin: 0.5em 0;\n}\n\n.active-palette-grid{\n  lost-utility: clearfix;\n  border: 3px solid #757575;\n  background-color: #4b4949;\n  text-align: center;\n  margin: 0.5em 0;\n  padding:10px;\n  p{\n    color: #bbbbbb;\n    padding-bottom: 0;\n    margin-bottom: 0;\n  }\n}\n\n.active-palette{\n  display: inline-block;\n  width: 100%;\n}\n\n.border-checkbox{\n  margin-top: 10px;\n  margin-left: 10px;\n  margin-right: 10px;\n  input{\n    cursor: pointer;\n  }\n  label{\n    cursor: pointer;\n    color: #bbbbbb;\n    font-size: 1.1rem;\n    padding-left: 5px;\n    /* do not allow text selection */\n    -webkit-touch-callout: none; /* iOS Safari */\n      -webkit-user-select: none; /* Safari */\n       -khtml-user-select: none; /* Konqueror HTML */\n         -moz-user-select: none; /* Firefox */\n          -ms-user-select: none; /* Internet Explorer/Edge */\n              user-select: none; /* Non-prefixed version, currently\n                                    supported by Chrome and Opera */\n  }\n\n}\n\n.border-color-select{\n  cursor: pointer;\n}\n\n.border-color-mode{\n  padding-bottom: 10px;\n\n  label{\n    color: #bbbbbb;\n    font-size: 1rem;\n    padding-left: 5px;\n    /* do not allow text selection */\n    -webkit-touch-callout: none; /* iOS Safari */\n      -webkit-user-select: none; /* Safari */\n       -khtml-user-select: none; /* Konqueror HTML */\n         -moz-user-select: none; /* Firefox */\n          -ms-user-select: none; /* Internet Explorer/Edge */\n              user-select: none; /* Non-prefixed version, currently\n                                    supported by Chrome and Opera */\n    cursor: pointer;\n  }\n  input{\n    cursor: pointer;\n  }\n\n  .active{\n    color: #bbbbbb;\n  }\n  .not-active{\n    color: #9c9c9c;\n  }\n}\n\n.color-cost-info{\n  margin-top: 10px;\n  margin-bottom: 20px;\n  background-color: #4b4949;\n  color: #bbbbbb;\n  border: 3px solid #757575;\n  padding: 10px 15px;\n  padding-bottom: 0;\n  padding-top: 12px;\n  font-size: 0.9rem;\n  p{\n    margin-bottom: 8px;\n  }\n}\n\n.additional-cost-notice{\n  background-color: #313131;\n  color: #bbbbbb;\n  border: 3px solid #757575;\n  padding: 10px 15px;\n  padding-bottom: 10px;\n  padding-top: 15px;\n  margin-top: 20px;\n  p{\n    margin-bottom: 0;\n  }\n}\n\n.warning-text{\n  color: #e6e6e6;\n}",".palette-color {\n  float: left;\n  border: 2px solid $color-scorpion;\n  border-width: 2px;\n\n  &.selected {\n    border-color: white;\n  }\n}\n",".modal {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow-x: hidden;\n  .modal__header {\n    text-align: right;\n    padding-bottom: 1em;\n    button.close {\n      @include button(blue);\n      padding: 0.4em 0.7em 0.3em 0.8em;\n    }\n  }\n  .product {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    max-height: 800px;\n    img {\n      max-height: 800px;\n    }\n  }\n  .modal__body {\n    overflow: auto;\n  }\n  .modal__preview,\n  .modal__load {\n    .modal__preview--wrapper {\n      margin: 1em auto;\n      display: table;\n    }\n  }\n\n  .modal__load,\n  .modal__preview,\n  .modal__body {\n    fieldset {\n      padding: 1em 0;\n\n      label {\n        margin: 1em 0.5em;\n        display: inline-block;\n      }\n    }\n  }\n}\n\n.ReactModal__Overlay {\n  display:flex;\n  align-items: center;\n  justify-content: center;\n}",".frames-handler {\n  lost-utility: clearfix;\n\n  .frames-handler__add {\n    @include button(gray);\n\n    height: 86px;\n    float: left;\n  }\n\n  .frame-handler__list {\n    display: flex;\n    background-color: $color-back-frames;\n    padding: 0.2em;\n\n    .list__container {\n      height: 85px;\n      display: flex;\n      flex-wrap: nowrap;\n      padding-bottom: 0.5em;\n    }\n  }\n}\n",".frame {\n  border: 1px solid $color-mineShaft;\n  background-color: $color-silver;\n  color: white;\n  width: 70px;\n  height: 84px;\n  margin: 0 0.3em;\n  flex: 0 0 auto;\n  position: relative;\n  overflow: hidden;\n  opacity: 0.4;\n\n  .delete,\n  .duplicate {\n    position: absolute;\n    color: white;\n    right: 0;\n    background-color: $color-mineShaft;\n    border: 1px solid $color-tundora;\n    padding: 0.1em;\n  }\n\n  .delete {\n    @include icon(trash);\n\n    font-size: 1.2em;\n    top: 0;\n    border-width: 0 0 2px 2px;\n  }\n\n  .duplicate {\n    @include icon(duplicate);\n\n    bottom: 23px;\n    border-width: 2px 0 0 2px;\n  }\n\n  .frame__percentage {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    height: 23px;\n    border-top: 2px solid $color-tundora;\n  }\n\n  &.active {\n    border: 2px solid $color-tamarillo;\n    opacity: 1;\n\n    .delete {\n      cursor: no-drop;\n    }\n\n    .duplicate {\n      cursor: copy;\n    }\n\n    .delete,\n    .duplicate {\n      border-color: $color-tamarillo;\n    }\n\n    .frame__percentage {\n      border-color: $color-tamarillo;\n    }\n  }\n}\n",".embroider {\n    width: 100%;\n    margin: 0.5em auto;\n    display: table;\n    margin-top: 20px;\n  \n    @include button(green);\n  }\n  \n  .download-pes {\n    width: 100%;\n    margin: 0.5em auto;\n    display: table;\n    margin-top: 20px;\n  \n    @include button(red);\n  }",".eyedropper {\n  @include icon(eyedropper);\n\n  &:hover {\n    cursor: pointer;\n  }\n}\n",".trash-icon-btn{\n    display: flex;\n    align-items: center;\n    height: 100%;\n    justify-content: center;\n    svg{\n        fill: #313131;\n        width: 25px;\n    }\n    &.selected svg{\n        fill: #bbb;\n    }\n}\n    ",".eraser {\n  @include icon(eraser);\n\n  &:hover {\n    cursor: pointer;\n  }\n}\n",".bucket {\n  @include icon(bucket);\n\n  &:hover {\n    cursor: pointer;\n  }\n}\n",".useful-data {\n  text-align: center;\n  .useful-data__rows {\n    border: none;\n    background-color: $color-alto;\n    padding: 1em 0;\n    .checkbox {\n      padding: 0.4em 0;\n    }\n  }\n  .useful-data__export {\n    font-family: $font-monospace;\n    overflow-x: hidden;\n    margin: 1em auto;\n    background-color: $color-mineShaft;\n    color: $color-silver;\n    padding: 0.5em;\n    text-align: left;\n    display: block;\n    width: 100%;\n    resize: none;\n    height: 20em;\n  }\n  .useful-data__options {\n    lost-utility: clearfix;\n    fieldset.useful-data__rows,\n    .useful-data__output {\n      lost-column: 1/2 0 0;\n    }\n    fieldset.useful-data__rows {\n      lost-utility: clearfix;\n      margin: 0;\n      height: 20em;\n      .useful-data__pixel-format,\n      .useful-data__reverse-rows {\n        lost-column: 1/2 0 0;\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 730px) {\n  .useful-data {\n    .useful-data__options {\n      fieldset.useful-data__rows,\n      .useful-data__output {\n        lost-column: 1/1;\n      }\n      fieldset.useful-data__rows {\n        height: auto;\n        .useful-data__pixel-format,\n        .useful-data__reverse-rows {\n          lost-column: 1/1;\n        }\n      }\n    }\n  }\n}\n",".output {\n  position: relative;\n  text-align: center;\n  .copy-to-clipboard__container {\n    position: absolute;\n    left: 0;\n    top: 0;\n    button.copy-to-clipboard {\n      @include button(brown);\n      padding: 0.1em 0.4em 0em 0.5em;\n      margin: 0.5em 0.5em 0;\n    }\n    span {\n      background-color: $color-shrub;\n      color: white;\n      padding: 0.1em 1.6em;\n      display: none;\n      &.show {\n        display: inline;\n      }\n    }\n  }\n  .output__text {\n    font-family: $font-monospace;\n    overflow-x: auto;\n    background-color: $color-mineShaft;\n    color: $color-silver;\n    padding: 3em 0.5em 0;\n    text-align: left;\n    display: block;\n    width: 100%;\n    resize: none;\n    height: 20em;\n  }\n  .output__pre {\n    white-space: pre;\n  }\n}\n",".checkbox {\n  border: none;\n  text-align: center;\n  margin: 0 auto;\n  padding: 1em 0;\n\n  label {\n    span {\n      padding: 0.6em 1em;\n      transition: all 0.3s;\n    }\n\n    input {\n      display: none;\n\n      &:checked + span {\n        color: white;\n        background-color: black;\n      }\n\n      &:not(:checked) + span {\n        &:hover {\n          box-shadow: 0 0 0 2px $color-scorpion inset;\n        }\n      }\n    }\n\n    margin: 0 0.5em;\n  }\n}\n",".move {\n  @include icon(move);\n\n  &:hover {\n    cursor: pointer;\n  }\n}\n",".download-btn {\n  @include button(brown);\n\n  margin: 1.5em auto;\n  display: table;\n}\n",".dimensions {\n  margin: 1em 0 0;\n  padding: 0.5em 0;\n}\n",".picker {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n\n  label.picker__columns {\n    @include icon(columns);\n  }\n\n  label.picker__rows {\n    @include icon(rows);\n  }\n\n  label.picker__columns,\n  label.picker__rows {\n    display: flex;\n    flex: 0 0 100%;\n  }\n\n  label {\n    flex: 1;\n    font-size: 2em !important;\n    color: $color-mineShaft;\n    position: relative;\n    margin: 0 auto;\n    text-align: center;\n\n    &::before {\n      display: inline-block;\n      width: 1.2em;\n      text-align: left;\n    }\n  }\n\n  .picker__container,\n  label {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .picker__value,\n  .picker__buttons {\n    flex: 1;\n    font-family: $font-nunito;\n    font-weight: 700;\n    font-size: 1.1em;\n  }\n\n  .picker__container {\n    /* font-family: $font-pixel; */\n    font-size: 16px;\n    color: $color-silver;\n    background-color: $color-tundora;\n    border: 3px solid $color-boulder;\n    flex: 1;\n\n    button {\n      color: $color-silver;\n      background-color: $color-mineShaft;\n      border: none;\n      outline: none;\n      display: block;\n      width: 100%;\n      height: 2em;\n      border-left: 3px solid $color-boulder;\n    }\n\n    button:hover {\n      background-color: $color-tundora;\n    }\n\n    .button-add {\n      border-bottom: 1px solid $color-boulder;\n    }\n\n    .picker-disabled {\n      opacity: 0.5;\n    }\n\n    .picker-disabled:hover {\n      background-color: $color-mineShaft;\n    }\n  }\n}\n",".cell-size {\n  border: 3px solid $color-boulder;\n  background-color: $color-mineShaft;\n  color: $color-silver;\n  text-align: center;\n\n  label,\n  input {\n    padding-top: 0.2em;\n  }\n\n  label {\n    display: block;\n  }\n}\n",".css-display {\n  position: absolute;\n  top: -1.6em;\n  left: 0;\n  opacity: 0.1;\n  z-index: -1;\n  padding: 1em;\n  margin-top: 1em;\n  color: black;\n  user-select: none;\n  font-size: 0.8em;\n}\n",".copy-css {\n  h2 {\n    padding: 2em 0 1em;\n    margin-bottom: 0;\n    font-size: 1em;\n    display: block;\n    text-align: center;\n\n    span {\n      color: $color-tamarillo;\n    }\n  }\n\n  .copy-css__string {\n    overflow-x: scroll;\n    background-color: $color-mineShaft;\n    color: $color-silver;\n    padding: 0.5em;\n    text-align: left;\n  }\n}\n",".color-picker {\n  .color-picker__button {\n    @include icon(paint-brush);\n\n    display: block;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  height: 3.2em;\n  border: none;\n  \n  input{\n    height: 100%;\n    width: 100%;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    border-radius: 0;\n  }\n\n  button{\n    padding: 0!important;\n    height: 100%;\n    background-color: transparent!important;\n  }\n\n  \n}\n",".duration {\n  margin-top: 1em;\n  border: 3px solid $color-boulder;\n  background-color: $color-mineShaft;\n  color: $color-silver;\n  text-align: center;\n\n  label,\n  input {\n    padding-top: 0.2em;\n  }\n\n  label {\n    display: block;\n  }\n}\n",".cellinfo {\n  color: $color-silver;\n  text-align: center;\n  margin-top: 0.5em;\n}\n",".preview-box {\n  & .buttons {\n    display: flex;\n    flex-flow: row nowrap;\n    justify-content: space-between;\n    margin-bottom: 0.5rem;\n    align-items: center;\n    \n  }\n\n  & .preview-box__container {\n    @include flex-row-center;\n    background-color: $color-back-frames;\n    padding: 0.8em 0 0.8em 0;\n    margin: 0.8em 0;\n    align-items: center;\n  }\n\n  .play {\n    @include button(gray);\n    @include icon(play);\n  }\n\n  .pause {\n    @include button(brown);\n    @include icon(pause);\n  }\n\n  .screen-full {\n    @include button(gray);\n    @include icon(screen-full);\n  }\n\n  .screen-normal {\n    @include button(gray);\n    @include icon(screen-normal);\n  }\n\n  .cross-stitch {\n    @include button(gray);\n    height: 36px;\n    img {\n      height: 18px;\n      width: 16px;\n      vertical-align: top;\n    }\n  }\n\n  .square {\n    padding-left: 0!important;\n    /* use before to render a square with color #bbb */\n    &:before {\n      content: '';\n      display: block;\n      width: 16px;\n      height: 16px;\n      background-color: #bbb;\n      \n    }\n  }\n\n  .preview-button-group{\n    display:flex;\n    flex-direction:row;\n    /* give second div padding-left 0.4 */\n    & > div:nth-child(2) {\n      padding-left: 0.4rem;\n    }\n  }\n\n  .frames {\n    @include button(gray);\n    @include icon(frames);\n  }\n}\n.cross-stitch-container {\n  position: relative;\n  overflow: hidden; /* to make sure the rotated divs don't overflow */\n}\n\n.cross-stitch-diagonal {\n  width: 1px; /* thickness of the stitch */\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform-origin: 50% 50%;\n}","@mixin flex-row-center {\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: center;\n}\n",".import-your-own{\n    display:flex;\n    height:100px;\n    width:100%;\n    border: 1px dashed #bbb;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 20px;\n    cursor: pointer;\n    background-color: #313131;\n    border-radius: 8px;\n    color: #bbb;\n    font-size: 12px;\n    padding: 20px 20px;\n    /* disable text highlighting */\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -khtml-user-select: none; /* Konqueror HTML */\n    -moz-user-select: none; /* Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none; /* Non-prefixed version, currently supported by Chrome, Opera and Firefox */\n\n    p{\n        margin: 0;\n        padding-left: 10px;\n    }\n}\n\n.import-your-own:hover{\n    border: 1px dashed #9b9b9b;\n}\n\n.image-upload-icon{\n    width: 24px;\n    height: 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
